import * as i0 from '@angular/core';
import { Injectable, Component, Inject, Pipe, ViewEncapsulation, Input, ViewChild, ViewChildren, NgModule } from '@angular/core';
import { BehaviorSubject, Subject, throwError, forkJoin } from 'rxjs';
import { map, pluck, catchError, take, takeUntil } from 'rxjs/operators';
import { saveAs } from 'file-saver';
import * as i8 from '@angular/forms';
import { Validators, FormControl, NgModel, ReactiveFormsModule, FormsModule } from '@angular/forms';
import * as i1 from '@angular/common/http';
import * as i2 from 'web-storage';
import * as RolesRouteMap from 'app-models';
import { TravelHistory, acceptedFileTypes, VisaMeta, VisaDetails } from 'app-models';
import * as moment from 'moment';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import * as i14 from '@angular/material/table';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { trigger, state, style, transition, animate } from '@angular/animations';
import * as errorUtils from 'error-message-utility';
import * as i1$1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MarkCleanFormAction, MarkDirtyFormAction } from 'dirty-check-store';
import * as i2$1 from '@ngrx/store';
import { environment } from 'environment-configurations';
import * as i13 from 'custom-questionnaire';
import { CustomQuestionnaireComponent, CustomQuestionnaireModule } from 'custom-questionnaire';
import * as i1$2 from 'cache-country-list';
import * as i2$2 from 'reference-library';
import * as i4 from 'ngx-toastr';
import * as i6 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i9 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i10 from '@angular/material/tabs';
import { MatTabsModule } from '@angular/material/tabs';
import * as i11 from '@angular/material/radio';
import { MatRadioModule } from '@angular/material/radio';
import * as i12 from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import * as i15 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i16 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as i17 from 'file-download-library';
import { FileDownloadLibraryModule } from 'file-download-library';
import * as i18 from '@angular/material/divider';
import { MatDividerModule } from '@angular/material/divider';
import * as i19 from 'primeng/dropdown';
import * as i20 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i21 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i22 from '@angular/material/datepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import * as i23 from 'primeng/calendar';
import * as i24 from 'file-upload-deafult-library';
import { FileUploadDeafultLibraryModule } from 'file-upload-deafult-library';
import { PrimengLibraryModule } from 'primeng-library';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import { NotificationComponentLibraryModule } from 'notification-component-library';
import { SendBackComponentLibraryModule } from 'send-back-component-library';
import { DeleteDialogLibraryModule } from 'delete-dialog-library';
import { FileUploadLibraryModule } from 'file-upload-library';
import { LastUpdateLibraryModule } from 'last-update-library';
import { AssigningTaskLibraryModule } from 'assigning-task-library';
import { MaximizeDialogLibraryModule } from 'maximize-dialog-library';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCardModule } from '@angular/material/card';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatNativeDateModule } from '@angular/material/core';
import { MatStepperModule } from '@angular/material/stepper';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectModule } from '@angular/material/select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatChipsModule } from '@angular/material/chips';
import { SaveAsDraftModule } from 'save-as-draft';

class GenericBeneficiaryImmigrationDetailsLibraryService {
    constructor(http, webStorage) {
        this.http = http;
        this.webStorage = webStorage;
        this.isExpired = false;
        // IM-3066 - remove deleted file.
        this.deletedfile$ = new BehaviorSubject({});
        this.showBeneficiary = new BehaviorSubject(false);
        this.dependentProfileSubject = new BehaviorSubject({});
        this.onLifeStorySubTabs = new Subject();
        this.selfBeneficiaryDetailChange = new Subject();
        this.newSubDependentCreated = new Subject();
        this.currentUserSubject = new BehaviorSubject(this.webStorage.getWebStorageItem('currentUser'));
        this.currentUser = this.currentUserSubject.asObservable();
    }
    get currentUserValue() {
        return this.currentUserSubject.value;
    }
    checkValidity() {
        return this.isExpired; /////
    }
    checkBeneEditPermission() {
        const permission = JSON.parse(sessionStorage.getItem('currentUser'));
        return permission ? permission['permissions'].length > 0 && permission['permissions'].find(x => x === 'EDIT_BENEFICIARY') ? true : false : false;
        // return permission['permissions'].length>0 && permission['permissions'].find(x=> x === 'DELETE_BENEFICIARY')? true : false;
    }
    dynamicRequiredValidator(formName, visaType, fieldNames) {
        fieldNames.addRequiredValidator.forEach(field => {
            const fieldName = field;
            if (fieldName) {
                fieldName.setValidators([Validators.required]);
                fieldName.updateValueAndValidity();
            }
        });
        fieldNames.removeAllValidator.forEach(field => {
            const fieldName = field;
            if (fieldName) {
                fieldName.clearValidators();
                fieldName.updateValueAndValidity();
            }
        });
    }
    genericGetUploadDocument(useCase, useCaseId, categoryName, entityId, useEntityId, familyId) {
        const entityUrlString = (useEntityId) ? `/entity/${entityId}` : '';
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.get(`/document/${useCase}/${useCaseId}/category/${categoryName}${entityUrlString}${profileFamilyString}`).pipe(map((response) => {
            if (response.status === 200) {
                response.data = response.data.filter(x => x.fileLocation !== null);
                return response;
            }
            return response;
        }));
    }
    changeDependentProfileID(dependentId, beneficiaryType) {
        this.dependentProfileSubject.next({ dependentId: dependentId, beneficiaryType: beneficiaryType });
    }
    getClientsList(companyId) {
        return this.http.get(`/company/${companyId}/addBeneficiaryByPetitioner`).pipe(map((response) => {
            return response.status === 200 ? response.data : [];
        }));
    }
    getCombinedVisas() {
        return this.http.get(`/task/getAllVisaTypeForBene`).pipe(map((response) => {
            return response.status === 200 ? response.data : [];
        }));
    }
    saveTrainingDetails(beneficiaryId, type, payload, familyId) {
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.post(`/beneficiary/${beneficiaryId}/profile/professional/${type}${profileFamilyString}`, payload).pipe(map((response) => response));
    }
    markComplete(payload, benenficiaryId, companyId) {
        return this.http.post(`/attor/markComplete?benenficiaryId=${benenficiaryId}&companyId=${companyId}`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    getTrainingsDetails(beneficiaryId, type, familyId) {
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.get(`/beneficiary/${beneficiaryId}/profile/professional/${type}${profileFamilyString}`).pipe(map((response) => response.data));
    }
    deleteTrainingsDetails(beneficiaryId, type, professionalId, familyId) {
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.delete(`/beneficiary/${beneficiaryId}/profile/professional/${professionalId}/${type}${profileFamilyString}`).pipe(map((response) => {
            // IM-3066 - remove deleted file.
            this.deletefile(beneficiaryId);
            return response;
        }));
    }
    // Immigration Fmaily
    saveImmgFamilyDetails(beneficiaryId, payload) {
        return this.http.post(`/beneficiary/${beneficiaryId}/immigration/family`, payload).pipe(map((response) => response));
    }
    getImmgFamilyDetails(beneficiaryId) {
        return this.http.get(`/beneficiary/${beneficiaryId}/immigration/family`).pipe(map((response) => response.data));
    }
    deleteImmgFamilyDetails(beneficiaryId, familyId) {
        return this.http.delete(`/beneficiary/${beneficiaryId}/immigration/family/${familyId}`).pipe(map((data) => {
            // IM-3066 - remove deleted file.
            this.deletefile(beneficiaryId);
            return data;
        }));
    }
    saveBeneficiaryDetails(beneficiaryId, type, payload, familyId) {
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.post(`/beneficiary/${beneficiaryId}/profile/${type}${profileFamilyString}`, payload).pipe(map((response) => response));
    }
    saveSimpleBeneficiaryDetails(beneficiaryId, type, payload, familyId) {
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.post(`/beneficiary/${beneficiaryId}/profile/${type}?isSimplifiedProfile=true${profileFamilyString}`, payload).pipe(map((response) => response));
    }
    saveEmployeeFB(payload) {
        return this.http.post(`/vd/formBuilder/invite/employee`, payload).pipe(map((response) => response));
    }
    getBeneficiaryDetails(beneficiaryId, type, familyId) {
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.get(`/beneficiary/${beneficiaryId}/profile/${type}${profileFamilyString}`).pipe(map((response) => response.data));
    }
    getEmployeeFBDetails(moduleId, pageFormId, companyId, beneficiaryId) {
        return this.http.get(`/vd/formBuilder/module/${moduleId}/pageForm/${pageFormId}/company/${companyId}/beneficiary/${beneficiaryId}/employee
    `).pipe(map((response) => response.data));
    }
    getFBEmployeeDetails(fbEmployeeId) {
        return this.http.get(`/vd/formBuilder/fbInviteEmployee/${fbEmployeeId}/employee`).pipe(map((response) => response.data));
    }
    getBeneficiaryFamilyDetails(beneficiaryId, type) {
        return this.http.get(`/beneficiary/${beneficiaryId}/profile/${type}`).pipe(map((response) => response.data));
    }
    saveBeneficiaryFamilyDetails(beneficiaryId, type, payload) {
        return this.http.post(`/beneficiary/${beneficiaryId}/profile/${type}`, payload).pipe(map((response) => response));
    }
    getFamilyDocumentsList(beneficiaryId, familyId) {
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.get(`/beneficiary/${beneficiaryId}/profile/documents${profileFamilyString}`).pipe(map((response) => response));
    }
    getBeneficiaries(companyId) {
        return this.http.get('/company/beneficiaries/company/' + companyId).pipe(pluck('data'), map((benes) => {
            benes.forEach(item => {
                item.name = item.fName + ' ' + item.lName,
                    item.address = (item.address.length > 0) ? item.address[0].addressLine1 : '',
                    item.email = (item.emailContacts.length > 0) ? item.emailContacts[0].email : '',
                    item.phone = (item.phoneContacts.length > 0) ? item.phoneContacts[0].phoneNo : '';
            });
            return benes;
        }));
    }
    generateUserid(payload) {
        return this.http.post('/user/generate/userId', payload).pipe(map((response) => response.data));
    }
    sendExternalBeneficiaryInvite(payload) {
        return this.http.post('/petitioner/dashboard/external/beneficiaries/create', payload).pipe(map((response) => response));
    }
    updateCommunicationEmail(payload) {
        return this.http.post('/updateCommunicationEmail', payload).pipe(map((response) => response));
    }
    updateUserId(payload) {
        return this.http.post('/updateUserId', payload).pipe(map((response) => response));
    }
    updateModeOfCreation(payload) {
        return this.http.post('/updateModeOfCreation', payload).pipe(map((response) => response));
    }
    sendInviteToAttorneyCreatedBeneficiary(beneficiaryId, companyId) {
        return this.http.post(`/attorneySendInviteToBeneficiary/${beneficiaryId}/${companyId}`, {}).pipe(map((response) => response));
    }
    sendBeneficiaryInvite(payload) {
        return this.http.post('/petitioner/dashboard/beneficiaries/create/', payload).pipe(map((response) => response));
    }
    sendBeneficiaryInviteByPetitioner(payload) {
        return this.http.post('/petitioner/dashboard/beneficiaries/create/', payload).pipe(map((response) => response));
    }
    // IM-3352 (IM-3335) user story
    resendBenificaryInvite(linkRequestId) {
        return this.http.post(`/linkRequest/${linkRequestId}/resend`, {}).pipe(map((response) => response));
    }
    sendInviteToClient(companyId, petitionerId) {
        return this.http.post(`/attorneySendInviteToPetitioner/${companyId}/${petitionerId}`, {}).pipe(map((response) => response));
    }
    withdrawanBenificaryInvite(linkRequestId) {
        return this.http.post(`/linkRequest/${linkRequestId}/withdraw`, {}).pipe(map((response) => response));
    }
    getBeneficiariesListForPetitioner(companyId, payload) {
        return this.http.post('/petitioner/dashboard/beneficiaries/company/' + companyId, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
            else {
                return null;
            }
        }));
    }
    getCategoryList() {
        return this.http.get('/referenceLibrary/TEMPLTCATGRY').pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
            else {
                return null;
            }
        }));
    }
    delinkBeneficiary(beneficiaryId, attorneyId) {
        return this.http.post(`/beneficiary/deLinkWithAttorney/${beneficiaryId}/${attorneyId}`, {}).pipe(map((response) => {
            return response.status === 200 ? response : null;
        }));
    }
    getBeneficiariesByCompanyId(companyId, payload) {
        return this.http.get(`/petitioner/dashboard/beneficiaries/company/associated/${companyId}/list`).pipe(
        // pluck('data'),
        // pluck('beneficiaryList'),
        // map((benes: Array<any>) => {
        //   benes.forEach(item => {
        //     item.firstname = item.beneficiaryEmployeeFName ? item.beneficiaryEmployeeFName : '',
        //       item.lastname = item.beneficiaryEmployeeLName ? item.beneficiaryEmployeeLName : '',
        //       item.middlename = item.beneficiaryEmployeeMName ? item.beneficiaryEmployeeMName : '-',
        //       item.company = (item.companyName) ? item.companyName : '';
        //   });
        //   return benes;
        // })
        map((response) => {
            if (response.status === 200 && response.data) {
                return response.data;
            }
            else {
                return [];
            }
        }));
    }
    saveBeneficiaryEducationByPetitioner(petitionId, type, payload) {
        return this.http.post(`/petitionBuilder/qualification/profile/${type}/petition/${petitionId}`, payload).pipe(map((response) => response));
    }
    saveBeneficiaryTrainingLicenseByPetitioner(petitionId, type, payload) {
        return this.http.post(`/petitionBuilder/qualification/profile/${petitionId}/professional/${type}/`, payload).pipe(map((response) => response));
    }
    saveBeneficiaryExperienceByPetitioner(petitionId, payload) {
        return this.http.post(`/petitionBuilder/workexperience/petition/${petitionId}`, payload).pipe(map((response) => response.data));
    }
    updateProfilePic(beneficiaryId, payload) {
        return this.http.post(`/beneficiary/${beneficiaryId}/profile/self/profileimage`, payload).pipe(map((response) => response));
    }
    updateFamilyProfilePic(beneficiaryId, familyId, payload) {
        return this.http.post(`/beneficiary/${beneficiaryId}/profile/family/${familyId}/profileimage`, payload).pipe(map((response) => response));
    }
    getStates(countryCode) {
        return this.http.get(`/countries/states?countryCode=${countryCode}`).pipe(map((response) => {
            if (response.status) {
                return response.data;
            }
        }));
    }
    saveBeneficiaryCurrentImmigration(beneficiaryId, payload) {
        return this.http.post(`/beneficiary/${beneficiaryId}/immigration/self/current`, payload).pipe(map((response) => response));
    }
    getBeneficiaryCurrentImmigration(beneficiaryId) {
        return this.http.get(`/beneficiary/${beneficiaryId}/immigration/self/current`).pipe(map((response) => response));
    }
    getBeneficiarysTasks(beneficiaryId) {
        return this.http.get(`/beneficiary/${beneficiaryId}/task`).pipe(map((response) => response));
    }
    getPastImmigrationDetails(beneficiaryId) {
        return this.http.get(`/beneficiary/${beneficiaryId}/immigration/self/past`).pipe(map((response) => response));
    }
    savePastImmigrationDetails(beneficiaryId, payload) {
        return this.http.post(`/beneficiary/${beneficiaryId}/immigration/self/past`, payload).pipe(map((response) => response));
    }
    deleteBeneExperience(beneficiaryId, experienceId, familyId) {
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.delete(`/beneficiary/${beneficiaryId}/profile/experience/${experienceId}${profileFamilyString}`).pipe(map((data) => {
            // IM-3066 - remove deleted file.
            this.deletefile(beneficiaryId);
            return data;
        }));
    }
    saveGroundsOfExclusion(beneficiaryId, payload) {
        return this.http.post(`/beneficiary/${beneficiaryId}/immigration/self/exclusion`, payload).pipe(map((data) => data));
    }
    getQuestionsForBeneficiary(groupCode, beneficiaryId) {
        return this.http.get(`/question/category/${groupCode}/beneficiary/${beneficiaryId}`).pipe(map((response) => {
            return response.data;
        }));
    }
    getGroundsOfExclusion(beneficiaryId) {
        return this.http.get(`/beneficiary/${beneficiaryId}/immigration/self/exclusion`).pipe(map((data) => data));
    }
    // Beneficiary education detials
    getEducationDetails(beneficiaryId, familyId) {
        const url = familyId ? `/beneficiary/${beneficiaryId}/profile/education?familyId=${familyId}` : `/beneficiary/${beneficiaryId}/profile/education`;
        // console.log('url', url);
        return this.http.get(url).pipe(map((data) => data));
    }
    getDocumentsList(beneficiaryId) {
        return this.http.get(`/beneficiary/${beneficiaryId}/profile/documents`).pipe(map((response) => response));
    }
    saveEducatinDegreeDetails(beneficiaryId, payload, familyId) {
        const url = familyId ? `/beneficiary/${beneficiaryId}/profile/education?familyId=${familyId}` : `/beneficiary/${beneficiaryId}/profile/education`;
        return this.http.post(url, payload).pipe(map((response) => response));
    }
    deleteEducatinDegreeDetails(beneficiaryId, educationId, familyId) {
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.delete(`/beneficiary/${beneficiaryId}/profile/education/${educationId}${profileFamilyString}`).pipe(map((data) => {
            // IM-3066 - remove deleted file.
            this.deletefile(beneficiaryId);
            return data;
        }));
    }
    addCurrentImmigrationDetails(beneficiaryId, payload) {
        return this.http.post(`/beneficiary/${beneficiaryId}/immigration/self/current`, payload).pipe(map((response) => response, catchError(this.errorHandler)));
    }
    addPastImmigrationDetails(beneficiaryId, payload) {
        return this.http.post(`/beneficiary/${beneficiaryId}/immigration/self/past`, payload).pipe(map((response) => response, catchError(this.errorHandler)));
    }
    errorHandler(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            errorMessage = error.error.message;
        }
        else {
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        return throwError(errorMessage);
    }
    saveVisaMetaInfo(beneficiaryId, payload, familyId) {
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.post(`/beneficiary/${beneficiaryId}/immigration/meta/self${profileFamilyString}`, payload).pipe(map((response) => {
            if (response.status && response.status === 200) {
                return response;
            }
        }));
    }
    saveVisaDetailsInfo(beneficiaryId, payload, familyId) {
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.post(`/beneficiary/${beneficiaryId}/immigration/self${profileFamilyString}`, payload).pipe(map((response) => {
            if (response.status && response.status === 200) {
                return response;
            }
        }));
    }
    getVisaDetails(beneficiaryId, familyId) {
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.get(`/beneficiary/${beneficiaryId}/immigration/self${profileFamilyString}`).pipe(map((response) => response));
    }
    getVisaMetaInfo(beneficiaryId, familyId) {
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.get(`/beneficiary/${beneficiaryId}/immigration/meta/self${profileFamilyString}`).pipe(map((response) => response));
    }
    saveTravelHistory(beneficiaryId, immigrationId, payload, familyId) {
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.post(`/beneficiary/${beneficiaryId}/immigration/${immigrationId}/travelInfo${profileFamilyString}`, payload).pipe(map((response) => response, catchError(this.errorHandler)));
    }
    getTravelHistory(beneficiaryId, immigrationId, familyId) {
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.get(`/beneficiary/${beneficiaryId}/immigration/${immigrationId}/travelInfo`).pipe(map((response) => {
            // IM-3066 - remove deleted file.
            this.deletefile(beneficiaryId);
            return response;
        }));
    }
    deleteImmigration(beneficiaryId, immigrationId, familyId) {
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.delete(`/beneficiary/${beneficiaryId}/immigration/${immigrationId}${profileFamilyString}`).pipe(map((response) => {
            // IM-3066 - remove deleted file.
            this.deletefile(beneficiaryId);
            return response;
        }));
    }
    deleteTravelInfo(beneficiaryId, immigrationId, travelInfoId) {
        return this.http.delete(`/beneficiary/${beneficiaryId}/immigration/${immigrationId}/travelInfo/${travelInfoId}`).pipe(map((response) => {
            // IM-3066 - remove deleted file.
            this.deletefile(beneficiaryId);
            return response;
        }));
    }
    // IM-3066 - remove deleted file.
    deletefile(beneficiaryId) {
        this.deletedfile$.next(true);
    }
    getSignatureImageBen(beneficiaryId) {
        return this.http.get(`/beneficiary/${beneficiaryId}/profile/signpic`).pipe(map((data) => {
            // console.log('from servpicget', data);
            return data;
        }));
    }
    getFamilySignatureImageBen(beneficiaryId, familyId) {
        return this.http.get(`/beneficiary/${beneficiaryId}/profile/family/${familyId}/signpic`).pipe(map((data) => {
            // console.log('from servpicget', data);
            return data;
        }));
    }
    // for benificiary sign Upload
    postSignatureImageBen(beneficiaryId, payload) {
        // console.log('post data', payload);
        return this.http.post(`/beneficiary/${beneficiaryId}/profile/signpic`, payload).pipe(map((data) => {
            // console.log('from servpicpost', data);
            return data;
        }));
    }
    // for benificiary sign Upload for family
    postFamilySignatureImageBen(beneficiaryId, familyId, payload) {
        // console.log('post data', payload);
        return this.http.post(`/beneficiary/${beneficiaryId}/profile/family/${familyId}/signPic`, payload).pipe(map((data) => {
            // console.log('from servpicpost', data);
            return data;
        }));
    }
    getBenficiaryLists(payload) {
        return this.http.post(`/beneficiaries/list`, payload).pipe(map((response) => {
            return response.status === 200 ? response.data : [];
        }));
    }
    // deleteFileFromDocumentList(){
    // }
    deleteFileFromDocumentList(beneficiaryId, catagoryGroup, catagoryCode, fileId) {
        return this.http.delete(`/document/beneficiary/${beneficiaryId}/category/${catagoryGroup}/fileCategory/${catagoryCode}/${fileId}`).pipe(map((data) => {
            // IM-3066 - remove deleted file.
            this.deletefile(beneficiaryId);
            return data;
        }));
    }
    // Inviting beneficiary through attorney login
    sendBeneficiaryConnectionInvite(attorneyId, beneficiaryId, payload) {
        return this.http.post(`/beneficiary/link/${attorneyId}/${beneficiaryId}`, payload).pipe(map((response) => {
            if (response.status && response.status === 200) {
                return response;
            }
            else {
                return null;
            }
        }));
    }
    // Attorney Beneficiary Connection Status
    getAttorneyBeneficiaryConnectionStatus(attorneyId, beneficiaryId) {
        return this.http.get(`/beneficiary/link/${attorneyId}/${beneficiaryId}`).pipe(map((response) => {
            if (response.status && response.status === 200) {
                return response;
            }
        }));
    }
    getPetitionerBeneficiaryConnectionStatus(attorneyId, beneficiaryId) {
        return this.http.get(`/petitioner/beneficiary/link/${attorneyId}/${beneficiaryId}`).pipe(map((response) => {
            if (response.status && response.status === 200) {
                return response;
            }
        }));
    }
    attorneyCreateBeneficiary(payload) {
        return this.http.post(`/attorney/beneficiary/create`, payload).pipe(map((response) => response, catchError(this.errorHandler)));
    }
    petitionerCreateBeneficiary(payload) {
        return this.http.post(`/attorney/beneficiary/create`, payload).pipe(map((response) => response, catchError(this.errorHandler)));
    }
    getBeneficiariesListForAttorney(companyId, payload) {
        return this.http.post(`/attorney/${companyId}/beneficiaries/list`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
            else {
                return null;
            }
        }));
    }
    getUndocImmigrantListForPetitioner(companyId, payload) {
        return this.http.post(`/lp/undocImmigrants/${companyId}`, payload).pipe(map((response) => {
            if (response.status && response.status === 200) {
                return response['data'];
            }
        }));
    }
    sendNotification(payload) {
        return this.http.post(`/mail/beneficiary`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    getRequestDataDocuments(data) {
        // beneficiaryId=1&companyId=1&immigrationType=asd&petitionType=asd&taskType=ww&visaType=ss
        let tempData;
        if (data.immigrationType === 'VISA') {
            tempData = `beneficiaryId=${data.beneficiaryId}&companyId=${data.companyId}&immigrationType=${data.immigrationType}&petitionType=${data.petitionType}&taskType=${data.taskType}&visaType=${data.visaType}`;
        }
        else {
            tempData = `beneficiaryId=${data.beneficiaryId}&companyId=${data.companyId}&immigrationCategory=${data.immigrationCategory}&immigrationClassfication=${data.immigrationClassfication}&taskType=${data.taskType}`;
        }
        if (data.taskTypeId) {
            tempData = `${tempData}&taskTypeId=${data.taskTypeId}`;
        }
        else {
            tempData = `${tempData}`;
        }
        return this.http.get(`/attrorpetnr/qdisplaySections?${tempData}`).pipe(map((response) => response.data));
    }
    getQuestionnaireRequestDataDocuments(data, isCaseRequestSatus, isBeneficiaryQuestionnaireStatus) {
        // beneficiaryId=1&companyId=1&immigrationType=asd&petitionType=asd&taskType=ww&visaType=ss
        let tempData;
        if (data.immigrationType === 'VISA') {
            if (isCaseRequestSatus || isBeneficiaryQuestionnaireStatus) {
                tempData = `companyId=${data.companyId}&immigrationType=${data.immigrationType}&petitionType=${data.petitionType}&taskType=${data.taskType}&visaType=${data.visaType}`;
            }
            else {
                tempData = `beneficiaryId=${data.beneficiaryId}&companyId=${data.companyId}&immigrationType=${data.immigrationType}&petitionType=${data.petitionType}&taskType=${data.taskType}&visaType=${data.visaType}`;
                if (data === null || data === void 0 ? void 0 : data.version) {
                    tempData += `&version=${data.version}`;
                }
            }
        }
        else {
            if (isCaseRequestSatus || isBeneficiaryQuestionnaireStatus) {
                tempData = `companyId=${data.companyId}&immigrationCategory=${data.immigrationCategory}&immigrationClassfication=${data.immigrationClassfication}&taskType=${data.taskType}`;
            }
            else {
                tempData = `beneficiaryId=${data.beneficiaryId}&companyId=${data.companyId}&immigrationCategory=${data.immigrationCategory}&immigrationClassfication=${data.immigrationClassfication}&taskType=${data.taskType}`;
            }
        }
        if (data.taskTypeId) {
            tempData = `${tempData}&taskTypeId=${data.taskTypeId}`;
        }
        else {
            tempData = `${tempData}`;
        }
        if (isCaseRequestSatus) {
            return this.http.get(`/platformadmin/displaySections?${tempData}&isCaseRequestInitiated=true&isUsedForBenQuestionnaryLibrary=false`).pipe(map((response) => response.data));
        }
        else if (isBeneficiaryQuestionnaireStatus) {
            return this.http.get(`/platformadmin/displaySections?${tempData}&isCaseRequestInitiated=false&isUsedForBenQuestionnaryLibrary=true`).pipe(map((response) => response.data));
        }
        else {
            return this.http.get(`/attrorpetnr/qdisplaySections?${tempData}`).pipe(map((response) => response.data));
        }
    }
    getAccessCodeAndLinkForBeneficiary(id) {
        return this.http.get(`/attor/getAccessCodeAndLinkForBeneficiary/${id}`).pipe(map((response) => response.data));
    }
    getPlatformDisplaySection(data) {
        // beneficiaryId=1&companyId=1&immigrationType=asd&petitionType=asd&taskType=ww&visaType=ss
        let tempData;
        if (data.immigrationType === 'VISA') {
            tempData = `immigrationType=${data.immigrationType}&petitionType=${data.petitionType}&taskType=${data.taskType}&visaType=${data.visaType}`;
        }
        else {
            tempData = `immigrationType=${data.immigrationType}&immigrationCategory=${data.immigrationCategory}&immigrationClassfication=${data.immigrationClassfication}&taskType=${data.taskType}`;
        }
        return this.http.get(`/platformadmin/displaySections?${tempData}`).pipe(map((response) => response.data));
    }
    saveRequestDataDocuments(reqLoad, payLoad) {
        return this.http.post(`/attor/saveQtsections?benenficiaryId=${reqLoad.beneficiaryId}&companyId=${reqLoad.companyId}`, payLoad).pipe(map((response) => response));
    }
    saveCaseRequestDataDocuments(reqLoad, payLoad, isCaseRequestSatus, isBeneficiaryQuestionnaireStatus) {
        let dynamicUrl;
        if (isCaseRequestSatus) {
            dynamicUrl = `/attor/saveQtsections?companyId=${reqLoad.companyId}&isCaseRequestInitiated=true&isUsedForBenQuestionnaryLibrary=false`;
        }
        else if (isBeneficiaryQuestionnaireStatus) {
            dynamicUrl = `/attor/saveQtsections?companyId=${reqLoad.companyId}&isCaseRequestInitiated=false&isUsedForBenQuestionnaryLibrary=true`;
        }
        return this.http.post(dynamicUrl, payLoad).pipe(map((response) => response));
    }
    // Call new api by Rahul
    saveRequestDataDocumentsAttorney(reqLoad, payLoad, externalEmployeeId) {
        return this.http.post(`/petnr/sendDataAndDocument/extrnalAttorney?benenficiaryId=${reqLoad.beneficiaryId}&companyId=${reqLoad.companyId}&externalEmployeeId=${externalEmployeeId}`, payLoad).pipe(map((response) => response));
    }
    saveQuestionnairePlatformAdmin(reqLoad, payLoad) {
        return this.http.post(`/platformadmin/saveQtsections`, payLoad).pipe(map((response) => {
            if (response.status && response.status === 200) {
                return response['data'];
            }
        }));
    }
    getTaskFordisplay(data) {
        return this.http.post(`/getTaskFordisplaySection`, data).pipe(map((response) => response.data));
    }
    getRequiredDocuments(data) {
        // let path = `/documentChecklist/${data.visaType}/${data.taskType}/${data.caseId}`;
        // let path = `/documentChecklist/${data.visaType}/${data.taskType}/${data.taskId}`;
        let path = `/documentChecklist/${data.visaType}/${data.taskType}/${data.petitioncaseId}`;
        return this.http.get(path).pipe(map((response) => {
            //if (response.status === 200) {
            return response; // send  full data
            //}
        }));
    }
    getTask(visaType, taskId) {
        return this.http.get(`/${visaType}/task/${taskId}`).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    // getCustomQuestionsDetailView(companyId, taskId) {
    //   return this.http.get(`/getCustomQuestionnaryDetails/company/${companyId}?taskTypeId=${taskId}`).pipe(
    //       map((response: ImagilityBaseResponse) => {
    //           if (response.status === 200) {
    //               return response;
    //           }
    //       })
    //   );
    // }
    getCustomQuestionsDetails(payload) {
        return this.http.get(`/getCustomJson/${payload.companyId}/${payload.beneficiaryId}?taskTypeId=${payload.taskTypeId}`).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    getQuestionnaireCustomQuestionsDetails(payload, isCaseRequestSatus, isBeneficiaryQuestionnaireStatus) {
        let customUrl;
        if (isCaseRequestSatus) {
            // customUrl = `/getCustomQuestionnaryDetails/company/${payload.companyId}?isUsedForPetition=false&taskTypeId=${payload.taskTypeId}`
            customUrl = `/getCustomJson/${payload.companyId}/0?taskTypeId=${payload.taskTypeId}&isCaseRequestInitiated=true&isUsedForBenQuestionnaryLibrary=false`;
        }
        else if (isBeneficiaryQuestionnaireStatus) {
            customUrl = `/getCustomJson/${payload.companyId}/0?taskTypeId=${payload.taskTypeId}&isCaseRequestInitiated=false&isUsedForBenQuestionnaryLibrary=true`;
        }
        else {
            customUrl = `/getCustomJson/${payload.companyId}/${payload.beneficiaryId}?taskTypeId=${payload.taskTypeId}`;
        }
        return this.http.get(customUrl).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    saveCustomQuestions(data, payLoad) {
        return this.http.post(`/saveCustomQuestionnary/${data}`, payLoad).pipe(map((response) => response));
    }
    saveEmployeeJobDetails(payLoad) {
        return this.http.post(`/vd/formBuilder/create/fbEmployee/jobSummary`, payLoad).pipe(map((response) => response));
    }
    getEmployeeJobDetails(beneficaryId) {
        return this.http.get(`/vd/formBuilder/get/fbEmployee/jobSummary/${beneficaryId}`).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    getCompanyList_ddl(companyId) {
        return this.http.get(`/company/${companyId}/heierachy`).pipe(pluck('data'), map((data) => {
            return data;
        }));
    }
    getEmployeeList_ddl(companyId) {
        return this.http.get(`/vd/formBuilder/get/fbEmployeeList/company/${companyId}`).pipe(pluck('data'), map((data) => {
            return data;
        }));
    }
    getHrEmployeeList_ddl(companyId) {
        return this.http.get(`/vd/formBuilder/get/hrAdmin/company/${companyId}`).pipe(pluck('data'), map((data) => {
            return data;
        }));
    }
    getRmEmployeeList_ddl(companyId) {
        return this.http.get(`/vd/formBuilder/get/reportingManager/company/${companyId}`).pipe(pluck('data'), map((data) => {
            return data;
        }));
    }
    getDepartmentList_ddl(companyId) {
        return this.http.get(`/vd/formBuilder/get/fbDepartmentList/company/${companyId}`).pipe(pluck('data'), map((data) => {
            return data;
        }));
    }
    getShiftList_ddl(departmentId) {
        return this.http.get(`/vd/formBuilder/get/fbShiftList/department/${departmentId}`).pipe(pluck('data'), map((data) => {
            return data;
        }));
    }
    /* Bank Details Apis */
    getBankDetails(bankId, type) {
        return this.http.get(`/formBuilder/employee/bankView/${bankId}`).pipe(map((response) => response.data));
    }
    saveBankDetails(payload) {
        return this.http.post(`/formBuilder/employee/bankDetails`, payload).pipe(map((response) => response));
    }
    deleteBankFileFromDocumentList(Id) {
        return this.http.delete(`/formBuilder/delete/bankDetailsDocument/${Id}`).pipe(map((data) => {
            this.deletefile(Id);
            return data;
        }));
    }
    /* W4 Details Apis */
    getW4Details(empId, type) {
        return this.http.get(`/formBuilder/employee/w4Details/view/${empId}`).pipe(map((response) => response.data));
    }
    saveW4Details(payload) {
        return this.http.post(`/formBuilder/employee/w4details/createorupdate`, payload).pipe(map((response) => response));
    }
    deleteW4FileFromDocumentList(empId, categoryName, fileCategory) {
        return this.http.delete(`/formBuilder/employee/w4Details/delete/${empId}/category/${categoryName}/fileCategory/${fileCategory}`).pipe(map((data) => {
            this.deletefile(empId);
            return data;
        }));
    }
    /* Form16 Details Apis */
    getForm16Details(empId, type) {
        return this.http.get(`/formBuilder/employee/form16details/view/${empId}`).pipe(map((response) => response.data));
    }
    saveForm16Details(payload) {
        return this.http.post(`/formBuilder/employee/form16details/createorupdate`, payload).pipe(map((response) => response));
    }
    deleteForm16FileFromDocumentList(empId) {
        return this.http.delete(`/formBuilder/employee/form16details/delete/${empId}`).pipe(map((data) => {
            this.deletefile(empId);
            return data;
        }));
    }
    getYearsDataSourceList(dataSourceType) {
        return this.http.get(`/vd/dataSource/${dataSourceType}/elements`).pipe(pluck('data'), map((data) => {
            return data;
        }));
    }
    getMonthsDataSourceList(dataSourceType) {
        return this.http.get(`/vd/dataSource/${dataSourceType}/elements`).pipe(pluck('data'), map((data) => {
            return data;
        }));
    }
    getPayslipDetails(payload) {
        return this.http.post(`/vd/formBuilder/externalSystem/employee/paystub/details`, payload).pipe(map((response) => response));
    }
    getSalaryBreakupDetails(payload) {
        return this.http.post(`/vd/formBuilder/externalSystem/employee/payroll/details`, payload).pipe(map((response) => response));
    }
    getPayslipDownloadDetails(payload) {
        return this.http.post(`/vd/formBuilder/employee/payroll/payslip/details`, payload).pipe(map((response) => response));
    }
    downloadDocuments(path, fileName) {
        this.http.get(path, { responseType: "arraybuffer" })
            .pipe(take(1))
            .subscribe(pdf => {
            const blob = new Blob([pdf], { type: 'application/pdf' });
            saveAs(blob, fileName);
        });
    }
    // Employee Onboadring APIs
    getBeneficiariesListForApprovedPetitions(companyId, payload) {
        return this.http.post('/datamigration/listofbeneficiaries/' + companyId, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
            else {
                return null;
            }
        }));
    }
    migrateOrOnboardEmployees(companyId, payload) {
        return this.http.post('/datamigration/migrate/beneficiaries/' + companyId, payload).pipe(map((response) => response));
    }
    getPetitionDropdownList(beneficiaryId) {
        return this.http.get(`/beneficiary/${beneficiaryId}/petitions`).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
        }));
    }
    getTaskListForBeneficiary(beneficiaryId, payload) {
        return this.http.post(`/superTask/beneficiary/${beneficiaryId}`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
        }));
    }
    getCompanyListAssociatedToBene(beneficiaryId) {
        return this.http.get(`/beneficiary/${beneficiaryId}/petitioner`).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
        }));
    }
    // Immigration details component services
    getUsStayHistory(beneficiaryId, familyId) {
        let url;
        if (familyId) {
            url = `/beneficiary/${beneficiaryId}/immigration/self?familyId=${familyId}`;
        }
        else {
            url = `/beneficiary/${beneficiaryId}/immigration/self`;
        }
        return this.http.get(url).pipe(map((response) => response));
    }
    saveUsStayHostory(beneficiaryId, payload, familyId) {
        let url;
        if (familyId) {
            url = `/beneficiary/${beneficiaryId}/travelInfo?familyId=${familyId}`;
        }
        else {
            url = `/beneficiary/${beneficiaryId}/travelInfo`;
        }
        return this.http.post(url, payload).pipe(map((response) => {
            if (response.status && response.status === 200) {
                return response;
            }
        }));
    }
    saveNotes(beneficiaryId, payload) {
        return this.http.post(`/beneficiary/${beneficiaryId}/note/create`, payload).pipe(map((response) => {
            if (response.status && response.status === 200) {
                return response;
            }
        }));
    }
    updateNotes(postId, payload) {
        return this.http.post(`/note/${postId}/edit`, payload).pipe(map((response) => {
            if (response.status && response.status === 200) {
                return response;
            }
        }));
    }
    getAllNotes(beneficiaryId) {
        return this.http.get(`/beneficiary/${beneficiaryId}/notelist`).pipe(map((response) => response));
    }
    deleteNote(noteId) {
        return this.http.delete(`/beneficiary/note/${noteId}/delete`).pipe(map((response) => {
            return response;
        }));
    }
    deletePetitionNotes(noteId, customStep, timelineSteps, taskId) {
        let url = `/L1/task/${taskId}/note/${noteId}/delete?isCustomStep=${customStep}`;
        if (!timelineSteps) { // to delete the non step (genral notes)
            url = `/genNotes/L1/task/${taskId}/note/${noteId}/delete`;
        }
        return this.http.delete(url).pipe(map((response) => {
            return response;
        }));
    }
    getBeneficiaryLCA(beneficiaryId) {
        return this.http.get(`/dashboard/petitioner/lca/beneficiary/${beneficiaryId}/list/`).pipe(map((response) => response.data));
    }
    getBeneficiary(accessCode) {
        return this.http.get(`/admin/getQuestionaryByAccessToken/${accessCode}`).pipe(map((response) => {
            if (response.status) {
                return response;
            }
        }));
    }
    saveRecentActivity(payload) {
        return this.http.post(`/saveRecentWorkDetail`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    getBeneficiaryEConsentCompany(beneficiaryId, companyId) {
        return this.http.get(`/econsent/details/beneficiary/${beneficiaryId}?companyId=${companyId}`).pipe(map((response) => response));
    }
    getBeneficiaryEConsentLogin(beneficiaryId, isRequestFromLogin) {
        return this.http.get(`/econsent/details/beneficiary/${beneficiaryId}?isRequestFromLogin=${isRequestFromLogin}`).pipe(map((response) => response));
    }
    getBeneficiaryEConsentReqData(beneficiaryId, isRequestFromLogin, accessTokenCode) {
        return this.http.get(`/econsent/details/beneficiary/${beneficiaryId}?isRequestFromLogin=${isRequestFromLogin}&accessTokenCode=${accessTokenCode}`).pipe(map((response) => response));
    }
    getEconsentMessage(companyId) {
        return this.http.get(`/econsent/details/company/${companyId}`).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
        }));
    }
    saveEconsent(payload) {
        return this.http.post(`/beneficiary/econsent/details`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    getDependentList(beneficiaryId) {
        return this.http.get(`/vd/beneficiary/${beneficiaryId}/dependentDetails`).pipe(map(response => {
            return response['data'];
        }));
    }
}
GenericBeneficiaryImmigrationDetailsLibraryService.ɵfac = function GenericBeneficiaryImmigrationDetailsLibraryService_Factory(t) { return new (t || GenericBeneficiaryImmigrationDetailsLibraryService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ImagilityWebStorage)); };
GenericBeneficiaryImmigrationDetailsLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: GenericBeneficiaryImmigrationDetailsLibraryService, factory: GenericBeneficiaryImmigrationDetailsLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GenericBeneficiaryImmigrationDetailsLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: i2.ImagilityWebStorage }]; }, null); })();

class ConfirmationModalComponent {
    constructor(dialogRef, dialogData, store) {
        this.dialogRef = dialogRef;
        this.dialogData = dialogData;
        this.store = store;
        this.buttons = [];
        this.dialogRef.disableClose = true;
    }
    ngOnInit() {
        this.title = this.dialogData.update.title;
        this.message = this.dialogData.update.message;
        this.buttons = (this.dialogData.buttons) ? this.dialogData.buttons : ['No', 'Yes'];
    }
    onConfirm() {
        // Close the dialog, return true
        this.dialogRef.close(true);
        this.store.dispatch(new MarkCleanFormAction({
            dirty: false
        }));
    }
    onDismiss() {
        // Close the dialog, return false
        this.dialogRef.close(false);
    }
    handleNo() {
        this.dialogRef.close(false);
    }
}
ConfirmationModalComponent.ɵfac = function ConfirmationModalComponent_Factory(t) { return new (t || ConfirmationModalComponent)(i0.ɵɵdirectiveInject(i1$1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i2$1.Store)); };
ConfirmationModalComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ConfirmationModalComponent, selectors: [["app-confirmation-modal"]], decls: 16, vars: 4, consts: [["mat-dialog-title", ""], [1, "col-md-12", "p-0", "row", "delete-header"], ["id", "deleteHeader", 1, "col-md-10", "p-0", "common-bene-class-for-translation"], [1, "col-md-2", "p-0", "justify-content-end", "d-flex"], [1, "close-icon", "pi", "pi-times", 3, "click"], ["mat-dialog-content", "", 1, "message"], ["id", "contentMessage", 1, "common-bene-class-for-translation"], ["mat-dialog-actions", "", 1, "float-right"], ["mat-raised-button", "", "color", "primary", 1, "btnCustom", "mr-3", 3, "click"], ["id", "saveBtn", 1, "common-bene-class-for-translation"], ["mat-button", "", 1, "btnCustom", 3, "click"], ["id", "cancelBtn", 1, "common-bene-class-for-translation"]], template: function ConfirmationModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "h5", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵelementStart(5, "i", 4);
        i0.ɵɵlistener("click", function ConfirmationModalComponent_Template_i_click_5_listener() { return ctx.handleNo(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵelementStart(7, "p", 6);
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 7);
        i0.ɵɵelementStart(10, "button", 8);
        i0.ɵɵlistener("click", function ConfirmationModalComponent_Template_button_click_10_listener() { return ctx.onConfirm(); });
        i0.ɵɵelementStart(11, "span", 9);
        i0.ɵɵtext(12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "button", 10);
        i0.ɵɵlistener("click", function ConfirmationModalComponent_Template_button_click_13_listener() { return ctx.onDismiss(); });
        i0.ɵɵelementStart(14, "span", 11);
        i0.ɵɵtext(15);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.title, " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.message);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.buttons[1]);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.buttons[0]);
    } }, styles: ["h5[_ngcontent-%COMP%]{color:#475f7b}.message[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{padding:20px 0;margin-bottom:0;font-size:18px}button[_ngcontent-%COMP%]:last-child{margin-left:5px}.close-icon[_ngcontent-%COMP%]{color:#fff;background-color:#553b7c;padding:10px;border-radius:20px;cursor:pointer;font-size:10px}.delete-header[_ngcontent-%COMP%]{color:#01a0da;border-bottom:1px dashed #707070;font-size:22px;font-weight:600;text-align:left;padding:0 0 15px!important}.btnCustom[_ngcontent-%COMP%]{color:#fff;background:#2196f3;border:1px solid #2196f3;padding:.5rem 1rem;font-size:1rem;transition:background-color .2s,color .2s,border-color .2s,box-shadow .2s}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfirmationModalComponent, [{
        type: Component,
        args: [{
                selector: 'app-confirmation-modal',
                templateUrl: './confirmation-modal.component.html',
                styleUrls: ['./confirmation-modal.component.scss']
            }]
    }], function () { return [{ type: i1$1.MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }, { type: i2$1.Store }]; }, null); })();

class InfoModalComponent {
    constructor(dialogRef, dialogData) {
        this.dialogRef = dialogRef;
        this.dialogData = dialogData;
    }
    ngOnInit() {
        this.infoForWhichPage = this.dialogData.update.pageName;
    }
    onConfirm() {
        // Close the dialog, return true
        this.dialogRef.close(true);
    }
    handleClose() {
        // Close the dialog, return false
        this.dialogRef.close(false);
    }
}
InfoModalComponent.ɵfac = function InfoModalComponent_Factory(t) { return new (t || InfoModalComponent)(i0.ɵɵdirectiveInject(i1$1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
InfoModalComponent.ɵcmp = i0.ɵɵdefineComponent({ type: InfoModalComponent, selectors: [["app-info-modal"]], decls: 14, vars: 0, consts: [[1, "infoClass"], [1, "row", "headerColor", "pt-2"], [1, "col-md-11"], [1, "col-md-1"], [1, "row", "p-2"]], template: function InfoModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtext(3, "Select the following ");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(4, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵelementStart(6, "p");
        i0.ɵɵtext(7, "Start of stay on this Visa - Select if there is 'Change of status'");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "p");
        i0.ɵɵtext(9, "Arrival Date - Enter the day you have arrived in the U.S.");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "p");
        i0.ɵɵtext(11, "End of stay on this Visa - if you have switched the visa status select and enter");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "p");
        i0.ɵɵtext(13, "Departure Date - Enter the day you left the U.S");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } }, styles: [".infoClass[_ngcontent-%COMP%]{background-color:#626262!important;color:#fff;font-size:12px}.infoClass[_ngcontent-%COMP%]   .headerColor[_ngcontent-%COMP%]{background-color:#727272!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InfoModalComponent, [{
        type: Component,
        args: [{
                selector: 'app-info-modal',
                templateUrl: './info-modal.component.html',
                styleUrls: ['./info-modal.component.scss']
            }]
    }], function () { return [{ type: i1$1.MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, null); })();

class ImgDateFormatPipe {
    transform(value) {
        return (value ? moment(value).format('MM/DD/YYYY') : '');
    }
}
ImgDateFormatPipe.ɵfac = function ImgDateFormatPipe_Factory(t) { return new (t || ImgDateFormatPipe)(); };
ImgDateFormatPipe.ɵpipe = i0.ɵɵdefinePipe({ name: "ImgDateFormat", type: ImgDateFormatPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImgDateFormatPipe, [{
        type: Pipe,
        args: [{ name: 'ImgDateFormat' }]
    }], null, null); })();

const _c0 = ["visaDetailsForm"];
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵtext(1, "Immigration Details");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_div_8_label_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 24);
    i0.ɵɵtext(1, " Thank you for your response. You do not have to enter any further details. ");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_div_8_div_14_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelementStart(1, "div", 26);
    i0.ɵɵelementStart(2, "label", 27);
    i0.ɵɵtext(3, "Alien Registration Number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 28, 29);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_div_8_div_14_div_1_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(4); return ctx_r12.visaMeta.alienRegNo = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 30);
    i0.ɵɵelementStart(7, "mat-checkbox", 31);
    i0.ɵɵlistener("change", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_div_8_div_14_div_1_Template_mat_checkbox_change_7_listener() { i0.ɵɵrestoreView(_r13); const ctx_r14 = i0.ɵɵnextContext(4); return ctx_r14.updateAlienNo(); })("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_div_8_div_14_div_1_Template_mat_checkbox_ngModelChange_7_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r15 = i0.ɵɵnextContext(4); return ctx_r15.visaMeta.hasAlienRegnNo = $event; });
    i0.ɵɵelementStart(8, "span", 32);
    i0.ɵɵtext(9, "Not Applicable");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r10.visaMeta.alienRegNo)("disabled", ctx_r10.visaMeta.hasAlienRegnNo);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r10.visaMeta.hasAlienRegnNo);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_div_8_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_div_8_div_14_div_1_Template, 10, 3, "div", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.expandPanel);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_div_8_div_16_div_1_div_1_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "lib-custom-questionnaire", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isNewPortion", false)("viewQuestions", true)("loadedIn", "Immigration Details")("beneficiaryId", ctx_r21.beneficiaryId)("isSection", true)("familyId", ctx_r21.currentFamilyId);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_div_8_div_16_div_1_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_div_8_div_16_div_1_div_1_div_1_div_1_Template, 2, 6, "div", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r20 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (item_r20 == null ? null : item_r20.key) == "QTPROFILEBEN" && item_r20.selected == true);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_div_8_div_16_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_div_8_div_16_div_1_div_1_div_1_Template, 2, 1, "div", 34);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ques_r17 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ques_r17.stakeHoldersSelected);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_div_8_div_16_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_div_8_div_16_div_1_div_1_Template, 2, 1, "div", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ques_r17 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ques_r17.name == "Immigration Details");
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_div_8_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_div_8_div_16_div_1_Template, 2, 1, "div", 33);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r8.customQuestions == null ? null : ctx_r8.customQuestions.sectionList);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_div_8_div_17_div_1_div_1_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "lib-custom-questionnaire", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isNewPortion", false)("viewQuestions", true)("loadedIn", "Immigration Details")("beneficiaryId", ctx_r28.beneficiaryId)("isSection", true)("familyId", ctx_r28.currentFamilyId);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_div_8_div_17_div_1_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_div_8_div_17_div_1_div_1_div_1_div_1_Template, 2, 6, "div", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r27 = ctx.$implicit;
    const ctx_r26 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r26.selectedUser == null ? null : ctx_r26.selectedUser.dependentType == null ? null : ctx_r26.selectedUser.dependentType.code) == item_r27.key && item_r27.selected == true);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_div_8_div_17_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_div_8_div_17_div_1_div_1_div_1_Template, 2, 1, "div", 34);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ques_r24 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ques_r24.stakeHoldersSelected);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_div_8_div_17_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_div_8_div_17_div_1_div_1_Template, 2, 1, "div", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ques_r24 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ques_r24.name == "Immigration Details");
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_div_8_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_div_8_div_17_div_1_Template, 2, 1, "div", 33);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r9.customQuestions == null ? null : ctx_r9.customQuestions.sectionList);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 8);
    i0.ɵɵelementStart(2, "div", 9);
    i0.ɵɵelementStart(3, "p", 10);
    i0.ɵɵtext(4, "Have you ever applied for any US immigrant/non-immigrant visa?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "mat-radio-group", 11);
    i0.ɵɵlistener("change", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_div_8_Template_mat_radio_group_change_5_listener() { i0.ɵɵrestoreView(_r31); const ctx_r30 = i0.ɵɵnextContext(2); return ctx_r30.handleToggle(); })("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_div_8_Template_mat_radio_group_ngModelChange_5_listener($event) { i0.ɵɵrestoreView(_r31); const ctx_r32 = i0.ɵɵnextContext(2); return ctx_r32.neverAppliedFlag = $event; });
    i0.ɵɵelementStart(6, "mat-radio-button", 12);
    i0.ɵɵelementStart(7, "span", 13);
    i0.ɵɵtext(8, "Yes");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "mat-radio-button", 14);
    i0.ɵɵelementStart(10, "span", 15);
    i0.ɵɵtext(11, "No");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 16);
    i0.ɵɵtemplate(13, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_div_8_label_13_Template, 2, 0, "label", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_div_8_div_14_Template, 2, 1, "div", 0);
    i0.ɵɵelementStart(15, "div", 18);
    i0.ɵɵtemplate(16, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_div_8_div_16_Template, 2, 1, "div", 0);
    i0.ɵɵtemplate(17, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_div_8_div_17_Template, 2, 1, "div", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 19);
    i0.ɵɵelementStart(19, "button", 20);
    i0.ɵɵlistener("click", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_div_8_Template_button_click_19_listener() { i0.ɵɵrestoreView(_r31); i0.ɵɵnextContext(); const _r2 = i0.ɵɵreference(5); const ctx_r33 = i0.ɵɵnextContext(); return ctx_r33.saveVisaMetaInfo(_r2); });
    i0.ɵɵelementStart(20, "span", 21);
    i0.ɵɵtext(21, "Save");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "button", 22);
    i0.ɵɵlistener("click", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_div_8_Template_button_click_22_listener() { i0.ɵɵrestoreView(_r31); i0.ɵɵnextContext(); const _r2 = i0.ɵɵreference(5); const ctx_r34 = i0.ɵɵnextContext(); return ctx_r34.cancelVisaMetaInfo(_r2); });
    i0.ɵɵelementStart(23, "span", 23);
    i0.ɵɵtext(24, "Cancel");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngModel", ctx_r3.neverAppliedFlag);
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("ngIf", ctx_r3.neverAppliedFlag === "No");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.iscaseRequest ? ctx_r3.currentItemDisplay.includes("VISADTLS") ? true : false : true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.beneficiaryType == "self");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.beneficiaryType !== "self");
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 46);
    i0.ɵɵtext(1, "Visa Details");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_label_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 47);
    i0.ɵɵelementStart(1, "span", 48);
    i0.ɵɵtext(2, "No visa details have been added yet.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r43 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 49);
    i0.ɵɵlistener("click", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_button_4_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r43); const ctx_r42 = i0.ɵɵnextContext(3); ctx_r42.toggleExpansion(); ctx_r42.closeForm(ctx_r42.visaDetailsForm); return ctx_r42.visaFormCheck(ctx_r42.visaDetailsForm); });
    i0.ɵɵelementStart(1, "span", 50);
    i0.ɵɵtext(2, " ADD DETAILS ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_ng_container_5_th_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 65);
    i0.ɵɵelementStart(1, "span", 66);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r53 = i0.ɵɵnextContext();
    const indx_r50 = ctx_r53.index;
    const column_r49 = ctx_r53.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "colHeader6Lbl", indx_r50, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(column_r49.header);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_ng_container_5_td_2_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r60 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 70);
    i0.ɵɵelementStart(1, "mat-icon", 71);
    i0.ɵɵlistener("click", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_ng_container_5_td_2_span_1_Template_mat_icon_click_1_listener() { i0.ɵɵrestoreView(_r60); const ctx_r59 = i0.ɵɵnextContext(6); return ctx_r59.tabChange(); });
    i0.ɵɵtext(2, "expand_more");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_ng_container_5_td_2_div_2_ng_container_1_span_1_mat_icon_1_Template(rf, ctx) { if (rf & 1) {
    const _r67 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-icon", 76);
    i0.ɵɵlistener("click", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_ng_container_5_td_2_div_2_ng_container_1_span_1_mat_icon_1_Template_mat_icon_click_0_listener() { i0.ɵɵrestoreView(_r67); const row_r54 = i0.ɵɵnextContext(4).$implicit; const ctx_r65 = i0.ɵɵnextContext(5); ctx_r65.editImmigration(row_r54); return ctx_r65.visaFormCheck(ctx_r65.visaDetailsForm); });
    i0.ɵɵtext(1, " edit ");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_ng_container_5_td_2_div_2_ng_container_1_span_1_mat_icon_2_Template(rf, ctx) { if (rf & 1) {
    const _r70 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-icon", 77);
    i0.ɵɵlistener("click", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_ng_container_5_td_2_div_2_ng_container_1_span_1_mat_icon_2_Template_mat_icon_click_0_listener() { i0.ɵɵrestoreView(_r70); const row_r54 = i0.ɵɵnextContext(4).$implicit; const ctx_r68 = i0.ɵɵnextContext(5); return ctx_r68.deleteImmigration(row_r54); });
    i0.ɵɵtext(1, " delete_forever ");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_ng_container_5_td_2_div_2_ng_container_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 73);
    i0.ɵɵtemplate(1, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_ng_container_5_td_2_div_2_ng_container_1_span_1_mat_icon_1_Template, 2, 0, "mat-icon", 74);
    i0.ɵɵtemplate(2, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_ng_container_5_td_2_div_2_ng_container_1_span_1_mat_icon_2_Template, 2, 0, "mat-icon", 75);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r62 = i0.ɵɵnextContext(8);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r62.viewMode);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r62.viewMode);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_ng_container_5_td_2_div_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_ng_container_5_td_2_div_2_ng_container_1_span_1_Template, 3, 2, "span", 72);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r49 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r49.columnType == "icon");
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_ng_container_5_td_2_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_ng_container_5_td_2_div_2_ng_container_1_Template, 2, 1, "ng-container", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r57 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r57.isExternalEmployeeId);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_ng_container_5_td_2_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 66);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r73 = i0.ɵɵnextContext();
    const i_r55 = ctx_r73.renderIndex;
    const row_r54 = ctx_r73.$implicit;
    const ctx_r72 = i0.ɵɵnextContext();
    const indx_r50 = ctx_r72.index;
    const column_r49 = ctx_r72.$implicit;
    i0.ɵɵpropertyInterpolate2("id", "colText6Lbl_", indx_r50, "__", i_r55, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", row_r54[column_r49.columnDef], " ");
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_ng_container_5_td_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 67);
    i0.ɵɵtemplate(1, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_ng_container_5_td_2_span_1_Template, 3, 0, "span", 68);
    i0.ɵɵtemplate(2, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_ng_container_5_td_2_div_2_Template, 2, 1, "div", 0);
    i0.ɵɵtemplate(3, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_ng_container_5_td_2_span_3_Template, 2, 3, "span", 69);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r49 = i0.ɵɵnextContext().$implicit;
    const ctx_r52 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r49.columnDef == "toggle");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r52.updateBenProfile && ctx_r52.showEditButton);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r49.columnType == "text");
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 62);
    i0.ɵɵtemplate(1, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_ng_container_5_th_1_Template, 3, 2, "th", 63);
    i0.ɵɵtemplate(2, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_ng_container_5_td_2_Template, 4, 3, "td", 64);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r49 = ctx.$implicit;
    i0.ɵɵproperty("matColumnDef", column_r49.columnDef);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_td_8_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "table", 81);
    i0.ɵɵelementStart(2, "thead");
    i0.ɵɵelementStart(3, "tr");
    i0.ɵɵelementStart(4, "th", 84);
    i0.ɵɵtext(5, " Approved Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "th", 85);
    i0.ɵɵtext(7, "Validity Start Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "th", 86);
    i0.ɵɵtext(9, "Validity End Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "th", 87);
    i0.ɵɵtext(11, "EAD Number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "th", 88);
    i0.ɵɵtext(13, " SEVIS Number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "tbody");
    i0.ɵɵelementStart(15, "tr");
    i0.ɵɵelementStart(16, "td", 89);
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "ImgDateFormat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "td", 66);
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "ImgDateFormat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "td", 89);
    i0.ɵɵtext(23);
    i0.ɵɵpipe(24, "ImgDateFormat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "td", 66);
    i0.ɵɵtext(26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "td", 89);
    i0.ɵɵtext(28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r82 = i0.ɵɵnextContext();
    const i_r76 = ctx_r82.renderIndex;
    const element_r75 = ctx_r82.$implicit;
    i0.ɵɵadvance(16);
    i0.ɵɵpropertyInterpolate1("id", "outcomeDate__", i_r76, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(18, 10, element_r75.outcomeDate), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "validityStartDate__", i_r76, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(21, 12, element_r75.validityStartDate), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "validityEndDate__", i_r76, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(24, 14, element_r75.validityEndDate), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "eadNo__", i_r76, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", element_r75.eadNo, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "sevisNo__", i_r76, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", element_r75.sevisNo, " ");
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_td_8_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "table", 81);
    i0.ɵɵelementStart(2, "thead");
    i0.ɵɵelementStart(3, "tr");
    i0.ɵɵelementStart(4, "th", 90);
    i0.ɵɵelementStart(5, "span", 91);
    i0.ɵɵtext(6, "Reason For Denial");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "th", 90);
    i0.ɵɵelementStart(8, "span", 92);
    i0.ɵɵtext(9, "Denial Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "tbody");
    i0.ɵɵelementStart(11, "tr");
    i0.ɵɵelementStart(12, "td", 93);
    i0.ɵɵelementStart(13, "span", 66);
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "td", 66);
    i0.ɵɵtext(16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r83 = i0.ɵɵnextContext();
    const i_r76 = ctx_r83.renderIndex;
    const element_r75 = ctx_r83.$implicit;
    i0.ɵɵadvance(13);
    i0.ɵɵpropertyInterpolate1("id", "outcomeReason__", i_r76, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(element_r75.outcomeReason);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "outcomeDate__", i_r76, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", element_r75.outcomeDate, " ");
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_td_8_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "table", 81);
    i0.ɵɵelementStart(2, "thead");
    i0.ɵɵelementStart(3, "tr");
    i0.ɵɵelementStart(4, "th", 90);
    i0.ɵɵelementStart(5, "span", 94);
    i0.ɵɵtext(6, "Reason For Withdrawal");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "th", 90);
    i0.ɵɵelementStart(8, "span", 95);
    i0.ɵɵtext(9, "Withdrawal Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "tbody");
    i0.ɵɵelementStart(11, "tr");
    i0.ɵɵelementStart(12, "td", 93);
    i0.ɵɵelementStart(13, "span", 66);
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "td", 66);
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "ImgDateFormat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r84 = i0.ɵɵnextContext();
    const i_r76 = ctx_r84.renderIndex;
    const element_r75 = ctx_r84.$implicit;
    i0.ɵɵadvance(13);
    i0.ɵɵpropertyInterpolate1("id", "withdrawalReason__", i_r76, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", element_r75.outcomeReason, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "outcomeDate1__", i_r76, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(17, 4, element_r75.outcomeDate), " ");
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_td_8_tr_34_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 82);
    i0.ɵɵelementStart(2, "div", 96);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵelementStart(5, "span", 66);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 89);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td", 66);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "ImgDateFormat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "td", 89);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "td", 66);
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "ImgDateFormat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "td", 89);
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "ImgDateFormat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const travel_r85 = ctx.$implicit;
    const ixx_r86 = ctx.index;
    const i_r76 = i0.ɵɵnextContext().renderIndex;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ixx_r86 + 1, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate2("id", "meansOfTravel", i_r76, "__", ixx_r86, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", travel_r85.meansOfTravel, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate2("id", "portOfEntry", i_r76, "__", ixx_r86, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", travel_r85.portOfEntry, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate2("id", "arrivalDate", i_r76, "__", ixx_r86, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 19, travel_r85.arrivalDate), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate2("id", "i94Number", i_r76, "__", ixx_r86, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", travel_r85.i94Number, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate2("id", "i94ExpiryDate", i_r76, "__", ixx_r86, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(16, 21, travel_r85.i94ExpiryDate), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate2("id", "exitDate", i_r76, "__", ixx_r86, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(19, 23, travel_r85.exitDate), " ");
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_td_8_tr_53_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 82);
    i0.ɵɵelementStart(2, "div", 96);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵelementStart(5, "strong");
    i0.ɵɵelementStart(6, "span", 66);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "td", 93);
    i0.ɵɵelementStart(9, "span", 66);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "td", 93);
    i0.ɵɵelement(12, "file-download-library", 97);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r88 = ctx.$implicit;
    const ixx_r89 = ctx.index;
    const i_r76 = i0.ɵɵnextContext().renderIndex;
    const ctx_r81 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ixx_r89 + 1, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate2("id", "'documentName", i_r76, "_", ixx_r89, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r88.fileName);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate2("id", "'documentType", i_r76, "_", ixx_r89, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate((item_r88 == null ? null : item_r88.fileCategory == null ? null : item_r88.fileCategory.code) === "OTHER" ? item_r88 == null ? null : item_r88.fileCategoryOtherName : item_r88 == null ? null : item_r88.fileCategory == null ? null : item_r88.fileCategory.name);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("fileName", item_r88.fileLocation.substring(23))("Path", ctx_r81.envPath + item_r88.fileLocation.substring(23));
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_td_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 78);
    i0.ɵɵelementStart(1, "div", 79);
    i0.ɵɵelementStart(2, "div", 80);
    i0.ɵɵtemplate(3, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_td_8_ng_container_3_Template, 29, 16, "ng-container", 0);
    i0.ɵɵtemplate(4, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_td_8_ng_container_4_Template, 17, 4, "ng-container", 0);
    i0.ɵɵtemplate(5, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_td_8_ng_container_5_Template, 18, 6, "ng-container", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 80);
    i0.ɵɵelementStart(7, "h6");
    i0.ɵɵelementStart(8, "span", 66);
    i0.ɵɵtext(9, "Travel History");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerStart(10);
    i0.ɵɵelementStart(11, "table", 81);
    i0.ɵɵelementStart(12, "thead");
    i0.ɵɵelementStart(13, "tr");
    i0.ɵɵelement(14, "th", 82);
    i0.ɵɵelementStart(15, "th");
    i0.ɵɵelementStart(16, "span", 66);
    i0.ɵɵtext(17, "Mode Of Travel");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "th");
    i0.ɵɵelementStart(19, "span", 66);
    i0.ɵɵtext(20, "Port");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "th");
    i0.ɵɵelementStart(22, "span", 66);
    i0.ɵɵtext(23, "Arrival Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "th");
    i0.ɵɵelementStart(25, "span", 66);
    i0.ɵɵtext(26, "I94 Number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "th");
    i0.ɵɵelementStart(28, "span", 66);
    i0.ɵɵtext(29, "I94 Expiry Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "th");
    i0.ɵɵelementStart(31, "span", 66);
    i0.ɵɵtext(32, "Exit Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(33, "tbody");
    i0.ɵɵtemplate(34, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_td_8_tr_34_Template, 20, 25, "tr", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(35, "div", 80);
    i0.ɵɵelementStart(36, "h6");
    i0.ɵɵelementStart(37, "span", 66);
    i0.ɵɵtext(38, "List of Documents");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerStart(39);
    i0.ɵɵelementStart(40, "table", 81);
    i0.ɵɵelementStart(41, "thead");
    i0.ɵɵelementStart(42, "tr");
    i0.ɵɵelement(43, "th", 82);
    i0.ɵɵelementStart(44, "th");
    i0.ɵɵelementStart(45, "span", 66);
    i0.ɵɵtext(46, " Document ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(47, "th");
    i0.ɵɵelementStart(48, "span", 66);
    i0.ɵɵtext(49, "Document Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(50, "th");
    i0.ɵɵelement(51, "i", 83);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(52, "tbody");
    i0.ɵɵtemplate(53, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_td_8_tr_53_Template, 13, 9, "tr", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r75 = ctx.$implicit;
    const i_r76 = ctx.renderIndex;
    const ctx_r45 = i0.ɵɵnextContext(4);
    i0.ɵɵattribute("colspan", ctx_r45.columns.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("@detailExpand", element_r75 == ctx_r45.expandedElement ? "expanded" : "collapsed");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", element_r75.outcomeIdCode === "VSAAPP");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", element_r75.outcomeIdCode === "VSADENY");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", element_r75.outcomeIdCode === "VSAWTDN");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate1("id", "travelHistory", i_r76, "");
    i0.ɵɵadvance(8);
    i0.ɵɵpropertyInterpolate1("id", "modeOfTravel", i_r76, "");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate1("id", "port", i_r76, "");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate1("id", "arrivalDate", i_r76, "");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate1("id", "i94Number", i_r76, "");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate1("id", "i94Number", i_r76, "");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate1("id", "exitDate", i_r76, "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", element_r75.travelInfo);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate1("id", "listOfDocuments", i_r76, "");
    i0.ɵɵadvance(8);
    i0.ɵɵpropertyInterpolate1("id", "document", i_r76, "");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate1("id", "documentType", i_r76, "");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", element_r75.documentList);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_tr_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 98);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_tr_10_Template(rf, ctx) { if (rf & 1) {
    const _r93 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 99);
    i0.ɵɵlistener("click", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_tr_10_Template_tr_click_0_listener() { i0.ɵɵrestoreView(_r93); const element_r91 = ctx.$implicit; const ctx_r92 = i0.ɵɵnextContext(4); return ctx_r92.expandedElement = ctx_r92.expandedElement === element_r91 ? null : element_r91; });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r91 = ctx.$implicit;
    const ctx_r47 = i0.ɵɵnextContext(4);
    i0.ɵɵclassProp("example-expanded-row", ctx_r47.expandedElement === element_r91);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_tr_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 100);
} }
const _c1 = function (a0) { return { disabledView: a0 }; };
const _c2 = function () { return ["expandedDetail"]; };
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 51);
    i0.ɵɵelementStart(1, "div", 52);
    i0.ɵɵelementStart(2, "div", 53);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "table", 54);
    i0.ɵɵtemplate(5, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_ng_container_5_Template, 3, 1, "ng-container", 55);
    i0.ɵɵelementStart(6, "div", 56);
    i0.ɵɵelementContainerStart(7, 57);
    i0.ɵɵtemplate(8, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_td_8_Template, 54, 17, "td", 58);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_tr_9_Template, 1, 0, "tr", 59);
    i0.ɵɵtemplate(10, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_tr_10_Template, 1, 2, "tr", 60);
    i0.ɵɵtemplate(11, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_tr_11_Template, 1, 0, "tr", 61);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c1, ctx_r38.isViewMode));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r38.dataSource && ctx_r38.dataSource.data.length > 0 ? ctx_r38.dataSource.data.length : "No", " Immigration details Added by you ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("dataSource", ctx_r38.dataSource);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r38.columns);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("matHeaderRowDef", ctx_r38.displayedColumns);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRowDefColumns", ctx_r38.displayedColumns);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRowDefColumns", i0.ɵɵpureFunction0(9, _c2));
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_i_8_Template(rf, ctx) { if (rf & 1) {
    const _r96 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "i", 101);
    i0.ɵɵlistener("click", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_i_8_Template_i_click_0_listener() { i0.ɵɵrestoreView(_r96); const ctx_r95 = i0.ɵɵnextContext(3); return ctx_r95.closeImmigration(); });
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r118 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 119);
    i0.ɵɵelementStart(1, "label", 120);
    i0.ɵɵelementStart(2, "span", 121);
    i0.ɵɵtext(3, "Which Visa did you apply for?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p-dropdown", 122, 123);
    i0.ɵɵlistener("onChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_7_Template_p_dropdown_onChange_4_listener() { i0.ɵɵrestoreView(_r118); i0.ɵɵnextContext(); const _r97 = i0.ɵɵreference(5); const ctx_r117 = i0.ɵɵnextContext(3); ctx_r117.handleVisaTypeChange(ctx_r117.visa.immigrationStatusCode, _r97); return ctx_r117.resetPetitionTypeDropDown(); })("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_7_Template_p_dropdown_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r118); const ctx_r119 = i0.ɵɵnextContext(4); return ctx_r119.visa.immigrationStatusCode = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r98 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r98.visaTypeList)("ngModel", ctx_r98.visa.immigrationStatusCode)("filter", true);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r122 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 119);
    i0.ɵɵelementStart(1, "label", 120);
    i0.ɵɵelementStart(2, "span", 124);
    i0.ɵɵtext(3, "Which Visa did you apply for?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p-dropdown", 125, 123);
    i0.ɵɵlistener("onChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_8_Template_p_dropdown_onChange_4_listener() { i0.ɵɵrestoreView(_r122); i0.ɵɵnextContext(); const _r97 = i0.ɵɵreference(5); const ctx_r121 = i0.ɵɵnextContext(3); ctx_r121.handleVisaTypeChange(ctx_r121.visa.immigrationStatusCode, _r97); return ctx_r121.resetPetitionTypeDropDown(); })("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_8_Template_p_dropdown_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r122); const ctx_r123 = i0.ɵɵnextContext(4); return ctx_r123.visa.immigrationStatusCode = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r99 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r99.visaTypeList)("ngModel", ctx_r99.visa.immigrationStatusCode);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r126 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 119);
    i0.ɵɵelementStart(1, "label", 120);
    i0.ɵɵelementStart(2, "span", 126);
    i0.ɵɵtext(3, "What is the petition type?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p-dropdown", 127, 128);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_9_Template_p_dropdown_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r126); const ctx_r125 = i0.ɵɵnextContext(4); return ctx_r125.visa.petitionTypeCode = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r100 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r100.visaPetitionTypeList)("ngModel", ctx_r100.visa.petitionTypeCode);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r129 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 119);
    i0.ɵɵelementStart(1, "label", 120);
    i0.ɵɵelementStart(2, "span", 129);
    i0.ɵɵtext(3, "What is the petition type?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p-dropdown", 130, 128);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_10_Template_p_dropdown_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r129); const ctx_r128 = i0.ɵɵnextContext(4); return ctx_r128.visa.petitionTypeCode = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r101 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r101.visaPetitionTypeList)("ngModel", ctx_r101.visa.petitionTypeCode);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_11_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r133 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 119);
    i0.ɵɵelementStart(1, "label", 120);
    i0.ɵɵelementStart(2, "span", 131);
    i0.ɵɵtext(3, "What is the Petitioner Name?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 132, 133);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_11_div_1_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r133); const ctx_r132 = i0.ɵɵnextContext(5); return ctx_r132.visa.companyName = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r130 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r130.visa.companyName);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtemplate(1, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_11_div_1_Template, 6, 1, "div", 107);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r102 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r102.checkPetitionName());
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_12_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r137 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 119);
    i0.ɵɵelementStart(1, "label", 120);
    i0.ɵɵelementStart(2, "span", 131);
    i0.ɵɵtext(3, "What is the Petitioner Name?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 132, 133);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_12_div_1_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r137); const ctx_r136 = i0.ɵɵnextContext(5); return ctx_r136.visa.companyName = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r134 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r134.visa.companyName);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtemplate(1, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_12_div_1_Template, 6, 1, "div", 107);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r103 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r103.checkPetitionName());
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_13_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r141 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 119);
    i0.ɵɵelementStart(1, "label", 120);
    i0.ɵɵelementStart(2, "span", 131);
    i0.ɵɵtext(3, "What is the Petitioner Name?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 134, 133);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_13_div_1_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r141); const ctx_r140 = i0.ɵɵnextContext(5); return ctx_r140.visa.companyName = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r138 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r138.visa.companyName);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtemplate(1, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_13_div_1_Template, 6, 1, "div", 107);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r104 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r104.checkPetitionName());
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_14_mat_radio_button_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-radio-button", 140);
    i0.ɵɵelementStart(1, "span", 66);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r144 = ctx.$implicit;
    const i_r145 = ctx.index;
    i0.ɵɵproperty("value", option_r144.code);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "optionCode-", i_r145, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(option_r144.name);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r147 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelementStart(1, "div", 135);
    i0.ɵɵelementStart(2, "label", 136);
    i0.ɵɵtext(3, "What is the visa outcome?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "mat-radio-group", 137, 138);
    i0.ɵɵlistener("change", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_14_Template_mat_radio_group_change_4_listener() { i0.ɵɵrestoreView(_r147); const ctx_r146 = i0.ɵɵnextContext(4); return ctx_r146.outcomeCodeIdChange(); })("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_14_Template_mat_radio_group_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r147); const ctx_r148 = i0.ɵɵnextContext(4); return ctx_r148.visa.outcomeIdCode = $event; });
    i0.ɵɵtemplate(6, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_14_mat_radio_button_6_Template, 3, 3, "mat-radio-button", 139);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r105 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r105.visa.outcomeIdCode);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r105.outcomeTypeList);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_15_mat_radio_button_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-radio-button", 140);
    i0.ɵɵelementStart(1, "span", 141);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r151 = ctx.$implicit;
    i0.ɵɵproperty("value", option_r151.code);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(option_r151.name);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r154 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelementStart(1, "div", 135);
    i0.ɵɵelementStart(2, "label", 136);
    i0.ɵɵtext(3, "What is the visa outcome?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "mat-radio-group", 137, 138);
    i0.ɵɵlistener("change", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_15_Template_mat_radio_group_change_4_listener() { i0.ɵɵrestoreView(_r154); const ctx_r153 = i0.ɵɵnextContext(4); return ctx_r153.outcomeCodeIdChange(); })("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_15_Template_mat_radio_group_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r154); const ctx_r155 = i0.ɵɵnextContext(4); return ctx_r155.visa.outcomeIdCode = $event; });
    i0.ɵɵtemplate(6, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_15_mat_radio_button_6_Template, 3, 2, "mat-radio-button", 139);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r106 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r106.visa.outcomeIdCode);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r106.outcomeTypeList);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_24_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 147);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r157 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r157.getGlobalErrorMessages("INVALID_FORMAT"), " ");
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_24_Template(rf, ctx) { if (rf & 1) {
    const _r159 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 119);
    i0.ɵɵelementStart(1, "label", 142);
    i0.ɵɵtext(2, "USCIS Receipt Number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 143, 144);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_24_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r159); const ctx_r158 = i0.ɵɵnextContext(4); return ctx_r158.visa.noticeNo = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "mat-hint", 145);
    i0.ɵɵtext(6, "Alphanumeric Characters only *");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "mat-error");
    i0.ɵɵtemplate(8, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_24_span_8_Template, 2, 1, "span", 146);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r156 = i0.ɵɵreference(4);
    i0.ɵɵnextContext();
    const _r97 = i0.ɵɵreference(5);
    const ctx_r107 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r107.visa.noticeNo);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", (_r156.touched || _r97.submitted) && (_r156.errors == null ? null : _r156.errors.pattern));
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_25_Template(rf, ctx) { if (rf & 1) {
    const _r162 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 119);
    i0.ɵɵelementStart(1, "label", 148);
    i0.ɵɵtext(2, "USCIS Receipt Number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 143, 144);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_25_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r162); const ctx_r161 = i0.ɵɵnextContext(4); return ctx_r161.visa.noticeNo = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "mat-hint", 149);
    i0.ɵɵtext(6, "Alphanumeric Characters only *");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r108 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r108.visa.noticeNo);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_26_Template(rf, ctx) { if (rf & 1) {
    const _r166 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 119);
    i0.ɵɵelementStart(1, "label", 150);
    i0.ɵɵtext(2, "USCIS Receipt Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-form-field", 151);
    i0.ɵɵelementStart(4, "input", 152, 153);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_26_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r166); const ctx_r165 = i0.ɵɵnextContext(4); return ctx_r165.visa.receiptDate = $event; })("click", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_26_Template_input_click_4_listener() { i0.ɵɵrestoreView(_r166); const _r164 = i0.ɵɵreference(8); return _r164.open(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "mat-datepicker-toggle", 154);
    i0.ɵɵelement(7, "mat-datepicker", null, 155);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r164 = i0.ɵɵreference(8);
    const ctx_r109 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("matDatepicker", _r164)("max", ctx_r109.today)("ngModel", ctx_r109.visa.receiptDate);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("for", _r164);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_27_Template(rf, ctx) { if (rf & 1) {
    const _r171 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 119);
    i0.ɵɵelementStart(1, "label", 150);
    i0.ɵɵtext(2, "USCIS Receipt Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-form-field", 156);
    i0.ɵɵelementStart(4, "input", 152, 153);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_27_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r171); const ctx_r170 = i0.ɵɵnextContext(4); return ctx_r170.visa.receiptDate = $event; })("click", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_27_Template_input_click_4_listener() { i0.ɵɵrestoreView(_r171); const _r169 = i0.ɵɵreference(8); return _r169.open(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "mat-datepicker-toggle", 154);
    i0.ɵɵelement(7, "mat-datepicker", null, 155);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r169 = i0.ɵɵreference(8);
    const ctx_r110 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("matDatepicker", _r169)("max", ctx_r110.today)("ngModel", ctx_r110.visa.receiptDate);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("for", _r169);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_28_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r179 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵelementStart(1, "label", 160);
    i0.ɵɵtext(2, "Reason for denial");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 161, 162);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_28_div_2_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r179); const ctx_r178 = i0.ɵɵnextContext(5); return ctx_r178.visa.outcomeReason = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r173 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r173.visa.outcomeReason);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_28_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r182 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵelementStart(1, "label", 160);
    i0.ɵɵtext(2, "Reason for denial");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 161, 162);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_28_div_3_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r182); const ctx_r181 = i0.ɵɵnextContext(5); return ctx_r181.visa.outcomeReason = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r174 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r174.visa.outcomeReason);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_28_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r186 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 163);
    i0.ɵɵelementStart(1, "label", 164);
    i0.ɵɵtext(2, "Denial Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-form-field", 156);
    i0.ɵɵelementStart(4, "input", 165, 166);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_28_div_4_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r186); const ctx_r185 = i0.ɵɵnextContext(5); return ctx_r185.visa.outcomeDate = $event; })("click", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_28_div_4_Template_input_click_4_listener() { i0.ɵɵrestoreView(_r186); const _r184 = i0.ɵɵreference(8); return _r184.open(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "mat-datepicker-toggle", 154);
    i0.ɵɵelement(7, "mat-datepicker", null, 167);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r184 = i0.ɵɵreference(8);
    const ctx_r175 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("matDatepicker", _r184)("min", ctx_r175.visa.receiptDate)("max", ctx_r175.today)("ngModel", ctx_r175.visa.outcomeDate);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("for", _r184);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_28_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r191 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 163);
    i0.ɵɵelementStart(1, "label", 164);
    i0.ɵɵtext(2, "Denial Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-form-field", 156);
    i0.ɵɵelementStart(4, "input", 165, 166);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_28_div_5_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r191); const ctx_r190 = i0.ɵɵnextContext(5); return ctx_r190.visa.outcomeDate = $event; })("click", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_28_div_5_Template_input_click_4_listener() { i0.ɵɵrestoreView(_r191); const _r189 = i0.ɵɵreference(8); return _r189.open(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "mat-datepicker-toggle", 154);
    i0.ɵɵelement(7, "mat-datepicker", null, 167);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r189 = i0.ɵɵreference(8);
    const ctx_r176 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("matDatepicker", _r189)("min", ctx_r176.visa.receiptDate)("max", ctx_r176.today)("ngModel", ctx_r176.visa.outcomeDate);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("for", _r189);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 157);
    i0.ɵɵelementStart(1, "div", 18);
    i0.ɵɵtemplate(2, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_28_div_2_Template, 5, 1, "div", 158);
    i0.ɵɵtemplate(3, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_28_div_3_Template, 5, 1, "div", 158);
    i0.ɵɵtemplate(4, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_28_div_4_Template, 9, 5, "div", 159);
    i0.ɵɵtemplate(5, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_28_div_5_Template, 9, 5, "div", 159);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r111 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r111.iscaseRequest);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r111.iscaseRequest ? ctx_r111.currentItemDisplay.includes("VISADTLS") ? true : false : false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r111.iscaseRequest);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r111.iscaseRequest ? ctx_r111.currentItemDisplay.includes("VISADTLS") ? true : false : false);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r208 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 163);
    i0.ɵɵelementStart(1, "label", 174);
    i0.ɵɵtext(2, "USCIS Approved Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-form-field", 156);
    i0.ɵɵelementStart(4, "input", 165, 166);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_2_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r208); const ctx_r207 = i0.ɵɵnextContext(5); return ctx_r207.visa.outcomeDate = $event; })("click", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_2_Template_input_click_4_listener() { i0.ɵɵrestoreView(_r208); const _r206 = i0.ɵɵreference(8); return _r206.open(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "mat-datepicker-toggle", 154);
    i0.ɵɵelement(7, "mat-datepicker", null, 175);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r206 = i0.ɵɵreference(8);
    const ctx_r193 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("matDatepicker", _r206)("min", ctx_r193.visa.receiptDate)("max", ctx_r193.today)("ngModel", ctx_r193.visa.outcomeDate);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("for", _r206);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r213 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 163);
    i0.ɵɵelementStart(1, "label", 176);
    i0.ɵɵtext(2, "USCIS Approved Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-form-field", 156);
    i0.ɵɵelementStart(4, "input", 165, 166);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_3_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r213); const ctx_r212 = i0.ɵɵnextContext(5); return ctx_r212.visa.outcomeDate = $event; })("click", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_3_Template_input_click_4_listener() { i0.ɵɵrestoreView(_r213); const _r211 = i0.ɵɵreference(8); return _r211.open(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "mat-datepicker-toggle", 154);
    i0.ɵɵelement(7, "mat-datepicker", null, 175);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r211 = i0.ɵɵreference(8);
    const ctx_r194 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("matDatepicker", _r211)("min", ctx_r194.visa.receiptDate)("max", ctx_r194.today)("ngModel", ctx_r194.visa.outcomeDate);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("for", _r211);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r218 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 163);
    i0.ɵɵelementStart(1, "label", 177);
    i0.ɵɵtext(2, "Visa Validity Start Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-form-field", 156);
    i0.ɵɵelementStart(4, "input", 178, 179);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_4_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r218); const ctx_r217 = i0.ɵɵnextContext(5); return ctx_r217.visa.validityStartDate = $event; })("dateChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_4_Template_input_dateChange_4_listener() { i0.ɵɵrestoreView(_r218); const ctx_r219 = i0.ɵɵnextContext(5); return ctx_r219.visaValidityStartChange(); })("click", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_4_Template_input_click_4_listener() { i0.ɵɵrestoreView(_r218); const _r216 = i0.ɵɵreference(8); return _r216.open(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "mat-datepicker-toggle", 154);
    i0.ɵɵelement(7, "mat-datepicker", null, 180);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r216 = i0.ɵɵreference(8);
    const ctx_r195 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("matDatepicker", _r216)("ngModel", ctx_r195.visa.validityStartDate)("min", ctx_r195.visa.receiptDate);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("for", _r216);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r224 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 163);
    i0.ɵɵelementStart(1, "label", 177);
    i0.ɵɵtext(2, "Visa Validity Start Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-form-field", 156);
    i0.ɵɵelementStart(4, "input", 181, 179);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_5_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r224); const ctx_r223 = i0.ɵɵnextContext(5); return ctx_r223.visa.validityStartDate = $event; })("dateChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_5_Template_input_dateChange_4_listener() { i0.ɵɵrestoreView(_r224); const ctx_r225 = i0.ɵɵnextContext(5); return ctx_r225.visaValidityStartChange(); })("click", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_5_Template_input_click_4_listener() { i0.ɵɵrestoreView(_r224); const _r222 = i0.ɵɵreference(8); return _r222.open(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "mat-datepicker-toggle", 154);
    i0.ɵɵelement(7, "mat-datepicker", null, 180);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r222 = i0.ɵɵreference(8);
    const ctx_r196 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("matDatepicker", _r222)("ngModel", ctx_r196.visa.validityStartDate)("min", ctx_r196.visa.receiptDate);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("for", _r222);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r230 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 163);
    i0.ɵɵelementStart(1, "label", 182);
    i0.ɵɵtext(2, "Visa Validity End Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-form-field", 156);
    i0.ɵɵelementStart(4, "input", 183, 184);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_6_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r230); const ctx_r229 = i0.ɵɵnextContext(5); return ctx_r229.visa.validityEndDate = $event; })("click", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_6_Template_input_click_4_listener() { i0.ɵɵrestoreView(_r230); const _r228 = i0.ɵɵreference(8); return _r228.open(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "mat-datepicker-toggle", 154);
    i0.ɵɵelement(7, "mat-datepicker", null, 185);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r228 = i0.ɵɵreference(8);
    const ctx_r197 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("matDatepicker", _r228)("min", ctx_r197.minVisaValidityEndDate)("ngModel", ctx_r197.visa.validityEndDate);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("for", _r228);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r235 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 163);
    i0.ɵɵelementStart(1, "label", 182);
    i0.ɵɵtext(2, "Visa Validity End Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-form-field", 156);
    i0.ɵɵelementStart(4, "input", 183, 184);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_7_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r235); const ctx_r234 = i0.ɵɵnextContext(5); return ctx_r234.visa.validityEndDate = $event; })("click", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_7_Template_input_click_4_listener() { i0.ɵɵrestoreView(_r235); const _r233 = i0.ɵɵreference(8); return _r233.open(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "mat-datepicker-toggle", 154);
    i0.ɵɵelement(7, "mat-datepicker", null, 185);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r233 = i0.ɵɵreference(8);
    const ctx_r198 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("matDatepicker", _r233)("min", ctx_r198.minVisaValidityEndDate)("ngModel", ctx_r198.visa.validityEndDate);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("for", _r233);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_22_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r244 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 119);
    i0.ɵɵelementStart(1, "label", 186);
    i0.ɵɵtext(2, "Visa Issue Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-form-field", 156);
    i0.ɵɵelementStart(4, "input", 187, 188);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_22_div_1_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r244); const ctx_r243 = i0.ɵɵnextContext(6); return ctx_r243.visa.visaIssueDate = $event; })("dateChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_22_div_1_Template_input_dateChange_4_listener() { i0.ɵɵrestoreView(_r244); const ctx_r245 = i0.ɵɵnextContext(6); return ctx_r245.visaIssueDateChange(); })("click", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_22_div_1_Template_input_click_4_listener() { i0.ɵɵrestoreView(_r244); const _r242 = i0.ɵɵreference(8); return _r242.open(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "mat-datepicker-toggle", 154);
    i0.ɵɵelement(7, "mat-datepicker", null, 189);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r242 = i0.ɵɵreference(8);
    const ctx_r237 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("matDatepicker", _r242)("ngModel", ctx_r237.visa.visaIssueDate)("min", ctx_r237.visa.receiptDate);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("for", _r242);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_22_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r250 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 119);
    i0.ɵɵelementStart(1, "label", 186);
    i0.ɵɵtext(2, "Visa Issue Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-form-field", 156);
    i0.ɵɵelementStart(4, "input", 187, 188);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_22_div_2_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r250); const ctx_r249 = i0.ɵɵnextContext(6); return ctx_r249.visa.visaIssueDate = $event; })("dateChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_22_div_2_Template_input_dateChange_4_listener() { i0.ɵɵrestoreView(_r250); const ctx_r251 = i0.ɵɵnextContext(6); return ctx_r251.visaIssueDateChange(); })("click", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_22_div_2_Template_input_click_4_listener() { i0.ɵɵrestoreView(_r250); const _r248 = i0.ɵɵreference(8); return _r248.open(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "mat-datepicker-toggle", 154);
    i0.ɵɵelement(7, "mat-datepicker", null, 189);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r248 = i0.ɵɵreference(8);
    const ctx_r238 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("matDatepicker", _r248)("ngModel", ctx_r238.visa.visaIssueDate)("min", ctx_r238.visa.receiptDate);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("for", _r248);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_22_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r256 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 119);
    i0.ɵɵelementStart(1, "label", 190);
    i0.ɵɵtext(2, "Visa Expiration Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-form-field", 156);
    i0.ɵɵelementStart(4, "input", 191, 192);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_22_div_3_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r256); const ctx_r255 = i0.ɵɵnextContext(6); return ctx_r255.visa.visaExpirationDate = $event; })("click", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_22_div_3_Template_input_click_4_listener() { i0.ɵɵrestoreView(_r256); const _r254 = i0.ɵɵreference(8); return _r254.open(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "mat-datepicker-toggle", 154);
    i0.ɵɵelement(7, "mat-datepicker", null, 193);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r254 = i0.ɵɵreference(8);
    const ctx_r239 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("matDatepicker", _r254)("min", ctx_r239.minVisaExpirationDate)("ngModel", ctx_r239.visa.visaExpirationDate);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("for", _r254);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_22_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r261 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 119);
    i0.ɵɵelementStart(1, "label", 190);
    i0.ɵɵtext(2, "Visa Expiration Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-form-field", 156);
    i0.ɵɵelementStart(4, "input", 191, 192);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_22_div_4_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r261); const ctx_r260 = i0.ɵɵnextContext(6); return ctx_r260.visa.visaExpirationDate = $event; })("click", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_22_div_4_Template_input_click_4_listener() { i0.ɵɵrestoreView(_r261); const _r259 = i0.ɵɵreference(8); return _r259.open(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "mat-datepicker-toggle", 154);
    i0.ɵɵelement(7, "mat-datepicker", null, 193);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r259 = i0.ɵɵreference(8);
    const ctx_r240 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("matDatepicker", _r259)("min", ctx_r240.minVisaExpirationDate)("ngModel", ctx_r240.visa.visaExpirationDate);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("for", _r259);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtemplate(1, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_22_div_1_Template, 9, 4, "div", 107);
    i0.ɵɵtemplate(2, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_22_div_2_Template, 9, 4, "div", 107);
    i0.ɵɵtemplate(3, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_22_div_3_Template, 9, 4, "div", 107);
    i0.ɵɵtemplate(4, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_22_div_4_Template, 9, 4, "div", 107);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r199 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r199.iscaseRequest);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r199.iscaseRequest ? ctx_r199.currentItemDisplay.includes("VISADTLS") ? true : false : false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r199.iscaseRequest);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r199.iscaseRequest ? ctx_r199.currentItemDisplay.includes("VISADTLS") ? true : false : false);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_23_Template(rf, ctx) { if (rf & 1) {
    const _r265 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelementStart(1, "div", 26);
    i0.ɵɵelementStart(2, "label", 194);
    i0.ɵɵtext(3, "EAD Number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 195, 196);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_23_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r265); const ctx_r264 = i0.ɵɵnextContext(5); return ctx_r264.visa.eadNo = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 163);
    i0.ɵɵelementStart(7, "mat-checkbox", 197);
    i0.ɵɵlistener("change", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_23_Template_mat_checkbox_change_7_listener() { i0.ɵɵrestoreView(_r265); const ctx_r266 = i0.ɵɵnextContext(5); return ctx_r266.eadUpdate(); })("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_23_Template_mat_checkbox_ngModelChange_7_listener($event) { i0.ɵɵrestoreView(_r265); const ctx_r267 = i0.ɵɵnextContext(5); return ctx_r267.visa.isEadNo = $event; });
    i0.ɵɵelementStart(8, "span", 198);
    i0.ɵɵtext(9, "Not Applicable");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r200 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", ctx_r200.visa.isEadNo)("ngModel", ctx_r200.visa.eadNo);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r200.visa.isEadNo);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_24_Template(rf, ctx) { if (rf & 1) {
    const _r270 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelementStart(1, "div", 26);
    i0.ɵɵelementStart(2, "label", 194);
    i0.ɵɵtext(3, "EAD Number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 195, 196);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_24_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r270); const ctx_r269 = i0.ɵɵnextContext(5); return ctx_r269.visa.eadNo = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 163);
    i0.ɵɵelementStart(7, "mat-checkbox", 197);
    i0.ɵɵlistener("change", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_24_Template_mat_checkbox_change_7_listener() { i0.ɵɵrestoreView(_r270); const ctx_r271 = i0.ɵɵnextContext(5); return ctx_r271.eadUpdate(); })("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_24_Template_mat_checkbox_ngModelChange_7_listener($event) { i0.ɵɵrestoreView(_r270); const ctx_r272 = i0.ɵɵnextContext(5); return ctx_r272.visa.isEadNo = $event; });
    i0.ɵɵelementStart(8, "span", 198);
    i0.ɵɵtext(9, "Not Applicable");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r201 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", ctx_r201.visa.isEadNo)("ngModel", ctx_r201.visa.eadNo);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r201.visa.isEadNo);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_25_Template(rf, ctx) { if (rf & 1) {
    const _r275 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelementStart(1, "div", 26);
    i0.ɵɵelementStart(2, "label", 199);
    i0.ɵɵtext(3, "SEVIS Number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 200, 201);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_25_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r275); const ctx_r274 = i0.ɵɵnextContext(5); return ctx_r274.visa.sevisNo = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 163);
    i0.ɵɵelementStart(7, "mat-checkbox", 202);
    i0.ɵɵlistener("change", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_25_Template_mat_checkbox_change_7_listener() { i0.ɵɵrestoreView(_r275); const ctx_r276 = i0.ɵɵnextContext(5); return ctx_r276.sevisUpdate(); })("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_25_Template_mat_checkbox_ngModelChange_7_listener($event) { i0.ɵɵrestoreView(_r275); const ctx_r277 = i0.ɵɵnextContext(5); return ctx_r277.visa.isSevisNo = $event; });
    i0.ɵɵelementStart(8, "span", 198);
    i0.ɵɵtext(9, "Not Applicable");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r202 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", ctx_r202.visa.isSevisNo)("ngModel", ctx_r202.visa.sevisNo);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r202.visa.isSevisNo)("disabled", ctx_r202.isVisaTypeF1);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_26_Template(rf, ctx) { if (rf & 1) {
    const _r280 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelementStart(1, "div", 26);
    i0.ɵɵelementStart(2, "label", 199);
    i0.ɵɵtext(3, "SEVIS Number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 200, 201);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_26_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r280); const ctx_r279 = i0.ɵɵnextContext(5); return ctx_r279.visa.sevisNo = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 163);
    i0.ɵɵelementStart(7, "mat-checkbox", 202);
    i0.ɵɵlistener("change", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_26_Template_mat_checkbox_change_7_listener() { i0.ɵɵrestoreView(_r280); const ctx_r281 = i0.ɵɵnextContext(5); return ctx_r281.sevisUpdate(); })("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_26_Template_mat_checkbox_ngModelChange_7_listener($event) { i0.ɵɵrestoreView(_r280); const ctx_r282 = i0.ɵɵnextContext(5); return ctx_r282.visa.isSevisNo = $event; });
    i0.ɵɵelementStart(8, "span", 198);
    i0.ɵɵtext(9, "Not Applicable");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r203 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", ctx_r203.visa.isSevisNo)("ngModel", ctx_r203.visa.sevisNo);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r203.visa.isSevisNo)("disabled", ctx_r203.isVisaTypeF1);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_27_Template(rf, ctx) { if (rf & 1) {
    const _r284 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelementStart(1, "div", 168);
    i0.ɵɵelementStart(2, "label", 203);
    i0.ɵɵtext(3, "Have you used this visa?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 170);
    i0.ɵɵelementStart(5, "mat-radio-group", 204);
    i0.ɵɵlistener("change", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_27_Template_mat_radio_group_change_5_listener() { i0.ɵɵrestoreView(_r284); const ctx_r283 = i0.ɵɵnextContext(5); return ctx_r283.handleToggleHasTravelToUs(); })("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_27_Template_mat_radio_group_ngModelChange_5_listener($event) { i0.ɵɵrestoreView(_r284); const ctx_r285 = i0.ɵɵnextContext(5); return ctx_r285.visa.hasTravelToUs = $event; });
    i0.ɵɵelementStart(6, "mat-radio-button", 140);
    i0.ɵɵelementStart(7, "span", 205);
    i0.ɵɵtext(8, "Yes");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "mat-radio-button", 140);
    i0.ɵɵelementStart(10, "span", 206);
    i0.ɵɵtext(11, "No");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r204 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngModel", ctx_r204.visa.hasTravelToUs);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", true);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", false);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_Template(rf, ctx) { if (rf & 1) {
    const _r287 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 157);
    i0.ɵɵelementStart(1, "div", 18);
    i0.ɵɵtemplate(2, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_2_Template, 9, 5, "div", 159);
    i0.ɵɵtemplate(3, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_3_Template, 9, 5, "div", 159);
    i0.ɵɵtemplate(4, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_4_Template, 9, 4, "div", 159);
    i0.ɵɵtemplate(5, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_5_Template, 9, 4, "div", 159);
    i0.ɵɵtemplate(6, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_6_Template, 9, 4, "div", 159);
    i0.ɵɵtemplate(7, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_7_Template, 9, 4, "div", 159);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 8);
    i0.ɵɵelementStart(9, "div", 168);
    i0.ɵɵelementStart(10, "label", 120);
    i0.ɵɵelementStart(11, "strong");
    i0.ɵɵelementStart(12, "span", 169);
    i0.ɵɵtext(13, "Did you go through Consular Process for Visa Stamping?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 170);
    i0.ɵɵelementStart(15, "mat-radio-group", 171);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_Template_mat_radio_group_ngModelChange_15_listener($event) { i0.ɵɵrestoreView(_r287); const ctx_r286 = i0.ɵɵnextContext(4); return ctx_r286.visa.visaStamping = $event; })("change", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_Template_mat_radio_group_change_15_listener() { i0.ɵɵrestoreView(_r287); const ctx_r288 = i0.ɵɵnextContext(4); return ctx_r288.refreshView(); });
    i0.ɵɵelementStart(16, "mat-radio-button", 140);
    i0.ɵɵelementStart(17, "span", 172);
    i0.ɵɵtext(18, "Yes");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "mat-radio-button", 140);
    i0.ɵɵelementStart(20, "span", 173);
    i0.ɵɵtext(21, "No");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(22, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_22_Template, 5, 4, "div", 108);
    i0.ɵɵtemplate(23, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_23_Template, 10, 3, "div", 25);
    i0.ɵɵtemplate(24, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_24_Template, 10, 3, "div", 25);
    i0.ɵɵtemplate(25, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_25_Template, 10, 4, "div", 25);
    i0.ɵɵtemplate(26, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_26_Template, 10, 4, "div", 25);
    i0.ɵɵtemplate(27, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_div_27_Template, 12, 3, "div", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r112 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r112.iscaseRequest);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r112.iscaseRequest ? ctx_r112.currentItemDisplay.includes("VISADTLS") ? true : false : false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r112.iscaseRequest);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r112.iscaseRequest ? ctx_r112.currentItemDisplay.includes("VISADTLS") ? true : false : false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r112.iscaseRequest);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r112.iscaseRequest ? ctx_r112.currentItemDisplay.includes("VISADTLS") ? true : false : false);
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("ngModel", ctx_r112.visa.visaStamping);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", true);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", false);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r112.visa.visaStamping);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r112.iscaseRequest);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r112.iscaseRequest ? ctx_r112.currentItemDisplay.includes("VISADTLS") ? true : false : false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r112.iscaseRequest);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r112.iscaseRequest ? ctx_r112.currentItemDisplay.includes("VISADTLS") ? true : false : false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r112.iscaseRequest ? ctx_r112.currentItemDisplay.includes("VISADTLS") ? true : false : true);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_30_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r295 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelementStart(1, "div", 26);
    i0.ɵɵelementStart(2, "label", 207);
    i0.ɵɵtext(3, "Reason for withdrawal");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 161, 162);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_30_div_1_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r295); const ctx_r294 = i0.ɵɵnextContext(5); return ctx_r294.visa.outcomeReason = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 163);
    i0.ɵɵelementStart(7, "label", 208);
    i0.ɵɵtext(8, "Withdrawal Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "mat-form-field", 156);
    i0.ɵɵelementStart(10, "input", 165, 166);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_30_div_1_Template_input_ngModelChange_10_listener($event) { i0.ɵɵrestoreView(_r295); const ctx_r296 = i0.ɵɵnextContext(5); return ctx_r296.visa.outcomeDate = $event; })("click", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_30_div_1_Template_input_click_10_listener() { i0.ɵɵrestoreView(_r295); const _r293 = i0.ɵɵreference(14); return _r293.open(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "mat-datepicker-toggle", 154);
    i0.ɵɵelement(13, "mat-datepicker", null, 167);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r293 = i0.ɵɵreference(14);
    const ctx_r289 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r289.visa.outcomeReason);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("matDatepicker", _r293)("min", ctx_r289.visa.receiptDate)("max", ctx_r289.today)("ngModel", ctx_r289.visa.outcomeDate);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("for", _r293);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_30_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r302 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelementStart(1, "div", 26);
    i0.ɵɵelementStart(2, "label", 207);
    i0.ɵɵtext(3, "Reason for withdrawal");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 161, 162);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_30_div_2_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r302); const ctx_r301 = i0.ɵɵnextContext(5); return ctx_r301.visa.outcomeReason = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 163);
    i0.ɵɵelementStart(7, "label", 208);
    i0.ɵɵtext(8, "Withdrawal Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "mat-form-field", 156);
    i0.ɵɵelementStart(10, "input", 165, 166);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_30_div_2_Template_input_ngModelChange_10_listener($event) { i0.ɵɵrestoreView(_r302); const ctx_r303 = i0.ɵɵnextContext(5); return ctx_r303.visa.outcomeDate = $event; })("click", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_30_div_2_Template_input_click_10_listener() { i0.ɵɵrestoreView(_r302); const _r300 = i0.ɵɵreference(14); return _r300.open(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "mat-datepicker-toggle", 154);
    i0.ɵɵelement(13, "mat-datepicker", null, 167);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r300 = i0.ɵɵreference(14);
    const ctx_r290 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r290.visa.outcomeReason);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("matDatepicker", _r300)("min", ctx_r290.visa.receiptDate)("max", ctx_r290.today)("ngModel", ctx_r290.visa.outcomeDate);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("for", _r300);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 157);
    i0.ɵɵtemplate(1, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_30_div_1_Template, 15, 6, "div", 108);
    i0.ɵɵtemplate(2, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_30_div_2_Template, 15, 6, "div", 108);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r113 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r113.iscaseRequest);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r113.iscaseRequest ? ctx_r113.currentItemDisplay.includes("VISADTLS") ? true : false : false);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_31_Template(rf, ctx) { if (rf & 1) {
    const _r306 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelementStart(1, "div", 209);
    i0.ɵɵelementStart(2, "mat-checkbox", 210);
    i0.ɵɵlistener("change", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_31_Template_mat_checkbox_change_2_listener() { i0.ɵɵrestoreView(_r306); const ctx_r305 = i0.ɵɵnextContext(4); return ctx_r305.updateCurrentlyUS(); })("ngModelChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_31_Template_mat_checkbox_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r306); const ctx_r307 = i0.ɵɵnextContext(4); return ctx_r307.visa.currentlyStayInUS = $event; });
    i0.ɵɵelementStart(3, "span", 211);
    i0.ɵɵtext(4, "Currently in the U.S");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r114 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngModel", ctx_r114.visa.currentlyStayInUS);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_button_40_Template(rf, ctx) { if (rf & 1) {
    const _r309 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 212);
    i0.ɵɵlistener("click", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_button_40_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r309); i0.ɵɵnextContext(); const _r97 = i0.ɵɵreference(5); const ctx_r308 = i0.ɵɵnextContext(3); return ctx_r308.closeForm(_r97); });
    i0.ɵɵelementStart(1, "span", 213);
    i0.ɵɵtext(2, "Cancel");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r311 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 102);
    i0.ɵɵelementStart(1, "label", 103);
    i0.ɵɵelementStart(2, "span", 104);
    i0.ɵɵtext(3, "Add Visa Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "form", 105, 106);
    i0.ɵɵlistener("click", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_Template_form_click_4_listener() { i0.ɵɵrestoreView(_r311); const _r97 = i0.ɵɵreference(5); const ctx_r310 = i0.ɵɵnextContext(3); return ctx_r310.visaFormCheck(_r97); })("ngSubmit", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_Template_form_ngSubmit_4_listener() { i0.ɵɵrestoreView(_r311); const _r97 = i0.ɵɵreference(5); const ctx_r312 = i0.ɵɵnextContext(3); return ctx_r312.saveVisaDetails(_r97); })("change", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_Template_form_change_4_listener() { i0.ɵɵrestoreView(_r311); const _r97 = i0.ɵɵreference(5); const ctx_r313 = i0.ɵɵnextContext(3); return ctx_r313.visaFormCheck(_r97); });
    i0.ɵɵelementStart(6, "div", 18);
    i0.ɵɵtemplate(7, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_7_Template, 6, 3, "div", 107);
    i0.ɵɵtemplate(8, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_8_Template, 6, 2, "div", 107);
    i0.ɵɵtemplate(9, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_9_Template, 6, 2, "div", 107);
    i0.ɵɵtemplate(10, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_10_Template, 6, 2, "div", 107);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_11_Template, 2, 1, "div", 108);
    i0.ɵɵtemplate(12, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_12_Template, 2, 1, "div", 108);
    i0.ɵɵtemplate(13, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_13_Template, 2, 1, "div", 108);
    i0.ɵɵtemplate(14, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_14_Template, 7, 2, "div", 108);
    i0.ɵɵtemplate(15, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_15_Template, 7, 2, "div", 108);
    i0.ɵɵelementStart(16, "div", 18);
    i0.ɵɵelementStart(17, "div", 109);
    i0.ɵɵelement(18, "mat-divider");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 18);
    i0.ɵɵelementStart(20, "div", 109);
    i0.ɵɵelementStart(21, "h5", 110);
    i0.ɵɵtext(22, "Enter visa details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "div", 111);
    i0.ɵɵtemplate(24, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_24_Template, 9, 2, "div", 107);
    i0.ɵɵtemplate(25, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_25_Template, 7, 1, "div", 107);
    i0.ɵɵtemplate(26, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_26_Template, 9, 4, "div", 107);
    i0.ɵɵtemplate(27, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_27_Template, 9, 4, "div", 107);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(28, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_28_Template, 6, 4, "div", 112);
    i0.ɵɵtemplate(29, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_29_Template, 28, 15, "div", 112);
    i0.ɵɵtemplate(30, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_30_Template, 3, 2, "div", 112);
    i0.ɵɵtemplate(31, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_div_31_Template, 5, 1, "div", 108);
    i0.ɵɵelementStart(32, "div", 113);
    i0.ɵɵelement(33, "hr");
    i0.ɵɵelementStart(34, "div", 114);
    i0.ɵɵelementStart(35, "div", 115);
    i0.ɵɵelementStart(36, "button", 116);
    i0.ɵɵelementStart(37, "span", 117);
    i0.ɵɵtext(38, "Save");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(39, "div", 115);
    i0.ɵɵtemplate(40, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_button_40_Template, 3, 0, "button", 118);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(41, "hr");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r40 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngIf", !ctx_r40.iscaseRequest);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r40.iscaseRequest ? ctx_r40.currentItemDisplay.includes("VISADTLS") ? true : false : false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r40.iscaseRequest);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r40.iscaseRequest ? ctx_r40.currentItemDisplay.includes("VISADTLS") ? true : false : false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r40.iscaseRequest);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r40.iscaseRequest ? ctx_r40.currentItemDisplay.includes("VISADTLS") ? true : false : false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r40.iscaseRequest ? ctx_r40.currentItemDisplay.includes("VISADTLS") ? true : false : true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r40.iscaseRequest);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r40.iscaseRequest);
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("ngIf", !ctx_r40.iscaseRequest);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r40.iscaseRequest ? ctx_r40.currentItemDisplay.includes("VISADTLS") ? true : false : false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r40.iscaseRequest);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r40.iscaseRequest ? ctx_r40.currentItemDisplay.includes("VISADTLS") ? true : false : false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r40.visa.outcomeIdCode === "VSADENY");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r40.visa.outcomeIdCode === "VSAAPP");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r40.visa.outcomeIdCode === "VSAWTDN");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r40.iscaseRequest ? ctx_r40.currentItemDisplay.includes("VISADTLS") ? true : false : true);
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("ngIf", !ctx_r40.modeVal);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 251);
    i0.ɵɵelementStart(1, "p", 252);
    i0.ɵɵtext(2, " Since you never travelled to U.S. on this Visa, You do not need to enter U.S. Stay History ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 253);
    i0.ɵɵelement(4, "div", 170);
    i0.ɵɵelement(5, "div", 254);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_th_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 255);
    i0.ɵɵtext(1, "Visa Type");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_12_Template(rf, ctx) { if (rf & 1) {
    const _r344 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 256);
    i0.ɵɵelementStart(1, "p-dropdown", 257);
    i0.ɵɵlistener("onChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_12_Template_p_dropdown_onChange_1_listener() { i0.ɵɵrestoreView(_r344); const i_r342 = ctx.index; const ctx_r343 = i0.ɵɵnextContext(4); return ctx_r343.updateFormControls(ctx_r343.stayHistoryForm.get("items")["controls"][i_r342]); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r342 = ctx.index;
    const ctx_r316 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("formGroup", ctx_r316.stayHistoryForm.get("items")["controls"][i_r342]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("options", ctx_r316.visaTypeList)("filter", true);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_th_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 258);
    i0.ɵɵtext(1, " Petition Type");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 256);
    i0.ɵɵelement(1, "p-dropdown", 259);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r346 = ctx.index;
    const ctx_r318 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("formGroup", ctx_r318.stayHistoryForm.get("items")["controls"][i_r346]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("options", ctx_r318.petitionTypeList);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_th_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 260);
    i0.ɵɵtext(1, "Mode of Travel");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_18_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 262);
    i0.ɵɵelement(2, "input", 263);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const j_r351 = ctx.index;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroupName", j_r351);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 256);
    i0.ɵɵelementStart(1, "div", 261);
    i0.ɵɵtemplate(2, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_18_ng_container_2_Template, 3, 1, "ng-container", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r348 = ctx.index;
    const ctx_r320 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("formGroup", ctx_r320.stayHistoryForm.get("items")["controls"][i_r348]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r320.getTravelInfoArray(i_r348)["controls"]);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_th_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 264);
    i0.ɵɵtext(1, "Port of entry into the US");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_21_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 262);
    i0.ɵɵelement(2, "input", 265);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const j_r356 = ctx.index;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroupName", j_r356);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 256);
    i0.ɵɵelementStart(1, "div", 261);
    i0.ɵɵtemplate(2, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_21_ng_container_2_Template, 3, 1, "ng-container", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r353 = ctx.index;
    const ctx_r322 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("formGroup", ctx_r322.stayHistoryForm.get("items")["controls"][i_r353]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r322.getTravelInfoArray(i_r353)["controls"]);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_th_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 266);
    i0.ɵɵtext(1, "i94 Number");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_24_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 262);
    i0.ɵɵelement(2, "input", 267);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const j_r361 = ctx.index;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroupName", j_r361);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 256);
    i0.ɵɵelementStart(1, "div", 261);
    i0.ɵɵtemplate(2, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_24_ng_container_2_Template, 3, 1, "ng-container", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r358 = ctx.index;
    const ctx_r324 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("formGroup", ctx_r324.stayHistoryForm.get("items")["controls"][i_r358]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r324.getTravelInfoArray(i_r358)["controls"]);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_th_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 268);
    i0.ɵɵtext(1, " Expiry Date");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_27_ng_container_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "input", 270);
    i0.ɵɵelementContainerEnd();
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_27_ng_container_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "p-calendar", 271);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const eachTravelInfo_r365 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("minDate", eachTravelInfo_r365.get("arrivalDate").value)("showIcon", true)("readonlyInput", false)("monthNavigator", true)("yearNavigator", true);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_27_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 269);
    i0.ɵɵtemplate(2, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_27_ng_container_2_ng_container_2_Template, 2, 0, "ng-container", 0);
    i0.ɵɵtemplate(3, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_27_ng_container_2_ng_container_3_Template, 2, 5, "ng-container", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const j_r366 = ctx.index;
    const i_r363 = i0.ɵɵnextContext().index;
    const ctx_r364 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroupName", j_r366);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r364.stayHistoryForm.get("items")["controls"][i_r363].get("immigrationStatusCode").value === "F1");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r364.stayHistoryForm.get("items")["controls"][i_r363].get("immigrationStatusCode").value !== "F1");
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 256);
    i0.ɵɵelementStart(1, "div", 261);
    i0.ɵɵtemplate(2, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_27_ng_container_2_Template, 4, 3, "ng-container", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r363 = ctx.index;
    const ctx_r326 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("formGroup", ctx_r326.stayHistoryForm.get("items")["controls"][i_r363]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r326.getTravelInfoArray(i_r363)["controls"]);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_th_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 272);
    i0.ɵɵtext(1, "Entry Date");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_30_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 269);
    i0.ɵɵelement(2, "p-calendar", 274);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const j_r375 = ctx.index;
    const ctx_r373 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroupName", j_r375);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("maxDate", ctx_r373.currentDate)("showIcon", true)("readonlyInput", false)("monthNavigator", true)("yearNavigator", true);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_30_Template(rf, ctx) { if (rf & 1) {
    const _r377 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 256);
    i0.ɵɵelementStart(1, "div", 261);
    i0.ɵɵtemplate(2, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_30_ng_container_2_Template, 3, 6, "ng-container", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 273);
    i0.ɵɵlistener("click", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_30_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r377); const i_r372 = ctx.index; const ctx_r376 = i0.ɵɵnextContext(4); return ctx_r376.addTravelInfo(i_r372); });
    i0.ɵɵelementStart(4, "span", 66);
    i0.ɵɵtext(5, "Add More - Entry and Exit");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r372 = ctx.index;
    const ctx_r328 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("formGroup", ctx_r328.stayHistoryForm.get("items")["controls"][i_r372]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r328.getTravelInfoArray(i_r372)["controls"]);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "addMoreEntryExitBtn-", i_r372, "");
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_th_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 275);
    i0.ɵɵtext(1, "Exit Date");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_33_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 269);
    i0.ɵɵelement(2, "p-calendar", 276);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const eachTravelInfo_r381 = ctx.$implicit;
    const j_r382 = ctx.index;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroupName", j_r382);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("minDate", eachTravelInfo_r381.get("arrivalDate").value)("showIcon", true)("readonlyInput", false)("monthNavigator", true)("yearNavigator", true);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_33_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 256);
    i0.ɵɵelementStart(1, "div", 261);
    i0.ɵɵtemplate(2, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_33_ng_container_2_Template, 3, 6, "ng-container", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r379 = ctx.index;
    const ctx_r330 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("formGroup", ctx_r330.stayHistoryForm.get("items")["controls"][i_r379]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r330.getTravelInfoArray(i_r379)["controls"]);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_th_35_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 277);
    i0.ɵɵtext(1, "Exit Reason");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_36_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 269);
    i0.ɵɵelement(2, "p-dropdown", 278);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const j_r387 = ctx.index;
    const ctx_r385 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroupName", j_r387);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("autoDisplayFirst", false)("options", ctx_r385.exitReasonList);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_36_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 256);
    i0.ɵɵelementStart(1, "div", 261);
    i0.ɵɵtemplate(2, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_36_ng_container_2_Template, 3, 3, "ng-container", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r384 = ctx.index;
    const ctx_r332 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("formGroup", ctx_r332.stayHistoryForm.get("items")["controls"][i_r384]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r332.getTravelInfoArray(i_r384)["controls"]);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_th_38_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 279);
    i0.ɵɵtext(1, "Other Reason");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_39_ng_container_2_input_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "input", 282);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_39_ng_container_2_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, " -- ");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_39_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 280);
    i0.ɵɵtemplate(2, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_39_ng_container_2_input_2_Template, 1, 0, "input", 281);
    i0.ɵɵtemplate(3, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_39_ng_container_2_span_3_Template, 2, 0, "span", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const eachTravelInfo_r391 = ctx.$implicit;
    const j_r392 = ctx.index;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroupName", j_r392);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", eachTravelInfo_r391.get("exitReason").value === "OTHER");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", eachTravelInfo_r391.get("exitReason").value !== "OTHER");
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_39_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 256);
    i0.ɵɵelementStart(1, "div", 261);
    i0.ɵɵtemplate(2, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_39_ng_container_2_Template, 4, 3, "ng-container", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r389 = ctx.index;
    const ctx_r334 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("formGroup", ctx_r334.stayHistoryForm.get("items")["controls"][i_r389]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r334.getTravelInfoArray(i_r389)["controls"]);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_th_41_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 283);
    i0.ɵɵtext(1, "Action ");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_42_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r402 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 280);
    i0.ɵɵelementStart(2, "i", 284);
    i0.ɵɵlistener("click", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_42_ng_container_2_Template_i_click_2_listener() { i0.ɵɵrestoreView(_r402); const j_r399 = ctx.index; const i_r396 = i0.ɵɵnextContext().index; const ctx_r400 = i0.ɵɵnextContext(4); return ctx_r400.deleteRow(i_r396, j_r399); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const j_r399 = ctx.index;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroupName", j_r399);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_42_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 256);
    i0.ɵɵelementStart(1, "div", 261);
    i0.ɵɵtemplate(2, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_42_ng_container_2_Template, 3, 1, "ng-container", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r396 = ctx.index;
    const ctx_r336 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("formGroup", ctx_r336.stayHistoryForm.get("items")["controls"][i_r396]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r336.getTravelInfoArray(i_r396)["controls"]);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_tr_43_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 98);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_tr_44_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 285);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_div_45_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 286);
    i0.ɵɵtext(1, "No record found");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_button_58_Template(rf, ctx) { if (rf & 1) {
    const _r405 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 212);
    i0.ɵɵlistener("click", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_button_58_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r405); const ctx_r404 = i0.ɵɵnextContext(4); return ctx_r404.cancelHistory(); });
    i0.ɵɵelementStart(1, "span", 23);
    i0.ɵɵtext(2, "Cancel");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r407 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 214);
    i0.ɵɵelementStart(1, "div", 214);
    i0.ɵɵelementStart(2, "label", 215);
    i0.ɵɵtext(3, " U.S. Stay History");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_div_4_Template, 6, 0, "div", 216);
    i0.ɵɵelementStart(5, "div", 217);
    i0.ɵɵelementStart(6, "form", 218);
    i0.ɵɵelementContainerStart(7, 219);
    i0.ɵɵelementStart(8, "div", 220);
    i0.ɵɵelementStart(9, "table", 221);
    i0.ɵɵelementContainerStart(10, 222);
    i0.ɵɵtemplate(11, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_th_11_Template, 2, 0, "th", 223);
    i0.ɵɵtemplate(12, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_12_Template, 2, 3, "td", 224);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(13, 225);
    i0.ɵɵtemplate(14, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_th_14_Template, 2, 0, "th", 226);
    i0.ɵɵtemplate(15, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_15_Template, 2, 2, "td", 224);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(16, 227);
    i0.ɵɵtemplate(17, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_th_17_Template, 2, 0, "th", 228);
    i0.ɵɵtemplate(18, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_18_Template, 3, 2, "td", 224);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(19, 229);
    i0.ɵɵtemplate(20, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_th_20_Template, 2, 0, "th", 230);
    i0.ɵɵtemplate(21, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_21_Template, 3, 2, "td", 224);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(22, 231);
    i0.ɵɵtemplate(23, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_th_23_Template, 2, 0, "th", 232);
    i0.ɵɵtemplate(24, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_24_Template, 3, 2, "td", 224);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(25, 233);
    i0.ɵɵtemplate(26, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_th_26_Template, 2, 0, "th", 234);
    i0.ɵɵtemplate(27, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_27_Template, 3, 2, "td", 224);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(28, 235);
    i0.ɵɵtemplate(29, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_th_29_Template, 2, 0, "th", 236);
    i0.ɵɵtemplate(30, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_30_Template, 6, 3, "td", 224);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(31, 237);
    i0.ɵɵtemplate(32, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_th_32_Template, 2, 0, "th", 238);
    i0.ɵɵtemplate(33, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_33_Template, 3, 2, "td", 224);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(34, 239);
    i0.ɵɵtemplate(35, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_th_35_Template, 2, 0, "th", 240);
    i0.ɵɵtemplate(36, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_36_Template, 3, 2, "td", 224);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(37, 241);
    i0.ɵɵtemplate(38, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_th_38_Template, 2, 0, "th", 242);
    i0.ɵɵtemplate(39, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_39_Template, 3, 2, "td", 224);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(40, 243);
    i0.ɵɵtemplate(41, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_th_41_Template, 2, 0, "th", 244);
    i0.ɵɵtemplate(42, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_td_42_Template, 3, 2, "td", 224);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵtemplate(43, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_tr_43_Template, 1, 0, "tr", 59);
    i0.ɵɵtemplate(44, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_tr_44_Template, 1, 0, "tr", 245);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(45, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_div_45_Template, 2, 0, "div", 246);
    i0.ɵɵelementStart(46, "div", 247);
    i0.ɵɵelementStart(47, "button", 248);
    i0.ɵɵlistener("click", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_Template_button_click_47_listener() { i0.ɵɵrestoreView(_r407); const ctx_r406 = i0.ɵɵnextContext(3); return ctx_r406.AddNewRow(); });
    i0.ɵɵelementStart(48, "span", 249);
    i0.ɵɵtext(49, "Add More");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(50, "div", 113);
    i0.ɵɵelement(51, "hr");
    i0.ɵɵelementStart(52, "div", 114);
    i0.ɵɵelementStart(53, "div", 250);
    i0.ɵɵelementStart(54, "button", 20);
    i0.ɵɵlistener("click", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_Template_button_click_54_listener() { i0.ɵɵrestoreView(_r407); const ctx_r408 = i0.ɵɵnextContext(3); return ctx_r408.saveStayHistory(); });
    i0.ɵɵelementStart(55, "span", 21);
    i0.ɵɵtext(56, "Save");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(57, "div", 115);
    i0.ɵɵtemplate(58, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_button_58_Template, 3, 0, "button", 118);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(59, "hr");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r41 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", ctx_r41.hasID ? "" : "notAllowedDiv");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r41.hasID ? "" : "notAllowed");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r41.visa.hasTravelToUs);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("hidden", !ctx_r41.visa.hasTravelToUs);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroup", ctx_r41.stayHistoryForm);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("dataSource", ctx_r41.stayHistoryDataSource);
    i0.ɵɵadvance(34);
    i0.ɵɵproperty("matHeaderRowDef", ctx_r41.stayHistoryDisplayedColumns);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRowDefColumns", ctx_r41.stayHistoryDisplayedColumns);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r41.stayHistoryDataSource && ctx_r41.stayHistoryDataSource.data.length == 0);
    i0.ɵɵadvance(13);
    i0.ɵɵproperty("ngIf", !ctx_r41.modeVal);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-tab");
    i0.ɵɵtemplate(1, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_ng_template_1_Template, 2, 0, "ng-template", 2);
    i0.ɵɵelementStart(2, "div", 37);
    i0.ɵɵtemplate(3, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_label_3_Template, 3, 0, "label", 38);
    i0.ɵɵtemplate(4, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_button_4_Template, 3, 0, "button", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_5_Template, 12, 10, "div", 40);
    i0.ɵɵelementStart(6, "div", 41);
    i0.ɵɵelementStart(7, "div", 42);
    i0.ɵɵtemplate(8, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_i_8_Template, 1, 0, "i", 43);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_9_Template, 42, 18, "div", 44);
    i0.ɵɵtemplate(10, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_div_10_Template, 60, 10, "div", 45);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hidden", ctx_r4.isAddVisaVisible);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.dataSource.data.length == 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.updateBenProfile && !ctx_r4.viewMode && ctx_r4.showEditButton);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.dataSource.data.length > 0 && !ctx_r4.isAddVisaVisible);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("hidden", !ctx_r4.isAddVisaVisible);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r4.showEditButton && ctx_r4.neverAppliedFlag === "Yes");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.beneficiaryId);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.visa.outcomeIdCode === "VSAAPP" && (ctx_r4.iscaseRequest ? ctx_r4.currentItemDisplay.includes("USSTAYHIST") ? true : false : true));
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_10_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 295);
    i0.ɵɵtext(1, "Documents");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_10_Template(rf, ctx) { if (rf & 1) {
    const _r411 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-tab", 287);
    i0.ɵɵtemplate(1, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_10_ng_template_1_Template, 2, 0, "ng-template", 2);
    i0.ɵɵelementStart(2, "div", 288);
    i0.ɵɵelementStart(3, "div", 289);
    i0.ɵɵelementStart(4, "p", 290);
    i0.ɵɵelementStart(5, "b", 291);
    i0.ɵɵtext(6, "Upload supporting documents");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 292);
    i0.ɵɵelementStart(8, "div", 293);
    i0.ɵɵelementStart(9, "file-upload-deafult-library", 294);
    i0.ɵɵlistener("fileUploadSuccess", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_10_Template_file_upload_deafult_library_fileUploadSuccess_9_listener() { i0.ɵɵrestoreView(_r411); const ctx_r410 = i0.ɵɵnextContext(2); return ctx_r410.fileUploadSuccess(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", !ctx_r5.configurations.entityId);
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("configurations", ctx_r5.configurations);
} }
function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r413 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-tab-group", 1);
    i0.ɵɵlistener("selectedTabChange", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_Template_mat_tab_group_selectedTabChange_1_listener($event) { i0.ɵɵrestoreView(_r413); const ctx_r412 = i0.ɵɵnextContext(); return ctx_r412.onTabChanged($event); });
    i0.ɵɵelementStart(2, "mat-tab");
    i0.ɵɵtemplate(3, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_ng_template_3_Template, 2, 0, "ng-template", 2);
    i0.ɵɵelementStart(4, "form", 3, 4);
    i0.ɵɵlistener("click", function GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_Template_form_click_4_listener() { i0.ɵɵrestoreView(_r413); const _r2 = i0.ɵɵreference(5); const ctx_r414 = i0.ɵɵnextContext(); return ctx_r414.trackNonImmigrantVisaForm(_r2); });
    i0.ɵɵelementStart(6, "h6", 5);
    i0.ɵɵtext(7, " Immigrant/Non-Immigrant Visa Info");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_div_8_Template, 25, 5, "div", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_9_Template, 11, 8, "mat-tab", 0);
    i0.ɵɵtemplate(10, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_mat_tab_10_Template, 10, 2, "mat-tab", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disablePagination", true);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngIf", ctx_r0.showEditButton);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.neverAppliedFlag === "Yes");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.neverAppliedFlag === "Yes");
} }
class GenericBeneficiaryImmigrationDetailsLibraryComponent {
    constructor(cacheCountryService, changeDetectorRef, referenceLibraryService, apiService, 
    // private authenticationService: AuthenticationService,
    toastr, dialog, route, store, fb) {
        this.cacheCountryService = cacheCountryService;
        this.changeDetectorRef = changeDetectorRef;
        this.referenceLibraryService = referenceLibraryService;
        this.apiService = apiService;
        this.toastr = toastr;
        this.dialog = dialog;
        this.route = route;
        this.store = store;
        this.fb = fb;
        this.modeVal = false;
        this.iscaseRequest = false;
        this.currentItemDisplay = [];
        this.showEditButton = true;
        this.updateBenProfile = true; // Edit permission
        this.beneficiaryId = 0;
        this.expandPanel = false;
        this.immiexpandPanel = false; // need for expanding on add / Edit button
        this.isTimeLineView = true;
        this.isListView = false;
        this.immigrationData = [];
        this.hasID = false;
        this.isLinear = true;
        this.formerrors = { arivalDateError: false, exitDateError: false, combination: false, errors: [], combinations: false, validityStartDateError: false, validityEndDateError: false };
        this.visaDateDetails = { startDate: '', expDate: '' };
        // showPetitionTypeDropdown: boolean = true;
        this.isCurrentlyUSChecked = false;
        this.indicatingMandatoryField = false;
        this.isDepatureChecked = false;
        this.listUploadedFiles = [];
        this.viewMode = false;
        /* IM-4320 : Current immigration details overrides the past immigration info */
        this.isEditVisaDetails = false;
        this.destroy$ = new Subject();
        /* IM-5015 Sevis No */
        this.isVisaTypeF1 = false;
        this.isBenQuestShowDivs = false;
        // Travel History
        this.isTravelHistoryValid = true;
        this.displayedColumnsForTravelInfo = [];
        this.columnsTravelInfo = [
            { columnDef: 'meansOfTravel', header: 'Mode Of Travel', columnType: 'text', customClass: '' },
            { columnDef: 'portOfEntry', header: 'Port', columnType: 'text', customClass: '' },
            { columnDef: 'arrivalDate', header: 'Arrival Date', columnType: 'text', customClass: '' },
            { columnDef: 'i94Number', header: 'I94 Number', columnType: 'text', customClass: '' },
            { columnDef: 'i94ExpiryDate', header: 'I94 Expiry Date', columnType: 'text', customClass: '' },
            { columnDef: 'exitDate', header: 'Exit Date', columnType: 'text', customClass: '' },
            { columnDef: 'action', header: 'Action', columnType: 'icon', customClass: '' }
        ];
        this.travelHistory = new TravelHistory({
            arrivalDate: '',
            arrivalCountryCode: '',
            arrivalStateProvinceCode: '',
            arrivalStateProvinceName: '',
            arrivalCity: '',
            exitDate: '',
            effectiveStartDate: '',
            effectiveEndDate: '',
            i94ExpiryDate: '',
            i94Number: null,
            // durationOfStatus: null,
            id: 0,
            isCurrentlyInUS: false,
            meansOfTravel: '',
            portOfEntry: ''
        });
        this.displayedColumns = [];
        this.columns = [
            { columnDef: 'toggle', header: '', columnType: 'toggleicon', customClass: '' },
            { columnDef: 'immigrationStatusCode', header: 'Visa', columnType: 'text', customClass: '' },
            { columnDef: 'petitionTypeCode', header: 'Petition', columnType: 'text', customClass: '' },
            { columnDef: 'companyName', header: 'Petitioner Name', columnType: 'text', customClass: '' },
            { columnDef: 'visaStatus', header: 'Visa Status', columnType: 'text', customClass: '' },
            { columnDef: 'noticeNo', header: 'Receipt Number', columnType: 'text', customClass: '' },
            { columnDef: 'receiptDate', header: 'Receipt Date', columnType: 'text', customClass: '' },
            { columnDef: 'action', header: 'Action', columnType: 'icon', customClass: '' }
        ];
        // Documents Upload
        this.configurations = {
            inputMultipleFlag: true,
            fileType: acceptedFileTypes,
            isFileListRequired: true,
            categoryName: 'BENIMMDOC',
            entityId: 0,
            fileCategory: '',
            listUploadedFiles: [],
            documentTypeRequired: true,
            docummentTypeCode: 'BENIMMDOC',
            useCase: 'beneficiary',
            useCaseId: 0,
            useEntityId: false,
            familyId: null
        };
        this.observableSubscription$ = new Subject();
        // showLifeStoryTimeLineSection: boolean;
        this.listCountry = [];
        this.listStates = [];
        this.isSaveAsDraftDisabled = true;
        this.isLocked = false;
        this.listArrivalCountry = [];
        this.isAddVisaVisible = false;
        this.stayHistoryDisplayedColumns = ['meansOfTravel', 'portOfEntry', 'immigrationStatusCode', 'petitionTypeCode', 'i94Number', 'i94ExpiryDate', 'arrivalDate', 'exitDate', 'exitReason', 'otherReason', 'action'];
        this.stayHistoryDataSource = new MatTableDataSource();
        this.isEditableNew = true;
        this.currentDate = new Date();
        debugger;
        this.stayHistoryForm = this.fb.group({
            items: this.fb.array([])
        });
        this.isExternalEmployeeId = sessionStorage.getItem('_isExternalEmployeeId');
        if (this.isExternalEmployeeId) {
            this.isLocked = true;
        }
        debugger;
        this.beneficiaryId = (sessionStorage.getItem('listBeneficiaryId')) ? parseInt(sessionStorage.getItem('listBeneficiaryId')) : this.apiService.currentUserValue['beneficiaryId'];
        this.resetImmigration();
        this.visaMeta = new VisaMeta({
            alienRegNo: null,
            hasAlienRegnNo: false,
            hasNonImmVisa: null
        });
        const request1 = this.referenceLibraryService.getReferenceDataWithoutAuthentication('PETTYP');
        const request2 = this.referenceLibraryService.getReferenceDataWithoutAuthentication('IMMSTAT');
        const request3 = this.referenceLibraryService.getReferenceDataWithoutAuthentication('VSAOUT');
        const request4 = this.referenceLibraryService.getReferenceDataWithoutAuthentication('REASONTYP');
        forkJoin([request1, request2, request3, request4]).subscribe(([response1, response2, response3, response4]) => {
            Promise.all([
                this.referenceLibraryService.translateArray(response1, 'name'),
                this.referenceLibraryService.translateArray(response2, 'name'),
                this.referenceLibraryService.translateArray(response3, 'name'),
                this.referenceLibraryService.translateArray(response4, 'name')
            ])
                .then(([translatedPetition, translatedVisa, translatedOutcome, translatedExit]) => {
                this.petitionTypeList = translatedPetition;
                this.visaTypeList = translatedVisa;
                this.outcomeTypeList = translatedOutcome;
                this.exitReasonList = translatedExit;
                this.getVisaDetails();
                this.getVisaMetaInfo();
                this.getUsStayHistory();
            })
                .catch(error => console.error("Translation error:", error));
        });
        this.today = new Date();
        this.formChangesSubscriptions = [];
    }
    set inputData(val) {
        this._inputData = this.primaryData || val;
        this.configurations.familyId = val.familyId;
        this.familyId = val.familyId;
        if (this.familyId) {
            sessionStorage.setItem('dependentId', this.familyId);
        }
        this.beneficiaryId = sessionStorage.getItem('beneficiaryId') ? parseInt(sessionStorage.getItem('beneficiaryId')) : 0;
        this.getVisaDetails();
        this.getVisaMetaInfo();
        this.getUsStayHistory();
    }
    get inputData() {
        return this._inputData;
    }
    ngOnInit() {
        this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
        this.viewMode = sessionStorage.getItem('bene-profile-viewMode') == 'true' ? true : false;
        this.apiService.currentUser.pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
            if (sessionStorage.getItem('userTypeRole') === RolesRouteMap.ATTORNEY || sessionStorage.getItem('userTypeRole') === RolesRouteMap.PETITIONER) {
                this.updateBenProfile = this.apiService.checkBeneEditPermission();
                this.viewMode = !this.updateBenProfile;
            }
            this.envPath = environment.docs;
        });
        this.envPath = environment.docs;
        this.dependentIdSubscription = this.apiService.dependentProfileSubject.subscribe(selectedBeneObj => {
            this.familyId = selectedBeneObj.dependentId;
            this.beneficiaryType = selectedBeneObj.beneficiaryType;
            this.showLifeStoryTimeLineSection = (this.beneficiaryType === 'family' && this.familyId) ? true : (this.beneficiaryType === 'self') ? true : false;
            if (this.isBenQuestShowDivs && sessionStorage.getItem('isCaseRequest')) {
                if (this.beneficiaryType === 'self') {
                    this.iscaseRequest = true;
                }
                else {
                    this.iscaseRequest = false;
                }
            }
            this.getVisaDetails();
            this.getVisaMetaInfo();
            this.getUsStayHistory();
            //this.getLicense();
        });
        this.showEditButton = !this.apiService.checkValidity();
        this.apiService.onLifeStorySubTabs.next();
        // this.familyId= sessionStorage.getItem('dependentId') ? parseInt(sessionStorage.getItem('dependentId')):null;
        // IM-3066 - remove deleted file.
        this.apiService.deletedfile$.pipe(takeUntil(this.observableSubscription$)).subscribe(status => {
            if (status === true) {
                this.getUpolodedFiles();
            }
        });
        this.cacheCountryService.getCachedCountryList().subscribe(data => {
            if (data.listCountries.length > 0) {
                this.listCountry = data.listCountries;
                this.listArrivalCountry = [{ countryCode: '', countryName: 'Select', labelWithCode: 'Select', phoneCode: '' }, ...this.listCountry];
            }
        });
        this.selectedUser = JSON.parse(localStorage.getItem('currentUserSelection'));
        this.customQuestions = JSON.parse(localStorage.getItem('customQuestions'));
        // this.onLoadCreateForm()
        // this.getUsStayHistory();
    }
    refreshView() {
        this.translet();
    }
    onLoadCreateForm() {
        const itemsArray = this.stayHistoryForm.get('items');
        let travelInfoArray = this.fb.array([]);
        travelInfoArray.push(this.fb.group({
            id: [0],
            arrivalDate: [null, Validators.required],
            exitDate: [null, Validators.required],
            exitReason: ['', Validators.required],
            otherReason: [''],
            i94Number: [''],
            i94ExpiryDate: [''],
            durationOfStatus: [null],
            meansOfTravel: [''],
            portOfEntry: ['']
        }));
        itemsArray.push(this.fb.group({
            id: [null],
            immigrationStatusCode: ['', Validators.required],
            petitionTypeCode: ['', Validators.required],
            travelInfo: travelInfoArray || []
        }));
        this.stayHistoryDataSource = new MatTableDataSource(this.stayHistoryForm.get('items').controls);
        this.translet();
    }
    visaFormCheck(visaDetailsForm) {
        var _a;
        this.visaDetailsForm = visaDetailsForm;
        if (!this.formChangesSubscriptions[0]) {
            this.formChangesSubscriptions[0] = visaDetailsForm.statusChanges.pipe(takeUntil(this.observableSubscription$)).subscribe(() => {
                if (visaDetailsForm.dirty) {
                    this.store.dispatch(new MarkDirtyFormAction({
                        dirty: true,
                        message: 'If you leave before saving, all changes made on the \'Visa Details\' section of the \'Beneficiary Immigration\' form will be lost. Do you wish to continue?'
                    }));
                }
                else {
                    this.store.dispatch(new MarkCleanFormAction({
                        dirty: false,
                        message: ''
                    }));
                }
            });
        }
        if (!this.formChangesSubscriptions[1]) {
            this.formChangesSubscriptions[1] = (_a = this.visaDetailsForm.valueChanges) === null || _a === void 0 ? void 0 : _a.pipe(takeUntil(this.observableSubscription$)).subscribe((formValue) => {
                this.isSaveAsDraftDisabled = !Object.values(formValue).some((val) => !!val || val === 0);
            });
        }
    }
    trackTravelHisFormChange(travelHistoryForm) {
        // window.alert("in ,travelHistoryForm")
        if (!this.formChangesSubscriptions[1]) {
            this.formChangesSubscriptions[1] = travelHistoryForm.statusChanges.pipe(takeUntil(this.observableSubscription$)).subscribe(() => {
                // window.alert("subs ,travelHistoryForm")
                if (travelHistoryForm.dirty) {
                    this.store.dispatch(new MarkDirtyFormAction({
                        dirty: true,
                        message: 'If you leave before saving, all changes made on the \'U.S travel history\' section of the \'Beneficiary Immigration\'form will be lost. Do you wish to continue?'
                    }));
                }
                else {
                    this.store.dispatch(new MarkCleanFormAction({
                        dirty: false,
                        message: ''
                    }));
                }
            });
        }
    }
    trackNonImmigrantVisaForm(nonImmigrantVisForm) {
        // window.alert("in ,travelHistoryForm")
        if (!this.formChangesSubscriptions[3]) {
            this.formChangesSubscriptions[3] = nonImmigrantVisForm.statusChanges.pipe(takeUntil(this.observableSubscription$)).subscribe(() => {
                // window.alert("subs ,travelHistoryForm")
                if (nonImmigrantVisForm.dirty) {
                    this.store.dispatch(new MarkDirtyFormAction({
                        dirty: true,
                        message: 'If you leave before saving, all changes made on the \'Non-Immigrant Visa Info\' section of the \'Beneficiary Immigration\'form will be lost. Do you wish to continue?'
                    }));
                }
                else {
                    this.store.dispatch(new MarkCleanFormAction({
                        dirty: false,
                        message: ''
                    }));
                }
            });
        }
    }
    // IM-3066 - remove deleted file.
    getUpolodedFiles() {
        this.apiService.genericGetUploadDocument(this.configurations.useCase, this.configurations.useCaseId, this.configurations.categoryName, this.configurations.entityId, this.configurations.useEntityId, this.configurations.familyId).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response['status'] === 200) {
                this.listUploadedFiles = response['data'];
                this.configurations.listUploadedFiles = response['data'];
                this.configurations = Object.assign({}, this.configurations);
            }
            else {
                this.listUploadedFiles = [];
                this.configurations.listUploadedFiles = [];
            }
        });
    }
    visaValidityStartChange() {
        const minVisaEndDate = new Date(this.visa.validityStartDate);
        this.minVisaValidityEndDate = new Date(minVisaEndDate.setDate(minVisaEndDate.getDate() + 1));
        if (this.visa.validityStartDate < this.visa.receiptDate) {
            this.validityConfirmationDialog = true;
        }
    }
    visaIssueDateChange() {
        const minVisaExpirationDate = new Date(this.visa.visaIssueDate);
        this.minVisaExpirationDate = new Date(minVisaExpirationDate.setDate(minVisaExpirationDate.getDate() + 1));
    }
    onValidtion(param) {
        if (param) {
            this.validityConfirmationDialog = false;
        }
        else {
            this.visa.validityStartDate = this.visa.receiptDate;
            this.validityConfirmationDialog = false;
        }
    }
    getVisaDetails() {
        if (sessionStorage.getItem('newFamilyId')) {
            this.familyId = sessionStorage.getItem('newFamilyId');
        }
        if (sessionStorage.getItem('dependentId')) {
            this.familyId = sessionStorage.getItem('dependentId');
        }
        this.apiService.getVisaDetails(this.beneficiaryId, this.familyId).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response.status === 200) {
                // Update visa status from ref library
                (response.data).map((item) => {
                    item.visaStatus = this.outcomeTypeList.find(x => x.code === item.outcomeIdCode) ? this.outcomeTypeList.find(x => x.code === item.outcomeIdCode).name : '';
                    item.receiptDate = item.receiptDate ? moment(item.receiptDate).format('DD-MMM-YYYY') : '';
                });
                this.immigrationData = response.data ? response.data : [];
                // Assign the data to the data source for the table to render
                this.dataSource = new MatTableDataSource(response.data);
                this.translet();
            }
            if (response.status === 204) {
                // Assign the data to the data source for the table to render
                // IM-2570
                this.immigrationData = [];
                this.dataSource = new MatTableDataSource([]);
            }
            this.dataSource.paginator = this.paginator;
            if (!this.isListView && this.route.snapshot.paramMap.get('listview')) {
                this.toggleListView(true);
            }
        });
    }
    getVisaMetaInfo() {
        if (sessionStorage.getItem('newFamilyId')) {
            this.familyId = sessionStorage.getItem('newFamilyId');
        }
        if (sessionStorage.getItem('dependentId')) {
            this.familyId = sessionStorage.getItem('dependentId');
        }
        this.apiService.getVisaMetaInfo(this.beneficiaryId, this.familyId).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response.status === 200) {
                this.visaMeta.alienRegNo = response.data['alienRegNo'];
                if (response.data['hasAlienRegnNo'] !== null) {
                    // Uncheck chkbox if the user dont have alien Reg Num
                    this.visaMeta.hasAlienRegnNo = response.data['hasAlienRegnNo'] === 0 ? true : false;
                }
                else {
                    this.visaMeta.hasAlienRegnNo = null;
                }
                if (response.data['hasNonImmVisa'] !== null) {
                    this.visaMeta.hasNonImmVisa = response.data['hasNonImmVisa'] === 1 ? true : false;
                    this.neverAppliedFlag = response.data['hasNonImmVisa'] === 1 ? 'Yes' : 'No';
                }
                else {
                    this.visaMeta.hasNonImmVisa = null;
                    this.neverAppliedFlag = null;
                }
                this.handleToggle();
                this.translet();
            }
        });
    }
    toggleExpansion() {
        this.isAddVisaVisible = true;
        this.immiexpandPanel = !this.immiexpandPanel;
        if (this.immiexpandPanel) {
            this.resetImmigration();
            this.hasID = false;
            this.isLinear = true;
        }
        this.translet();
    }
    onTabChanged(event) {
        console.log('event', event);
        this.isAddVisaVisible = false;
        this.translet();
    }
    tabChange() {
        this.translet();
    }
    saveVisaDetails(visaDetailsForm, isDraft = false) {
        const payload = Object.assign({}, this.visa);
        payload.beneficiaryId = this.beneficiaryId;
        payload.companyId = 0;
        payload['isSaveAsDraft'] = isDraft;
        /* IM-4320 : Current immigration details overrides the past immigration info */
        if (this.isEditVisaDetails === false) {
            payload.id = 0;
        }
        if (this.isEditVisaDetails === false && this.visa.id) { // IM 4736
            payload.id = this.visa.id;
        }
        payload.isEadNo = this.visa.isEadNo ? 1 : 0;
        payload.isSevisNo = this.visa.isSevisNo ? 1 : 0;
        payload.outcomeDate = this.visa.outcomeDate ? moment(this.visa.outcomeDate).format('YYYY-MM-DD') : null;
        payload.receiptDate = this.visa.receiptDate ? moment(this.visa.receiptDate).format('YYYY-MM-DD') : null;
        payload.validityStartDate = this.visa.validityStartDate ? moment(this.visa.validityStartDate).format('YYYY-MM-DD') : null;
        payload.validityEndDate = this.visa.validityEndDate ? moment(this.visa.validityEndDate).format('YYYY-MM-DD') : null;
        payload.hasTravelToUs = this.visa.hasTravelToUs ? true : false;
        // IM-3831 : Add  'Not Applicable'
        payload.petitionTypeCode = (this.visa.petitionTypeCode == 'null') ? null : this.visa.petitionTypeCode;
        payload.visaStamping = this.visa.visaStamping ? true : false;
        payload.visaIssueDate = this.visa.visaIssueDate ? moment(this.visa.visaIssueDate).format('YYYY-MM-DD') : null;
        payload.visaExpirationDate = this.visa.visaExpirationDate ? moment(this.visa.visaExpirationDate).format('YYYY-MM-DD') : null;
        this.apiService.saveVisaDetailsInfo(this.beneficiaryId, payload, this.familyId).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            this.toastr.success(response.message, 'Success');
            this.visa.id = response.data.id || 0; // IM 4736
            visaDetailsForm.reset(visaDetailsForm.value); // fix reset
            this.getVisaDetails(); // Relaod main table
            this.loadVisaDetails(response.data);
            this.configurations.useCaseId = this.beneficiaryId;
            this.configurations.entityId = this.visa ? this.visa.id : null;
            this.configurations.familyId = this.familyId ? this.familyId : null;
            this.configurations.listUploadedFiles = [];
            this.configurations = Object.assign({}, this.configurations);
            this.hasID = true;
            this.isLinear = false;
            // this.isCurrentlyUSChecked = this.visa.currentlyStayInUS ? true : false;
            this.getUsStayHistory();
            // this.getImmigrationTravelInfo();
            //   // Refresh the form
            //   this.travelHistoryForm.resetForm({});
            //   // travelHistoryForm.form.reset();  //I94 Expiry Date field validation remove
            //   this.travelHistory = new TravelHistory({
            //     arrivalDate: '',
            //     arrivalCountryCode: '',
            //     arrivalStateProvinceCode: '',
            //     arrivalStateProvinceName:'',
            //     arrivalCity: '',
            //     exitDate: '',
            //     effectiveStartDate: '',
            //     effectiveEndDate: '',
            //     i94ExpiryDate: '',
            //     i94Number: null,
            //     id: 0,
            //     isCurrentlyInUS: false,
            //     meansOfTravel: '',
            //     portOfEntry: ''
            //   });
            // this.loadTravelInfo(this.travelInfoDataSource.data as []);
        });
    }
    loadVisaDetails(input) {
        input.receiptDate = input.receiptDate ? moment(input.receiptDate).toISOString() : '';
        input.outcomeDate = input.outcomeDate ? moment(input.outcomeDate).toISOString() : '';
        input.validityEndDate = input.validityEndDate ? moment(input.validityEndDate).toISOString() : '';
        input.validityStartDate = input.validityStartDate ? moment(input.validityStartDate).toISOString() : '';
        input.outcomeDate = input.outcomeDate ? moment(input.outcomeDate).toISOString() : '';
        input.visaStamping = input.visaStamping ? input.visaStamping : false;
        input.visaIssueDate = input.visaIssueDate ? moment(input.visaIssueDate).toISOString() : '';
        input.visaExpirationDate = input.visaExpirationDate ? moment(input.visaExpirationDate).toISOString() : '';
        this.visa = input;
        this.visa.isEadNo = input.isEadNo === 1 ? true : false;
        this.visa.isSevisNo = input.isSevisNo === 1 ? true : false;
        this.visaDateDetails.startDate = input.validityStartDate;
        this.visaDateDetails.expDate = input.validityEndDate;
        this.min = new Date(this.visaDateDetails.startDate);
        this.max = new Date(this.visaDateDetails.expDate);
        // this.isCurrentlyUSChecked = this.visa.currentlyStayInUS ? true : false;
        if (this.visa.immigrationStatusCode) {
            const visaType = this.visa.immigrationStatusCode;
            this.handleVisaTypeChange(visaType, this.immvisaDetailsForm);
            // this.showPetitionTypeDropdown = (visaType === 'H4' || visaType === 'F1' || visaType === 'B1' || visaType === 'B2' || visaType === 'L2') ? false : true;
        }
        this.translet();
    }
    handleToggle() {
        if (this.neverAppliedFlag !== null) {
            this.expandPanel = this.neverAppliedFlag === 'Yes' ? true : false;
            this.visaMeta.hasNonImmVisa = this.neverAppliedFlag === 'Yes' ? true : false;
        }
        else {
            this.expandPanel = false;
            this.visaMeta.hasNonImmVisa = null;
        }
        this.translet();
    }
    handleToggleHasTravelToUs() {
        if (this.visa.id && !this.visa.hasTravelToUs) {
            const message = 'Changing the answer from \'Yes\' to \'No\' will result in removal of Stay history details, if available. Are you sure you want to proceed with this? ';
            this.confirmationPopup(this.visa, message, 'hasTravelToUs');
        }
    }
    handleToggleArrivalDate(val) {
        if (val) {
            this.travelHistory.arrivalDate = '';
            this.travelHistory.meansOfTravel = '';
            this.travelHistory.portOfEntry = '';
        }
        else {
            this.travelHistory.effectiveStartDate = '';
        }
    }
    handleToggleDepartureDate(val) {
        if (val) {
            this.travelHistory.effectiveEndDate = '';
        }
        else {
            this.travelHistory.exitDate = '';
        }
    }
    updateCurrentlyUS() {
        this.isCurrentlyUSChecked = this.visa.currentlyStayInUS ? true : false;
    }
    eadUpdate() {
        this.visa.eadNo = '';
    }
    sevisUpdate() {
        this.visa.sevisNo = '';
    }
    updateAlienNo() {
        this.visaMeta.alienRegNo = '';
    }
    saveVisaMetaInfo(nonImmigrantVisForm) {
        const payload = Object.assign({}, this.visaMeta);
        payload.hasAlienRegnNo = payload.hasAlienRegnNo ? 0 : 1;
        payload.hasNonImmVisa = payload.hasNonImmVisa ? 1 : 0;
        this.apiService.saveVisaMetaInfo(this.beneficiaryId, payload, this.familyId).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (this.beneficiaryType === 'self') {
                if (this.customQuestionsComponent) {
                    this.customQuestionsComponent.onClickSave(null);
                }
            }
            else {
                if (this.customQuestionsComponent) {
                    this.customQuestionsComponent.onClickSave(this.familyId);
                }
            }
            this.getVisaDetails();
            nonImmigrantVisForm.reset(nonImmigrantVisForm.value);
            this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
            this.toastr.success(response.message, 'Success');
        });
        // this.customTriggeredStatus == false ? this.customTriggeredStatus = true: this.customTriggeredStatus = false;
    }
    cancelVisaMetaInfo(nonImmigrantVisForm) {
        this.visaMeta.hasAlienRegnNo = null;
        this.neverAppliedFlag = null;
        nonImmigrantVisForm.reset();
        this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
    }
    editImmigration(input) {
        this.currentItemEdit = input;
        /* IM-4320 : Current immigration details overrides the past immigration info */
        this.isAddVisaVisible = true;
        this.isEditVisaDetails = true;
        this.immiexpandPanel = true;
        this.expandPanel = true;
        this.resetValidation();
        this.loadVisaDetails(Object.assign({}, input));
        this.loadTravelInfo(Object.assign([], input.travelInfo));
        this.loadDocuments(Object.assign([], input.documentList));
        this.hasID = true;
        this.isLinear = false;
        // IM-4040-need visa validity start date to resctict min of end date on edit
        this.visaValidityStartChange();
    }
    deleteImmigration(input) {
        const title = 'Confirm';
        const message = 'Do you wish to remove this item?';
        const buttons = ['Cancel', 'Delete'];
        this.dialogueInitializer(event, title, message, buttons).afterClosed().subscribe(result => {
            if (result) {
                this.apiService.deleteImmigration(this.beneficiaryId, input.id, this.familyId).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                    if (response.status === 200) {
                        if (this.visa.id === input.id) {
                            this.resetImmigration();
                        }
                        this.toastr.success(response.message, 'Success');
                        this.getVisaDetails(); // Relaod main table
                    }
                });
            }
        });
    }
    onRefreshPage(event) {
        if (event) {
            this.ngOnInit();
        }
    }
    confirmationPopup(input, message, field) {
        const title = 'Confirm';
        const buttons = ['No', 'Yes'];
        this.dialogueInitializer(event, title, message, buttons).afterClosed().subscribe(result => {
            if (result) {
                //  IM-3831 : For able to save visa details
                this.immvisaDetailsForm.resetForm();
                this.visa.currentlyStayInUS = false;
                this.resetOutcomeIdField();
            }
            else {
                if (field === 'hasTravelToUs') {
                    this.visa.hasTravelToUs = true;
                }
                else {
                    this.visa.outcomeIdCode = 'VSAAPP';
                }
            }
            this.translet();
        });
    }
    outcomeCodeIdChange() {
        var _a, _b, _c, _d;
        if (this.visa.id && this.visa.outcomeIdCode !== 'VSAAPP') {
            const message = 'Changing the outcome will result in removal of Stay history details, if available. Are you sure you want to proceed with this?';
            this.confirmationPopup(this.visa, message, 'outcomeIdCode');
        }
        else {
            //  IM-3831 : For able to save visa details
            if (this.visaDetailsForm) {
                this.visaDetailsForm.resetForm({
                    companyName: (_a = this.visaDetailsForm.value) === null || _a === void 0 ? void 0 : _a.companyName,
                    immigrationStatusCode: (_b = this.visaDetailsForm.value) === null || _b === void 0 ? void 0 : _b.immigrationStatusCode,
                    petitionTypeCode: (_c = this.visaDetailsForm.value) === null || _c === void 0 ? void 0 : _c.petitionTypeCode,
                    outcome: (_d = this.visaDetailsForm.value) === null || _d === void 0 ? void 0 : _d.outcome
                });
            }
            this.visa.currentlyStayInUS = false;
            // Refresh the form
            if (this.travelHistoryForm) {
                this.travelHistoryForm.resetForm({});
            }
            this.travelHistory = new TravelHistory({
                arrivalDate: '',
                arrivalCountryCode: '',
                arrivalStateProvinceCode: '',
                arrivalStateProvinceName: '',
                arrivalCity: '',
                exitDate: '',
                effectiveStartDate: '',
                effectiveEndDate: '',
                i94ExpiryDate: '',
                // durationOfStatus: '',
                i94Number: null,
                id: 0,
                isCurrentlyInUS: false,
                meansOfTravel: '',
                portOfEntry: ''
            });
            this.resetOutcomeIdField();
        }
    }
    resetOutcomeIdField() {
        this.visa.currentlyStayInUS = false;
        this.visa.hasTravelToUs = false;
        this.visa.receiptDate = '';
        this.visa.noticeNo = '';
        this.visa.isEadNo = false;
        this.visa.eadNo = '';
        this.visa.isSevisNo = false;
        this.visa.sevisNo = '';
        this.visa.outcomeReason = '';
        this.visa.outcomeDate = '';
        this.visa.statusId = 0;
        this.visa.outcomeDate = '';
        this.visa.receiptDate = '';
        this.visa.validityStartDate = '';
        this.visa.validityEndDate = '';
        this.visa.visaStamping = false;
        this.visa.visaIssueDate = '';
        this.visa.visaExpirationDate = '';
        this.translet();
    }
    resetImmigration() {
        /* IM-4320 : Current immigration details overrides the past immigration info */
        this.isEditVisaDetails = false;
        this.visa = new VisaDetails({
            id: 0,
            immigrationStatusCode: '',
            currentlyStayInUS: false,
            hasTravelToUs: false,
            receiptDate: '',
            noticeNo: '',
            companyId: null,
            companyName: null,
            isEadNo: false,
            eadNo: '',
            isSevisNo: false,
            sevisNo: '',
            validityEndDate: '',
            validityStartDate: '',
            outcomeIdCode: '',
            outcomeReason: '',
            outcomeDate: '',
            petitionTypeCode: '',
            visaTypeCode: '',
            statusId: 0,
            visaStamping: false,
            visaIssueDate: '',
            visaExpirationDate: ''
        });
        this.travelHistory = new TravelHistory({
            arrivalDate: '',
            arrivalCountryCode: '',
            arrivalStateProvinceCode: '',
            arrivalStateProvinceName: '',
            arrivalCity: '',
            exitDate: '',
            effectiveStartDate: '',
            effectiveEndDate: '',
            i94ExpiryDate: '',
            i94Number: null,
            // durationOfStatus: '',
            id: 0,
            isCurrentlyInUS: false,
            meansOfTravel: '',
            portOfEntry: ''
        });
        this.configurations.listUploadedFiles = [];
        this.configurations = Object.assign({}, this.configurations);
        this.hasID = false;
        this.isLinear = true;
        this.translet();
    }
    resetAllForms(visaDetailsForm, travelHistoryForm) {
        this.loadTravelInfo([]);
        this.configurations.listUploadedFiles = [];
        this.configurations.familyId = this.familyId ? this.familyId : null;
        this.configurations = Object.assign({}, this.configurations);
    }
    saveTravelHistory(travelHistoryForm) {
        const payload = Object.assign({}, this.travelHistory);
        payload.isCurrentlyInUS = false;
        payload.effectiveStartDate = this.travelHistory.effectiveStartDate ? moment(this.travelHistory.effectiveStartDate).format('YYYY-MM-DD') : null;
        payload.arrivalDate = this.travelHistory.arrivalDate ? moment(this.travelHistory.arrivalDate).format('YYYY-MM-DD') : null;
        payload.arrivalCountryCode = this.travelHistory.arrivalCountryCode ? this.travelHistory.arrivalCountryCode : null;
        if (this.listStates.length > 0)
            payload.arrivalStateProvinceName = null;
        payload.arrivalStateProvinceCode = this.travelHistory.arrivalStateProvinceCode ? this.travelHistory.arrivalStateProvinceCode : null;
        if (this.listStates.length <= 0) {
            payload.arrivalStateProvinceCode = null;
            payload.arrivalStateProvinceName = this.travelHistory.arrivalStateProvinceName ? this.travelHistory.arrivalStateProvinceName : null;
        }
        payload.arrivalCity = this.travelHistory.arrivalCity ? this.travelHistory.arrivalCity : null;
        payload.exitDate = this.travelHistory.exitDate ? moment(this.travelHistory.exitDate).format('YYYY-MM-DD') : null;
        payload.effectiveEndDate = this.travelHistory.effectiveEndDate ? moment(this.travelHistory.effectiveEndDate).format('YYYY-MM-DD') : null;
        if (this.isVisaTypeF1 === false) {
            payload.i94ExpiryDate = this.travelHistory.i94ExpiryDate ? moment(this.travelHistory.i94ExpiryDate).format('YYYY-MM-DD') : null;
        }
        else {
            // const check = moment(this.travelHistory.durationOfStatus,'MM/DD/YYYY', true).isValid();
            // if(check){
            //   payload.i94ExpiryDate = moment(this.travelHistory.durationOfStatus).format('YYYY-MM-DD')
            // }else{
            //   payload.i94ExpiryDate = null;
            // }
        }
        this.apiService.saveTravelHistory(this.beneficiaryId, this.visa.id, payload, this.familyId).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response.status === 200) {
                travelHistoryForm.reset(travelHistoryForm); // fix reset
                this.toastr.success(response.message, 'Success');
                // Reload entire immigration
                this.getVisaDetails();
                // Reload travel info table
                this.getImmigrationTravelInfo();
                // Refresh the form
                travelHistoryForm.resetForm({});
                // travelHistoryForm.form.reset();  //I94 Expiry Date field validation remove
                this.travelHistory = new TravelHistory({
                    arrivalDate: '',
                    arrivalCountryCode: '',
                    arrivalStateProvinceCode: '',
                    arrivalStateProvinceName: '',
                    arrivalCity: '',
                    exitDate: '',
                    effectiveStartDate: '',
                    effectiveEndDate: '',
                    i94ExpiryDate: '',
                    i94Number: null,
                    id: 0,
                    isCurrentlyInUS: false,
                    meansOfTravel: '',
                    portOfEntry: ''
                });
            }
        });
    }
    loadTravelInfo(listTravelInfo) {
        this.isTravelHistoryValid = true;
        if (listTravelInfo.length > 0 && this.visa.currentlyStayInUS) {
            if (listTravelInfo.filter((x) => x.exitDate === null || x.exitDate === '').length === 1) {
                this.isTravelHistoryValid = true;
            }
            else {
                this.isTravelHistoryValid = false;
            }
        }
        this.travelInfoDataSource = new MatTableDataSource(listTravelInfo);
        this.translet();
    }
    getImmigrationTravelInfo() {
        this.apiService.getTravelHistory(this.beneficiaryId, this.visa.id, this.familyId).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response.status === 200) {
                this.loadTravelInfo(response.data);
            }
            if (response.status === 204) {
                this.loadTravelInfo([]);
            }
        });
    }
    editTravelInfo(row) {
        this.travelHistory = Object.assign({}, row);
        this.isDepatureChecked = this.travelHistory.exitDate ? true : false;
        this.isCurrentlyUSChecked = this.travelHistory.effectiveStartDate ? true : false;
        // ISO Stringfy is required for date correction in different timezone
        this.travelHistory.arrivalDate = this.travelHistory.arrivalDate ? moment(this.travelHistory.arrivalDate).toISOString() : null;
        if (this.travelHistory.arrivalCountryCode && this.travelHistory.arrivalCountryCode != null) {
            // this.handleCountryChange(this.travelHistory.arrivalCountryCode, true);
            if (this.travelHistory.arrivalStateProvinceCode && this.travelHistory.arrivalStateProvinceCode != null) {
                this.handleCountryChange(this.travelHistory.arrivalCountryCode, this.travelHistory.arrivalStateProvinceCode, true);
                this.travelHistory.arrivalStateProvinceCode = this.travelHistory.arrivalStateProvinceCode;
                //  this.handleStateChange(this.travelHistory.arrivalStateProvinceCode)
            }
            if (this.travelHistory.arrivalStateProvinceName && this.travelHistory.arrivalStateProvinceName != null) {
                this.listStates.length = 0;
                this.travelHistory.arrivalStateProvinceName = this.travelHistory.arrivalStateProvinceName ? this.travelHistory.arrivalStateProvinceName : null;
            }
        }
        this.travelHistory.arrivalCity = this.travelHistory.arrivalCity ? this.travelHistory.arrivalCity : null;
        this.travelHistory.exitDate = this.travelHistory.exitDate ? moment(this.travelHistory.exitDate).toISOString() : null;
        this.travelHistory.effectiveStartDate = this.travelHistory.effectiveStartDate ? moment(this.travelHistory.effectiveStartDate).toISOString() : null;
        this.travelHistory.effectiveEndDate = this.travelHistory.effectiveEndDate ? moment(this.travelHistory.effectiveEndDate).toISOString() : null;
        if (this.isVisaTypeF1 === false) {
            this.travelHistory.i94ExpiryDate = this.travelHistory.i94ExpiryDate ? moment(this.travelHistory.i94ExpiryDate).toISOString() : null;
        }
        else {
            this.travelHistory.i94ExpiryDate = null;
        }
        this.translet();
    }
    deleteTravelInfo(row) {
        // visa.id ===> ImmigrationId
        this.apiService.deleteTravelInfo(this.beneficiaryId, this.visa.id, row.id).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response.status === 200) {
                this.toastr.success(response.message, 'Success');
                // Load entire immigration
                this.getVisaDetails();
                // Reload travel info table
                this.getImmigrationTravelInfo();
            }
        });
    }
    ngAfterContentInit() {
        this.displayedColumns = this.columns.map(c => c.columnDef);
        this.displayedColumnsForTravelInfo = this.columnsTravelInfo.map(c => c.columnDef);
    }
    loadDocuments(documentList) {
        this.configurations.useCaseId = this.beneficiaryId;
        this.configurations.entityId = this.visa ? this.visa.id : null;
        this.configurations.familyId = this.familyId ? this.familyId : null;
        this.configurations.listUploadedFiles = documentList;
        this.configurations = Object.assign({}, this.configurations);
    }
    fileUploadSuccess() {
        this.getVisaDetails(); // Relaod main table
    }
    toggleListView(val) {
        if (!val) {
            this.isTimeLineView = true;
            this.isListView = false;
        }
        else {
            this.isTimeLineView = false;
            this.isListView = true;
        }
    }
    resetValidation() {
        this.formerrors = { arivalDateError: false, exitDateError: false, combination: false, errors: [], combinations: false, validityStartDateError: false, validityEndDateError: false };
        this.visaDateDetails = { startDate: '', expDate: '' };
        this.arrivalDate = '';
        this.exitDate = '';
        this.validityStartDate = '';
        this.validityEndDate = '';
    }
    handleVisaTypeChange(visaType, formName) {
        // formName.form.controls.petitionTypeCode = null;
        /* IM-5015 Sevis No */
        if (visaType === 'F1') {
            this.isVisaTypeF1 = true;
            this.visa.isSevisNo = false;
        }
        else {
            this.isVisaTypeF1 = false;
        }
        this.visaPetitionTypeList = [];
        if (visaType === 'H1B') {
            this.visaPetitionTypeList = Object.assign([], this.petitionTypeList);
            this.indicatingMandatoryField = true;
        }
        else {
            this.indicatingMandatoryField = false;
            const obj = {
                code: null,
                desc: null,
                group: null,
                id: null,
                name: 'Not Applicable'
            };
            this.visaPetitionTypeList = Object.assign([], this.petitionTypeList);
            this.visaPetitionTypeList.push(obj);
        }
        // this.showPetitionTypeDropdown = (visaType === 'H4' || visaType === 'F1' || visaType === 'B1' || visaType === 'B2' || visaType === 'L2') ? false : true;
        if (formName) {
            const formFields = {
                addRequiredValidator: [],
                removeAllValidator: []
            };
            switch (visaType) {
                case 'H1B':
                    formFields.addRequiredValidator = [formName.form.controls.petitionTypeCode,
                        formName.form.controls.noticeNo, formName.form.controls.receiptDate, formName.form.controls.sevisNo];
                    formFields.removeAllValidator = [];
                    break;
                case 'F1':
                    formFields.addRequiredValidator = [formName.form.controls.noticeNo, formName.form.controls.receiptDate,
                        formName.form.controls.sevisNo];
                    formFields.removeAllValidator = [formName.form.controls.petitionTypeCode];
                    break;
                default:
                    formFields.addRequiredValidator = [];
                    formFields.removeAllValidator = [formName.form.controls.noticeNo,
                        formName.form.controls.receiptDate, formName.form.controls.sevisNo, formName.form.controls.petitionTypeCode];
                    break;
            }
            this.apiService.dynamicRequiredValidator(formName, visaType, formFields);
            this.translet();
        }
    }
    resetPetitionTypeDropDown() {
        this.visa.petitionTypeCode = '';
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    dialogueInitializer(event, title, message, buttons) {
        const cordinates = event;
        const dialogRef = this.dialog.open(ConfirmationModalComponent, {
            width: '400px',
            data: {
                update: { title, message },
                buttons: buttons
            }
        });
        return dialogRef;
    }
    openInfoModal() {
        const pageName = 'BeneficiaryImmigration';
        this.dialog.open(InfoModalComponent, {
            width: '450px',
            panelClass: 'custom-info-modalbox',
            data: {
                update: { pageName }
            }
        });
        this.translet();
    }
    //  IM-3831 : For able to save visa details
    checkPetitionName() {
        if (this.visa.immigrationStatusCode === 'H4' || this.visa.immigrationStatusCode === 'F1' || this.visa.immigrationStatusCode === 'B1' || this.visa.immigrationStatusCode === 'B2' || this.visa.immigrationStatusCode === 'L2') {
            return true;
        }
        else {
            return false;
        }
    }
    // IM-3956/IM-4058 Alien Registration Number*
    checkAlienRegistration() {
        if (this.neverAppliedFlag === 'Yes') {
            return false;
        }
        else {
            if (this.neverAppliedFlag === null) {
                return true;
            }
            else {
                if (this.visaMeta.alienRegNo === '' || this.visaMeta.alienRegNo === null) {
                    if (this.visaMeta.hasAlienRegnNo === true) {
                        return false;
                    }
                    else {
                        return true;
                    }
                }
                else {
                    return false;
                }
            }
        }
    }
    // IM-3933 : Beneficiary Profile- Immigration section- Click on Add/Edit immigration button
    closeForm(f) {
        if (this.hasID) {
            this.editImmigration(this.currentItemEdit);
            this.getUsStayHistory();
        }
        else {
            this.resetForm(f);
            this.toggleExpansion();
            if (this.visaDetailsForm) {
                this.visaDetailsForm.reset({});
            }
            if (this.travelHistoryForm) {
                this.travelHistoryForm.reset({});
            }
            this.toggleExpansion();
            this.resetAllForms(this.visaDetailsForm, this.travelHistoryForm);
            if (this.stepper) {
                this.stepper.reset();
            }
            this.resetImmigration();
        }
        this.translet();
    }
    cancelHistory() {
        this.getUsStayHistory();
    }
    resetForm(visaDetailsForm) {
        visaDetailsForm.resetForm();
        this.isLinear = true;
    }
    markAsUntouched() {
        this.immgFields.forEach(model => {
            if (model.name === 'i94ExpiryDate') {
                model.control.markAsUntouched();
            }
        });
    }
    ngOnChanges(changes) {
        var _a;
        if (((_a = changes.isWizard) === null || _a === void 0 ? void 0 : _a.currentValue) && sessionStorage.getItem("tempPetitionId")) {
            debugger;
            this.inputData = {
                visaType: "H1B",
                caseType: this.wizardData.caseType,
                caseId: JSON.parse(sessionStorage.getItem("tempPetitionId")),
                superTaskId: this.wizardData.superTaskId,
                subTaskId: this.wizardData.subTaskId,
                familyId: this.wizardData.familyId,
            };
            this.configurations.familyId = this.inputData.familyId;
            this.familyId = this.inputData.familyId;
            this.beneficiaryId = sessionStorage.getItem('beneficiaryId') ? parseInt(sessionStorage.getItem('beneficiaryId')) : 0;
        }
        if (changes.mode.currentValue) {
            if (changes.mode.currentValue === 'list') {
                this.modeVal = true;
            }
        }
        if ((changes.caseRequestShowDivs && changes.caseRequestShowDivs.currentValue) || (changes.benQuestShowDivs && changes.benQuestShowDivs.currentValue)) {
            // this.visaDetailsForm = this.fb.group({
            //   id: [],        
            // });
            if (changes.caseRequestShowDivs && changes.caseRequestShowDivs.currentValue) {
                this.iscaseRequest = true;
                changes.caseRequestShowDivs.currentValue.subLevel.forEach(element => {
                    this.currentItemDisplay.push(element.code);
                });
            }
            if (changes.benQuestShowDivs && changes.benQuestShowDivs.currentValue) {
                this.isBenQuestShowDivs = true;
                changes.benQuestShowDivs.currentValue.subLevel.forEach(element => {
                    this.currentItemDisplay.push(element.code);
                });
            }
        }
        else {
            this.iscaseRequest = false;
        }
    }
    ngAfterViewInit() {
        if (this.modeVal) {
            this.showLifeStoryTimeLineSection = true;
            this.toggleListView(true);
            this.toggleExpansion();
            this.translet();
        }
    }
    ngOnDestroy() {
        sessionStorage.removeItem('dependentId');
        if (this.formChangesSubscriptions) {
            this.formChangesSubscriptions.forEach(subscription => subscription.unsubscribe());
        }
        this.destroy$.next();
        this.destroy$.complete();
        if (this.dependentIdSubscription) {
            this.dependentIdSubscription.unsubscribe();
        }
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
        this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
    }
    handleCountryChange(countryCode, sc, editMode) {
        this.travelHistory.arrivalCountryCode = countryCode;
        this.apiService.getStates(countryCode).subscribe((states) => {
            this.listStates = states;
            if (editMode) {
                this.travelHistory.arrivalStateProvinceCode = sc;
            }
            this.changeDetectorRef.markForCheck();
        });
    }
    handleStateChange(stateCode) {
        this.travelHistory.arrivalStateProvinceCode = stateCode;
    }
    resetTravalHistoryForm() {
        if (this.travelHistoryForm) {
            this.travelHistoryForm.reset();
        }
    }
    saveAsDraft(event) {
        this.saveVisaDetails(this.visaDetailsForm, event);
    }
    closeImmigration() {
        if (this.visaDetailsForm) {
            this.visaDetailsForm.reset({});
        }
        if (this.travelHistoryForm) {
            this.travelHistoryForm.reset({});
        }
        this.resetAllForms(this.visaDetailsForm, this.travelHistoryForm);
        this.resetImmigration();
        this.isAddVisaVisible = false;
        this.translet();
    }
    translet() {
        setTimeout(() => {
            this.referenceLibraryService.transletConversion();
        }, 600);
    }
    getUsStayHistory() {
        if (sessionStorage.getItem('newFamilyId')) {
            this.familyId = sessionStorage.getItem('newFamilyId');
        }
        if (sessionStorage.getItem('dependentId')) {
            this.familyId = sessionStorage.getItem('dependentId');
        }
        this.apiService.getUsStayHistory(this.beneficiaryId, this.familyId).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response && response.status === 200) {
                if (response.data && response.data.length > 0) {
                    this.createForm(response.data);
                }
                else {
                    this.stayHistoryDataSource = new MatTableDataSource([]);
                    this.AddNewRow();
                }
            }
            else if (response && response.status === 204) {
                this.stayHistoryDataSource = new MatTableDataSource([]);
            }
        });
    }
    getFormGroup(i) {
        const itemsArray = this.stayHistoryForm.get('items');
        return itemsArray.at(i);
    }
    get stayHistoryFormItems() {
        return this.stayHistoryForm.get('items');
    }
    getTravelInfoArray(index) {
        return this.stayHistoryFormItems.at(index).get("travelInfo");
    }
    createForm(data) {
        this.stayHistoryForm = this.fb.group({
            items: this.fb.array([])
        });
        const itemsArray = this.stayHistoryForm.get('items');
        data.forEach(item => {
            let travelInfoArray = this.fb.array([]);
            if (item.travelInfo.length > 0) {
                item.travelInfo.forEach(travel => {
                    travelInfoArray.push(this.fb.group({
                        id: [travel.id || null],
                        arrivalDate: [travel.arrivalDate ? moment(travel.arrivalDate).utc().toDate() : null, Validators.required],
                        exitDate: [travel.exitDate ? moment(travel.exitDate).utc().toDate() : null, Validators.required],
                        exitReason: [travel.exitReason, Validators.required],
                        otherReason: [travel.otherReason || ''],
                        i94Number: [travel.i94Number || ''],
                        meansOfTravel: [travel.meansOfTravel || ''],
                        portOfEntry: [travel.portOfEntry || ''],
                        i94ExpiryDate: [travel.i94ExpiryDate ? moment(travel.i94ExpiryDate).utc().toDate() : null, Validators.required],
                        durationOfStatus: [travel.durationOfStatus || null]
                    }));
                });
            }
            else {
                travelInfoArray.push(this.fb.group({
                    id: [0],
                    arrivalDate: [null, Validators.required],
                    exitDate: [null, Validators.required],
                    exitReason: ['', Validators.required],
                    otherReason: [''],
                    i94Number: [''],
                    i94ExpiryDate: [''],
                    durationOfStatus: [null],
                    meansOfTravel: [''],
                    portOfEntry: [''],
                }));
            }
            itemsArray.push(this.fb.group({
                id: [item.id || null],
                immigrationStatusCode: [item.immigrationStatusCode || '', Validators.required],
                petitionTypeCode: [item.petitionTypeCode || '', Validators.required],
                travelInfo: travelInfoArray || []
            }));
        });
        this.stayHistoryDataSource = new MatTableDataSource(this.stayHistoryForm.get('items').controls);
        this.translet();
    }
    AddNewRow() {
        const itemsArray = this.stayHistoryForm.get('items');
        const travelInfoArray = this.fb.array([]);
        travelInfoArray.push(this.fb.group({
            id: [0],
            arrivalDate: [null, Validators.required],
            exitDate: [null, Validators.required],
            exitReason: ['', Validators.required],
            i94ExpiryDate: [null],
            i94Number: [''],
            otherReason: [''],
            meansOfTravel: [''],
            portOfEntry: [''],
        }));
        // Creating a new FormGroup for the new item
        const newItem = this.fb.group({
            id: [0],
            immigrationStatusCode: [null, Validators.required],
            petitionTypeCode: [null, Validators.required],
            travelInfo: travelInfoArray || []
        });
        // Adding the new FormGroup to the items FormArray
        itemsArray.push(newItem);
        this.stayHistoryDataSource = new MatTableDataSource(this.stayHistoryForm.get('items').controls);
        this.translet();
    }
    deleteRow(rowIndex, travelIndex) {
        const travelInfoFormArray = this.stayHistoryForm.get('items')['controls'][rowIndex].get('travelInfo');
        travelInfoFormArray.removeAt(travelIndex);
        this.stayHistoryDataSource = new MatTableDataSource(this.stayHistoryForm.get('items').controls);
        this.translet();
    }
    saveStayHistory() {
        for (let index = 0; index < this.stayHistoryForm.value.items.length; index++) {
            for (let travelIndex = 0; travelIndex < this.stayHistoryForm.value.items[index].travelInfo.length; travelIndex++) {
                this.stayHistoryForm.value.items[index].travelInfo[travelIndex].arrivalDate = this.stayHistoryForm.value.items[index].travelInfo[travelIndex].arrivalDate ? moment(this.stayHistoryForm.value.items[index].travelInfo[travelIndex].arrivalDate).format('YYYY-MM-DD') : null;
                this.stayHistoryForm.value.items[index].travelInfo[travelIndex].exitDate = this.stayHistoryForm.value.items[index].travelInfo[travelIndex].exitDate ? moment(this.stayHistoryForm.value.items[index].travelInfo[travelIndex].exitDate).format('YYYY-MM-DD') : null;
                this.stayHistoryForm.value.items[index].travelInfo[travelIndex].i94ExpiryDate = this.stayHistoryForm.value.items[index].travelInfo[travelIndex].i94ExpiryDate ? moment(this.stayHistoryForm.value.items[index].travelInfo[travelIndex].i94ExpiryDate).format('YYYY-MM-DD') : null;
            }
        }
        if (sessionStorage.getItem('newFamilyId')) {
            this.familyId = sessionStorage.getItem('newFamilyId');
        }
        if (sessionStorage.getItem('dependentId')) {
            this.familyId = sessionStorage.getItem('dependentId');
        }
        this.apiService.saveUsStayHostory(this.beneficiaryId, this.stayHistoryForm.value.items, this.familyId).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            this.toastr.success(response.message, 'Success');
            this.getVisaDetails();
            this.getVisaMetaInfo();
            this.getUsStayHistory();
        });
    }
    // Method to add a new record to the travelInfo array
    addTravelInfo(index) {
        const travelInfoFormArray = this.stayHistoryForm.get('items')['controls'][index].get('travelInfo');
        travelInfoFormArray.push(this.createTravelInfoFormGroup());
        this.translet();
    }
    // Helper method to create a new FormGroup for travelInfo
    createTravelInfoFormGroup() {
        return this.fb.group({
            id: [0],
            arrivalDate: [null, Validators.required],
            exitDate: [null, Validators.required],
            exitReason: ['', Validators.required],
            i94Number: [''],
            i94ExpiryDate: [null],
            otherReason: [''],
            meansOfTravel: [''],
            portOfEntry: [''],
        });
    }
    updateFormControls(formgroup) {
        var _a, _b, _c;
        if (((_b = (_a = formgroup === null || formgroup === void 0 ? void 0 : formgroup.controls) === null || _a === void 0 ? void 0 : _a.immigrationStatusCode) === null || _b === void 0 ? void 0 : _b.value) === 'F1') {
            formgroup.addControl('durationOfStatus', new FormControl(''));
        }
        else if ((_c = formgroup === null || formgroup === void 0 ? void 0 : formgroup.controls) === null || _c === void 0 ? void 0 : _c.durationOfStatus) {
            formgroup.removeControl('durationOfStatus');
        }
        this.translet();
    }
}
GenericBeneficiaryImmigrationDetailsLibraryComponent.ɵfac = function GenericBeneficiaryImmigrationDetailsLibraryComponent_Factory(t) { return new (t || GenericBeneficiaryImmigrationDetailsLibraryComponent)(i0.ɵɵdirectiveInject(i1$2.CacheCountryListService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i2$2.ReferenceLibraryService), i0.ɵɵdirectiveInject(GenericBeneficiaryImmigrationDetailsLibraryService), i0.ɵɵdirectiveInject(i4.ToastrService), i0.ɵɵdirectiveInject(i1$1.MatDialog), i0.ɵɵdirectiveInject(i6.ActivatedRoute), i0.ɵɵdirectiveInject(i2$1.Store), i0.ɵɵdirectiveInject(i8.FormBuilder)); };
GenericBeneficiaryImmigrationDetailsLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: GenericBeneficiaryImmigrationDetailsLibraryComponent, selectors: [["lib-generic-beneficiary-immigration-details-library"]], viewQuery: function GenericBeneficiaryImmigrationDetailsLibraryComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 3);
        i0.ɵɵviewQuery(MatPaginator, 3);
        i0.ɵɵviewQuery(CustomQuestionnaireComponent, 1);
        i0.ɵɵviewQuery(NgModel, 1);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.immvisaDetailsForm = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.paginator = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.customQuestionsComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.immgFields = _t);
    } }, inputs: { mode: "mode", showLifeStoryTimeLineSection: "showLifeStoryTimeLineSection", caseRequestShowDivs: "caseRequestShowDivs", benQuestShowDivs: "benQuestShowDivs", isViewMode: "isViewMode", isWizard: "isWizard", type: "type", userId: "userId", inputData: "inputData" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], ["mat-stretch-tabs", "false", "mat-align-tabs", "start", "id", "immigrationTab", 1, "immigrationContainer", 3, "disablePagination", "selectedTabChange"], ["matTabLabel", ""], [1, "p-3", 3, "click"], ["nonImmigrantVisForm", "ngForm"], ["id", "immigrantVisaInfo", 1, "beneficiary-immigration", "pl-3", "common-bene-class-for-translation"], [3, "disabled", 4, "ngIf"], ["id", "immigrationDetails", 1, "common-bene-class-for-translation"], [1, "row", "align-items-center"], [1, "col-md-12", "beneficiary-immigration", "visaDetails", "pt-2", "pb-3"], ["id", "eveAppliedUSVisa", 1, "m-0", "pr-2", "common-bene-class-for-translation"], ["name", "neverAppliedFlag", "aria-labelledby", "example-radio-group-label", 1, "example-radio-group", "has-immigration", 3, "ngModel", "change", "ngModelChange"], ["value", "Yes", 1, "example-radio-button", "beneficiary-immigration"], ["id", "visaAppliedYes", 1, "common-bene-class-for-translation"], ["value", "No", 1, "example-radio-button", "beneficiary-immigration"], ["id", "visaAppliedNo", 1, "common-bene-class-for-translation"], [1, "row", "col-md-12"], ["class", "beneficiary-immigration noVisa common-bene-class-for-translation", "id", "noVisaMessage", 4, "ngIf"], [1, "row"], [1, "row", "col-md-12", "mt-3", "pt-3", "immigrantSave"], ["type", "button", 1, "btn", "btn-primary", 3, "click"], ["id", "saveVisaButton", 1, "common-bene-class-for-translation"], ["type", "button", 1, "button_bg-gray", "ml-3", 3, "click"], ["id", "cancelVisaButton", 1, "common-bene-class-for-translation"], ["id", "noVisaMessage", 1, "beneficiary-immigration", "noVisa", "common-bene-class-for-translation"], ["class", "row align-items-center", 4, "ngIf"], [1, "form-group", "col-md-8"], ["id", "alienRegLabel", 1, "beneficiary-immigration", "mb-0", "common-bene-class-for-translation"], ["type", "text", "name", "alienRegNumber", "placeholder", "Enter", 1, "im-input", "mb-2", "ml-0", 3, "ngModel", "disabled", "ngModelChange"], ["alienRegNumber", "ngModel"], [1, "form-group", "col-md-4", "pl-0", "pt-3", 2, "margin-bottom", "0"], ["name", "alienRegNumberNA", 1, "beneficiary-immigration", 3, "ngModel", "change", "ngModelChange"], ["id", "alienRegNotApplicable", 1, "common-bene-class-for-translation"], [4, "ngFor", "ngForOf"], ["class", "customSections", 4, "ngFor", "ngForOf"], [1, "customSections"], [3, "isNewPortion", "viewQuestions", "loadedIn", "beneficiaryId", "isSection", "familyId"], [1, "col-12", "addDetails", "pt-3", 3, "hidden"], ["class", "mb-0", 4, "ngIf"], ["class", "btn btn-primary mb-0 ml-2", "type", "button", 3, "click", 4, "ngIf"], ["class", "spacing immigration-list-table mt-0", 3, "ngClass", 4, "ngIf"], [1, "col-12", "listVisaDetails", 3, "hidden"], [1, "w-100", "closeIcon"], ["class", "pi pi-times", 3, "click", 4, "ngIf"], ["class", "w-100", 4, "ngIf"], ["class", "w-100", 3, "ngClass", 4, "ngIf"], ["id", "visaDetails", 1, "common-bene-class-for-translation"], [1, "mb-0"], ["id", "noVisaDetailsAdded", 1, "common-bene-class-for-translation"], ["type", "button", 1, "btn", "btn-primary", "mb-0", "ml-2", 3, "click"], ["id", "addVisaDetailsButton", 1, "common-bene-class-for-translation"], [1, "spacing", "immigration-list-table", "mt-0", 3, "ngClass"], [1, "p-3"], ["id", "immigrationDetailsAdded", 1, "common-bene-class-for-translation"], ["multiTemplateDataRows", "", "mat-table", "", 1, "immigration-list-table", 3, "dataSource"], [3, "matColumnDef", 4, "ngFor", "ngForOf"], [1, "example-element-description"], ["matColumnDef", "expandedDetail"], ["class", "w40", "mat-cell", "", 4, "matCellDef"], ["mat-header-row", "", 4, "matHeaderRowDef"], ["mat-row", "", "class", "example-element-row", 3, "example-expanded-row", "click", 4, "matRowDef", "matRowDefColumns"], ["mat-row", "", "class", "example-detail-row", 4, "matRowDef", "matRowDefColumns"], [3, "matColumnDef"], ["mat-header-cell", "", 4, "matHeaderCellDef"], ["mat-cell", "", 4, "matCellDef"], ["mat-header-cell", ""], [1, "common-bene-class-for-translation", 3, "id"], ["mat-cell", ""], ["class", "toggle-col", 4, "ngIf"], ["class", "common-bene-class-for-translation", 3, "id", 4, "ngIf"], [1, "toggle-col"], ["matTooltip", "View more", 1, "mr-1", "icn", 3, "click"], ["class", "column.customClass", 4, "ngIf"], [1, "column.customClass"], ["class", "mr-1 icn", "matTooltip", "Edit", "class", "im-table-verticle-icon", 3, "click", 4, "ngIf"], ["class", "mr-1 icn", "matTooltip", "Delete", 3, "click", 4, "ngIf"], ["matTooltip", "Edit", 1, "im-table-verticle-icon", 3, "click"], ["matTooltip", "Delete", 1, "mr-1", "icn", 3, "click"], ["mat-cell", "", 1, "w40"], [1, "example-element-detail"], [1, "w100", "example-element-description", "py-1"], [1, "im-card-no-border-table"], [1, "w40"], ["aria-hidden", "true", 1, "fa", "fa-download", "fa-lg", "icn"], ["id", "approvedDate", 1, "common-bene-class-for-translation"], ["id", "validityStartDate", 1, "common-bene-class-for-translation"], ["id", "validityEndDate", 1, "common-bene-class-for-translation"], ["id", "eadNumber", 1, "common-bene-class-for-translation"], ["id", "sevisNumber", 1, "common-bene-class-for-translation"], ["nowrap", "", 1, "common-bene-class-for-translation", 3, "id"], [2, "width", "80%"], ["id", "reasonForDenial", 1, "common-bene-class-for-translation"], ["id", "denialDate", 1, "common-bene-class-for-translation"], ["nowrap", ""], ["id", "reasonForWithdrawal", 1, "common-bene-class-for-translation"], ["id", "withdrawalDate", 1, "common-bene-class-for-translation"], [1, "circleIndex", "rounded-circle"], [3, "fileName", "Path"], ["mat-header-row", ""], ["mat-row", "", 1, "example-element-row", 3, "click"], ["mat-row", "", 1, "example-detail-row"], [1, "pi", "pi-times", 3, "click"], [1, "w-100"], [1, "pl-3", "pt-3", "addVisaHead"], ["id", "addVisaDetails", 1, "common-bene-class-for-translation"], [1, "mt-2", 3, "click", "ngSubmit", "change"], ["visaDetailsForm", "ngForm"], ["class", "form-group col-md-6", 4, "ngIf"], ["class", "row", 4, "ngIf"], [1, "col-md-12", "pt-2"], ["id", "enterVisaDetails", 1, "labelText", "common-bene-class-for-translation"], [1, "row", "pt-2"], ["class", "container-fluid", "style", "padding-left: 0px; padding-right: 0px", 4, "ngIf"], [1, "next-btn"], [1, "d-flex"], [1, "p-2"], ["type", "submit", 1, "btn", "btn-success"], ["id", "saveButton", 1, "common-bene-class-for-translation"], ["type", "button", "class", "button_bg-gray", 3, "click", 4, "ngIf"], [1, "form-group", "col-md-6"], [1, "label-cls"], ["id", "visaAppliedLabel", 1, "common-bene-class-for-translation"], ["name", "immigrationStatusCode", "optionValue", "code", "optionLabel", "name", "placeholder", "Select", "required", "", "appendTo", "body", "filterBy", "name", "id", "visaAppliedDropdown", 1, "w-100", 3, "options", "ngModel", "filter", "onChange", "ngModelChange"], ["immigrationStatusCode", "ngModel"], ["id", "visaAppliedLabel", 1, "label-cls", "common-bene-class-for-translation"], ["name", "immigrationStatusCode", "optionValue", "code", "optionLabel", "name", "placeholder", "Select", 1, "w-100", 3, "options", "ngModel", "onChange", "ngModelChange"], ["id", "petitionTypeLabel", 1, "common-bene-class-for-translation"], ["name", "petitionTypeCode", "required", "", "optionValue", "code", "optionLabel", "name", "placeholder", "Select", "id", "petitionTypeDropdown", 1, "w-100", 3, "options", "ngModel", "ngModelChange"], ["petitionTypeCode", "ngModel"], ["id", "petitionTypeLabelCaseRequest", 1, "label-cls", "common-bene-class-for-translation"], ["name", "petitionTypeCode", "optionValue", "code", "optionLabel", "name", "placeholder", "Select", "id", "petitionTypeDropdownCaseRequest", 1, "w-100", 3, "options", "ngModel", "ngModelChange"], ["id", "petitionerNameLabel", 1, "common-bene-class-for-translation"], ["type", "text", "name", "companyName", "placeholder", "Enter", "id", "petitionerNameInput", 1, "im-input", "mw-100", 3, "ngModel", "ngModelChange"], ["companyName", "ngModel"], ["type", "text", "name", "companyName", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "ngModel", "ngModelChange"], [1, "form-group", "col-md-12"], ["id", "visaOutcomeLabel", 1, "label-cls", "d-block", "common-bene-class-for-translation"], ["aria-label", "Select an option", "name", "outcome", 3, "ngModel", "change", "ngModelChange"], ["outcomeIdCode", "ngModel"], ["class", "example-radio-button", 3, "value", 4, "ngFor", "ngForOf"], [1, "example-radio-button", 3, "value"], ["id", "'visaOutcomeOption' + i", 1, "common-bene-class-for-translation"], ["id", "uscisReceiptNumberLabel", 1, "label-cls", "common-bene-class-for-translation"], ["type", "text", "name", "noticeNo", "placeholder", "Enter", "pattern", "^[A-Za-z0-9]+$", 1, "im-input", "mw-100", 3, "ngModel", "ngModelChange"], ["noticeNo", "ngModel"], ["id", "uscisReceiptNumberHint", 1, "hint-text", "common-bene-class-for-translation"], ["class", "invalid-message common-bene-class-for-translation", "id", "uscisReceiptNumberError", 4, "ngIf"], ["id", "uscisReceiptNumberError", 1, "invalid-message", "common-bene-class-for-translation"], ["id", "uscisReceiptNumberLabelCaseRequest", 1, "label-cls", "common-bene-class-for-translation"], ["id", "uscisReceiptNumberHintCaseRequest", 1, "hint-text", "common-bene-class-for-translation"], ["id", "uscisReceiptDateLabel", 1, "label-cls", "common-bene-class-for-translation"], ["appearance", "outline", 1, "mt-1", "date-field"], ["matInput", "", "name", "receiptDate", "placeholder", "MM/DD/YYYY", 3, "matDatepicker", "max", "ngModel", "ngModelChange", "click"], ["receiptDate", "ngModel"], ["matSuffix", "", 3, "for"], ["receiptDtPicker", ""], ["appearance", "outline", 1, "mt-0", "date-field"], [1, "container-fluid", 2, "padding-left", "0px", "padding-right", "0px"], ["class", "form-group col-md-8", 4, "ngIf"], ["class", "form-group col-md-4", 4, "ngIf"], ["id", "reasonForDenialLabel", 1, "label-cls", "common-bene-class-for-translation"], ["type", "text", "name", "reasonForDenial", "placeholder", "Enter", 1, "im-input", "mb-2", "mw-100", 3, "ngModel", "ngModelChange"], ["reasonForDenial", "ngModel"], [1, "form-group", "col-md-4"], ["id", "denialDateLabel", 1, "label-cls", "common-bene-class-for-translation"], ["matInput", "", "name", "outcomeDate", "placeholder", "MM/DD/YYYY", 3, "matDatepicker", "min", "max", "ngModel", "ngModelChange", "click"], ["outcomeDate", "ngModel"], ["denialDtPicker", ""], [1, "col-md-12"], ["id", "consularProcessLabel", 1, "common-bene-class-for-translation"], [1, "col-md-6"], ["name", "visaStamping", "aria-labelledby", "example-radio-group-label", 1, "example-radio-group", 3, "ngModel", "ngModelChange", "change"], ["id", "visaStampingYes", 1, "common-bene-class-for-translation"], ["id", "visaStampingNo", 1, "common-bene-class-for-translation"], ["id", "uscisApprovedDateLabel", 1, "label-cls", "common-bene-class-for-translation"], ["approvedDtPicker", ""], ["id", "uscisApprovedDateLabelCaseRequest", 1, "label-cls", "common-bene-class-for-translation"], ["id", "visaValidityStartDateLabel", 1, "label-cls", "common-bene-class-for-translation"], ["matInput", "", "name", "validityStartDate", "placeholder", "MM/DD/YYYY", "required", "", 3, "matDatepicker", "ngModel", "min", "ngModelChange", "dateChange", "click"], ["validityStartDate", "ngModel"], ["valStartDtPicker", ""], ["matInput", "", "name", "validityStartDate", "placeholder", "MM/DD/YYYY", 3, "matDatepicker", "ngModel", "min", "ngModelChange", "dateChange", "click"], ["id", "visaValidityEndDateLabel", 1, "label-cls", "common-bene-class-for-translation"], ["matInput", "", "name", "validityEndDate", "placeholder", "MM/DD/YYYY", 3, "matDatepicker", "min", "ngModel", "ngModelChange", "click"], ["validityEndDate", "ngModel"], ["valEndDtPicker", ""], ["id", "visaIssueDateLabel1", 1, "label-cls", "common-bene-class-for-translation"], ["matInput", "", "name", "visaIssueDate", "placeholder", "MM/DD/YYYY", 3, "matDatepicker", "ngModel", "min", "ngModelChange", "dateChange", "click"], ["visaIssueDate", "ngModel"], ["valVisaIssueDateDtPicker", ""], ["id", "visaExpirationDateLabel1", 1, "label-cls", "common-bene-class-for-translation"], ["matInput", "", "name", "visaExpirationDate", "placeholder", "MM/DD/YYYY", 3, "matDatepicker", "min", "ngModel", "ngModelChange", "click"], ["visaExpirationDate", "ngModel"], ["valVisaExpirationDateDtPicker", ""], ["id", "eadNumberLabel", 1, "label-cls", "common-bene-class-for-translation"], ["type", "text", "name", "eadNo", "placeholder", "Enter", 1, "im-input", "mb-2", "mw-100", 3, "disabled", "ngModel", "ngModelChange"], ["eadNo", "ngModel"], ["name", "isEadNo", 3, "ngModel", "change", "ngModelChange"], ["id", "notApplicableCheckbox", 1, "common-bene-class-for-translation"], ["id", "sevisNumberLabel", 1, "label-cls", "common-bene-class-for-translation"], ["type", "text", "name", "sevisNo", "placeholder", "Enter", 1, "im-input", "mb-2", "mw-100", 3, "disabled", "ngModel", "ngModelChange"], ["sevisNo", "ngModel"], ["name", "isSevisNo", 3, "ngModel", "disabled", "change", "ngModelChange"], ["id", "usedVisaLabel", 1, "label-cls", "common-bene-class-for-translation"], ["name", "hasTravelToUs", "aria-labelledby", "example-radio-group-label", 1, "example-radio-group", 3, "ngModel", "change", "ngModelChange"], ["id", "usedVisaYes", 1, "common-bene-class-for-translation"], ["id", "usedVisaNo", 1, "common-bene-class-for-translation"], ["id", "reasonForWithdrawalLabel", 1, "label-cls", "common-bene-class-for-translation"], ["id", "withdrawalDateLabel", 1, "label-cls", "common-bene-class-for-translation"], [1, "col-md-12", "form-group"], ["name", "currentlyStayInUS", 3, "ngModel", "change", "ngModelChange"], ["id", "currentlyInUs", 1, "common-bene-class-for-translation"], ["type", "button", 1, "button_bg-gray", 3, "click"], ["id", "cancelButton", 1, "common-bene-class-for-translation"], [1, "w-100", 3, "ngClass"], ["id", "usStayHistoryLabel", 1, "common-bene-class-for-translation", "pl-0", "pt-3", "addVisaHead"], ["class", "col-12 mt-2", 4, "ngIf"], [3, "hidden"], [3, "formGroup"], ["formArrayName", "items"], [1, "usStayHistory"], ["mat-table", "", 1, "us-stay-hisroty-table", 3, "dataSource"], ["matColumnDef", "immigrationStatusCode"], ["mat-header-cell", "", "class", "common-bene-class-for-translation", "id", "visaTypeHeader", 4, "matHeaderCellDef"], ["mat-cell", "", 3, "formGroup", 4, "matCellDef"], ["matColumnDef", "petitionTypeCode"], ["mat-header-cell", "", "class", "common-bene-class-for-translation", "id", "petitionTypeHeader", 4, "matHeaderCellDef"], ["matColumnDef", "meansOfTravel"], ["mat-header-cell", "", "class", "minWidth common-bene-class-for-translation", "id", "meansOfTravelHeader", 4, "matHeaderCellDef"], ["matColumnDef", "portOfEntry"], ["mat-header-cell", "", "class", "common-bene-class-for-translation minWidthCus1", "id", "portOfEntryHeader", 4, "matHeaderCellDef"], ["matColumnDef", "i94Number"], ["mat-header-cell", "", "style", "width:150px;", "class", "common-bene-class-for-translation", "id", "i94NumberHeader", 4, "matHeaderCellDef"], ["matColumnDef", "i94ExpiryDate"], ["mat-header-cell", "", "style", "width:150px;", "class", "common-bene-class-for-translation", "id", "expiryDateHeader", 4, "matHeaderCellDef"], ["matColumnDef", "arrivalDate"], ["mat-header-cell", "", "class", "common-bene-class-for-translation", "id", "entryDateHeader", 4, "matHeaderCellDef"], ["matColumnDef", "exitDate"], ["mat-header-cell", "", "class", "common-bene-class-for-translation", "id", "exitDateHeader", 4, "matHeaderCellDef"], ["matColumnDef", "exitReason"], ["mat-header-cell", "", "class", "common-bene-class-for-translation", "id", "exitReasonHeader", 4, "matHeaderCellDef"], ["matColumnDef", "otherReason"], ["mat-header-cell", "", "class", "common-bene-class-for-translation minWidthCus", "id", "otherReasonHeader", 4, "matHeaderCellDef"], ["matColumnDef", "action"], ["mat-header-cell", "", "class", "common-bene-class-for-translation", "id", "actionHeader", 4, "matHeaderCellDef"], ["mat-row", "", 4, "matRowDef", "matRowDefColumns"], ["class", "no-record common-bene-class-for-translation", "id", "noRecords", 4, "ngIf"], [1, "row", "mt-4"], ["type", "button", 1, "btn", "btn-primary", "mr-4", "addMore", 3, "click"], ["id", "addMore", 1, "common-bene-class-for-translation"], [1, "pt-2", "ng-tns-c1051-89", "pl-0", "mr-2"], [1, "col-12", "mt-2"], ["id", "noTravelMessage", 1, "common-bene-class-for-translation"], [1, "row", "pt-3"], [1, "col-md-6", "text-right"], ["mat-header-cell", "", "id", "visaTypeHeader", 1, "common-bene-class-for-translation"], ["mat-cell", "", 3, "formGroup"], ["appendTo", "body", "formControlName", "immigrationStatusCode", "optionValue", "code", "optionLabel", "name", "filterBy", "name", 3, "options", "filter", "onChange"], ["mat-header-cell", "", "id", "petitionTypeHeader", 1, "common-bene-class-for-translation"], ["appendTo", "body", "formControlName", "petitionTypeCode", "optionValue", "code", "optionLabel", "name", 3, "options"], ["mat-header-cell", "", "id", "meansOfTravelHeader", 1, "minWidth", "common-bene-class-for-translation"], ["formArrayName", "travelInfo"], [3, "formGroupName"], ["type", "text", "formControlName", "meansOfTravel", "placeholder", "Enter", 1, "im-input", "m-0", "w-100"], ["mat-header-cell", "", "id", "portOfEntryHeader", 1, "common-bene-class-for-translation", "minWidthCus1"], ["type", "text", "formControlName", "portOfEntry", "placeholder", "Enter", 1, "im-input", "m-0", "w-100"], ["mat-header-cell", "", "id", "i94NumberHeader", 1, "common-bene-class-for-translation", 2, "width", "150px"], ["type", "text", "formControlName", "i94Number", "placeholder", "Enter", "maxlength", "11", 1, "im-input", "m-0", "mw-100"], ["mat-header-cell", "", "id", "expiryDateHeader", 1, "common-bene-class-for-translation", 2, "width", "150px"], [1, "mb-2", "iterative-column", 3, "formGroupName"], ["type", "text", "formControlName", "durationOfStatus", "placeholder", "Enter", 1, "im-input", "mb-2", "mw-100"], ["appendTo", "body", "formControlName", "i94ExpiryDate", "name", "date", "styleClass", "p-form-datepicker immDatePicker", "dateFormat", "mm/dd/yy", "placeholder", "MM/DD/YYYY", "yearRange", "1900:2100", 3, "minDate", "showIcon", "readonlyInput", "monthNavigator", "yearNavigator"], ["mat-header-cell", "", "id", "entryDateHeader", 1, "common-bene-class-for-translation"], ["type", "button", 1, "btn", "btn-outline-primary", "add-more-button", 3, "click"], ["appendTo", "body", "formControlName", "arrivalDate", "name", "date", "styleClass", "p-form-datepicker immDatePicker", "dateFormat", "mm/dd/yy", "placeholder", "MM/DD/YYYY", "yearRange", "1900:2100", 3, "maxDate", "showIcon", "readonlyInput", "monthNavigator", "yearNavigator"], ["mat-header-cell", "", "id", "exitDateHeader", 1, "common-bene-class-for-translation"], ["appendTo", "body", "formControlName", "exitDate", "name", "date", "styleClass", "p-form-datepicker immDatePicker", "dateFormat", "mm/dd/yy", "placeholder", "MM/DD/YYYY", "yearRange", "1900:2100", 3, "minDate", "showIcon", "readonlyInput", "monthNavigator", "yearNavigator"], ["mat-header-cell", "", "id", "exitReasonHeader", 1, "common-bene-class-for-translation"], ["appendTo", "body", "placeholder", "Select a Reason", "formControlName", "exitReason", "optionValue", "code", "optionLabel", "name", 3, "autoDisplayFirst", "options"], ["mat-header-cell", "", "id", "otherReasonHeader", 1, "common-bene-class-for-translation", "minWidthCus"], [1, "mb-2", "iterative-column", "p-1", 3, "formGroupName"], ["matInput", "", "type", "text", "formControlName", "otherReason", 4, "ngIf"], ["matInput", "", "type", "text", "formControlName", "otherReason"], ["mat-header-cell", "", "id", "actionHeader", 1, "common-bene-class-for-translation"], ["title", "This delete will only delete the travel record. Same visa record has to be deleted explicitly", 1, "fa", "fa-trash", 3, "click"], ["mat-row", ""], ["id", "noRecords", 1, "no-record", "common-bene-class-for-translation"], [3, "disabled"], [1, "row", "bg-white", "p-0"], [1, "col-12", "p-4"], ["id", "uploadSupportingDoc", 1, "p-3", "m-0", "pb-0"], [1, "common-bene-class-for-translation"], [1, "row", "formBox"], [1, "col-md-12", "mt-2"], [1, "w-100", 3, "configurations", "fileUploadSuccess"], ["id", "documentDetails", 1, "common-bene-class-for-translation"]], template: function GenericBeneficiaryImmigrationDetailsLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, GenericBeneficiaryImmigrationDetailsLibraryComponent_ng_container_0_Template, 11, 4, "ng-container", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.isExternalEmployeeId);
    } }, directives: [i9.NgIf, i10.MatTabGroup, i10.MatTab, i10.MatTabLabel, i8.ɵangular_packages_forms_forms_ba, i8.NgControlStatusGroup, i8.NgForm, i11.MatRadioGroup, i8.NgControlStatus, i8.NgModel, i11.MatRadioButton, i8.DefaultValueAccessor, i12.MatCheckbox, i9.NgForOf, i13.CustomQuestionnaireComponent, i9.NgClass, i14.MatTable, i14.MatColumnDef, i14.MatCellDef, i14.MatHeaderRowDef, i14.MatRowDef, i14.MatHeaderCellDef, i14.MatHeaderCell, i14.MatCell, i15.MatIcon, i16.MatTooltip, i17.FileDownloadLibraryComponent, i14.MatHeaderRow, i14.MatRow, i18.MatDivider, i19.Dropdown, i8.RequiredValidator, i8.PatternValidator, i20.MatHint, i20.MatError, i20.MatFormField, i21.MatInput, i22.MatDatepickerInput, i22.MatDatepickerToggle, i20.MatSuffix, i22.MatDatepicker, i8.FormGroupDirective, i8.FormArrayName, i8.FormControlName, i8.FormGroupName, i8.MaxLengthValidator, i23.Calendar, i24.FileUploadDeafultLibraryComponent], pipes: [ImgDateFormatPipe], styles: [".immigrationContainer .immigration-list-table{margin-bottom:0;font-family:Source Sans Pro}.immigrationContainer .immigration-list-table thead th{color:#a4a7b5;border-bottom:none;border-top:none;vertical-align:middle!important;font-size:14px;line-height:18px;font-weight:700;color:#4d4f5c;padding:4px 14px 0!important;border-right:1px solid #e1e1e1}.immigrationContainer .immigration-list-table tbody{border-left:1px solid #e1e1e1}.immigrationContainer .immigration-list-table tbody tr{border-right:1px solid #e1e1e1;border-bottom:1px solid #e1e1e1!important}.immigrationContainer .immigration-list-table tbody tr .mat-cell:not(.empty-cell){border-left:1px solid #e1e1e1;font-size:14px;line-height:20px;color:#4d4f5c;padding:14px 0 0 14px!important;word-break:break-word}.immigrationContainer .immigration-list-table tbody tr .mat-cell:not(.empty-cell).inner-table-with-nopadding{padding:0!important}.immigrationContainer .immigration-list-table tbody tr .mat-cell:not(.empty-cell) span{width:100%;display:inline-block;padding-right:9px;word-break:break-word;margin-bottom:14px}.immigrationContainer .immigration-list-table tbody tr .mat-cell:not(.empty-cell):last-child span{border:none}.immigrationContainer .immigration-list-table tbody tr .mat-cell:not(.empty-cell).mat-column-fileLocation{text-align:center}.immigrationContainer .example-radio-group{display:flex;flex-direction:row;margin:15px 0}.immigrationContainer .example-radio-group.has-immigration{margin:0}.immigrationContainer .example-radio-button{margin:5px}.immigrationContainer .beneficiary-workexp-clients-box{width:100%}.immigrationContainer .beneficiary-workexp-clients-box .client-name{width:40vw}.immigrationContainer .beneficiary-workexp-clients-box .dynamic-client-controlgroup{margin-bottom:10px}.immigrationContainer .beneficiary-workexp-clients-box .flex-row{display:flex;flex-direction:row;justify-content:flex-start;align-items:stretch}.immigrationContainer .beneficiary-workexp-clients-box .flex-vertical{display:flex;font-size:14px;flex-direction:column;padding-right:1.25em}.immigrationContainer .beneficiary-workexp-clients-box .action-group{display:inline-flex;flex-direction:row;justify-content:space-around;align-items:center;margin-top:.2em}.immigrationContainer .beneficiary-workexp-clients-box .action-group .btn{color:#fff;background-color:green;line-height:1.2;height:34px}.immigrationContainer .beneficiary-workexp-clients-box .action-group .add_circle{font-size:24px;margin-left:4px;color:grey;cursor:pointer}.immigrationContainer .beneficiary-workexp-clients-box .action-group .add_circle:hover{color:green}.immigrationContainer .beneficiary-workexp-clients-box .client-display-box{padding:0}.immigrationContainer .beneficiary-workexp-clients-box .client-display-box .mat-subheader-clients-added{font-size:20px;font-weight:700}.immigrationContainer .beneficiary-workexp-clients-box mat-list-item{border:1px solid #dadada;width:70%}.immigrationContainer .beneficiary-workexp-clients-box .clients-list-item-partition{margin-right:5px;width:25%}.immigrationContainer .beneficiary-workexp-clients-box .numberCircle{border-radius:50%;width:36px;height:36px;padding:5px;background:#b5d8ff;border:2px solid #666;color:#676868;text-align:center;font-size:22px Arial,sans-serif}.immigrationContainer .beneficiary-workexp-clients-box .evenBg{background-color:#f5f5f5}.immigrationContainer .beneficiary-workexp-clients-box .border-top-radius{border-top-left-radius:.6em;border-top-right-radius:.6em}.immigrationContainer .beneficiary-workexp-clients-box .border-bottom-radius{border-bottom-left-radius:.6em;border-bottom-right-radius:.6em}.immigrationContainer .beneficiary-workexp-clients-box .delete-client-entry{cursor:pointer}.immigrationContainer .beneficiary-workexp-clients-box .delete-client-entry:active,.immigrationContainer .beneficiary-workexp-clients-box .delete-client-entry:hover{color:red}.immigrationContainer .beneficiary-workexp-clients-box .alert-message,.immigrationContainer .beneficiary-workexp-clients-box .error-validation{font-size:12px;color:red}.immigrationContainer .beneficiary-workexp-clients-box .error-validation{padding-left:1.2em}.immigrationContainer table{width:100%}.immigrationContainer tr.example-detail-row{height:0}.immigrationContainer tr.example-element-row:not(.example-expanded-row):hover{background:#f5f5f5}.immigrationContainer tr.example-element-row:not(.example-expanded-row):active{background:#efefef}.immigrationContainer .example-element-row td{border-bottom-width:0}.immigrationContainer .example-element-detail{overflow:hidden}.immigrationContainer .example-element-diagram{min-width:80px;border:2px solid #000;padding:8px;font-weight:lighter;margin:8px 0;height:104px}.immigrationContainer .example-element-symbol{font-weight:700;font-size:40px;line-height:normal}.immigrationContainer .example-element-description{padding:16px}.immigrationContainer .example-element-description li:nth-child(odd){background:#d3d3d3}.immigrationContainer .bgGray{background-color:#d3d3d3!important}.immigrationContainer .circleIndex{width:20px;height:20px;background-color:#8ecdd6;text-align:center}.immigrationContainer .w40{width:40px!important}.immigrationContainer .w200{width:200px!important}.immigrationContainer .mat-form-field{font-size:14px;width:100%}.immigrationContainer .icn{cursor:pointer}.immigrationContainer .spacing{margin:10px 0}.immigrationContainer .f10{font-size:12px;color:#afaaaa}.immigrationContainer .dasheedTopBorder{border-top:1px dashed grey}.immigrationContainer .paddingTop10{padding-top:10px}.immigrationContainer .mTop10{margin-top:10px!important}.immigrationContainer .formBox{margin-top:10px!important;border-top:1px solid grey}.immigrationContainer .w100{width:100%!important}.immigrationContainer .title-steps{margin:10px 0;font-weight:700}.immigrationContainer .mLeft{margin-left:2rem!important}.immigrationContainer .borderRight{border-right:1px dashed grey}.immigrationContainer .iconPosition{position:relative;top:5px}.immigrationContainer .mRight15{margin-right:15px!important}.immigrationContainer .viewType>.childBtn:not(.firstBtn){border-radius:0 30px 30px 0!important}.immigrationContainer .viewType>.childBtn:not(.lastBtn){border-radius:30px 0 0 30px!important}.immigrationContainer .viewType>.childBtn.firstBtn{border-right:.75px solid grey!important;border-left:none!important}.immigrationContainer .viewType>.childBtn.lastBtn{border-right:none!important;border-left:.75px solid grey!important}.immigrationContainer .aligncenter{text-align:center;margin-top:10px}.immigrationContainer .dtpickr-outline{display:flex;flex-direction:row;border:1px solid grey;border-radius:4px;height:40px}.disabledView{pointer-events:none}button.add-visa-details,button.add-visa-details:active,button.add-visa-details:hover{background:transparent!important;border-color:#022e83!important;color:#022e83!important;padding:0 10px;text-transform:uppercase;border-radius:4px;height:40px;font-weight:400}.add-visa-details-form-container{border:1px solid grey;border-radius:2px}.label-help-text{color:#b7b7b7;font-size:12px}.table-section{background-color:#e4eaea;width:100%;font-size:16px;color:#222;font-weight:600;padding:15px 20px;margin:20px 0}table{width:100%;border:1px solid #ddd}.inner-heading{color:#475f7d;font-size:20px;font-weight:500}.no-record{width:100%;border:1px solid #ddd;border-top:0 solid #ddd;color:#fa5f55;text-align:center;padding:15px}.mat-table .mat-header-row{height:45px}.mat-header-cell{color:#333;font-size:16px;font-weight:600}.fa{font-size:16px;margin:0 6px;cursor:pointer}.p-dropdown .p-dropdown-label{width:160px}.us-stay-hisroty-table td{padding:24px 10px!important;vertical-align:top}.mat-tab-list{background-color:#eee}.iterative-column .other-reason{height:40px;vertical-align:middle}.iterative-column .other-reason span{display:inline-block}.add-more-button,.add-more-button:active,.add-more-button:hover{background:transparent!important;border:none;padding:0!important;font-size:12px!important;color:#18a0da!important;text-transform:capitalize}.cdk-cell .p-form-datepicker .p-inputtext{min-width:105px}.cdk-cell .p-form-datepicker .p-inputtext .p-datepicker-trigger{height:40px!important;top:0!important}.cdk-cell.cdk-column-i94Number .im-input{min-width:100px}.cdk-cell.cdk-column-otherReason .mat-input-element{min-width:200px}.immDatePicker .p-datepicker-trigger{height:40px!important;top:0!important}.noVisa{background-color:#0eb70e;color:#fff;padding:8px 20px;font-size:14px!important;border-radius:20px}.immigrantSave{border-top:1px solid #ccc}.addDetails{display:flex;justify-content:flex-end;align-items:center}.addDetails label{color:red}.closeIcon{cursor:pointer}.closeIcon,.closeIcon i{display:flex;justify-content:flex-end;align-items:center}.closeIcon i{font-size:10px;background-color:#2c2a2a;color:#fff;border-radius:10px;padding:4px;position:absolute;top:15px;right:25px;z-index:3}.addVisaHead{font-weight:600;font-size:18px!important}.notAllowed{pointer-events:none;opacity:.6}.notAllowedDiv{cursor:not-allowed}.usStayHistory{overflow:auto;scrollbar-width:thin}.usStayHistory :host ::ng-deep .p-button .p-button-icon-only{height:40px;font-size:20px;top:0}.addMore{background-color:#fff!important;color:#158fc4!important;border:1px solid #158fc4!important}.minWidth{min-width:150px!important}.minWidthCus{min-width:100px!important}.minWidthCus1{min-width:180px!important}"], encapsulation: 2, data: { animation: [
            trigger('detailExpand', [
                state('collapsed', style({ height: '0px', minHeight: '0' })),
                state('expanded', style({ height: '*' })),
                transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
            ]),
        ] } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GenericBeneficiaryImmigrationDetailsLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'lib-generic-beneficiary-immigration-details-library',
                templateUrl: `./generic-beneficiary-immigration-details-library.component.html`,
                styleUrls: ['./generic-beneficiary-immigration-details-library.component.scss'],
                encapsulation: ViewEncapsulation.None,
                animations: [
                    trigger('detailExpand', [
                        state('collapsed', style({ height: '0px', minHeight: '0' })),
                        state('expanded', style({ height: '*' })),
                        transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
                    ]),
                ],
            }]
    }], function () { return [{ type: i1$2.CacheCountryListService }, { type: i0.ChangeDetectorRef }, { type: i2$2.ReferenceLibraryService }, { type: GenericBeneficiaryImmigrationDetailsLibraryService }, { type: i4.ToastrService }, { type: i1$1.MatDialog }, { type: i6.ActivatedRoute }, { type: i2$1.Store }, { type: i8.FormBuilder }]; }, { mode: [{
            type: Input
        }], showLifeStoryTimeLineSection: [{
            type: Input
        }], caseRequestShowDivs: [{
            type: Input
        }], benQuestShowDivs: [{
            type: Input
        }], isViewMode: [{
            type: Input
        }], isWizard: [{
            type: Input
        }], type: [{
            type: Input
        }], userId: [{
            type: Input
        }], immvisaDetailsForm: [{
            type: ViewChild,
            args: ['visaDetailsForm', { static: true }]
        }], immgFields: [{
            type: ViewChildren,
            args: [NgModel]
        }], paginator: [{
            type: ViewChild,
            args: [MatPaginator, { static: true }]
        }], customQuestionsComponent: [{
            type: ViewChild,
            args: [CustomQuestionnaireComponent]
        }], inputData: [{
            type: Input
        }] }); })();

const routes = [
    {
        path: '',
        component: GenericBeneficiaryImmigrationDetailsLibraryComponent
    }
];
class GenericBeneficiaryImmigrationDetailsLibraryModule {
}
GenericBeneficiaryImmigrationDetailsLibraryModule.ɵfac = function GenericBeneficiaryImmigrationDetailsLibraryModule_Factory(t) { return new (t || GenericBeneficiaryImmigrationDetailsLibraryModule)(); };
GenericBeneficiaryImmigrationDetailsLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: GenericBeneficiaryImmigrationDetailsLibraryModule });
GenericBeneficiaryImmigrationDetailsLibraryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            StepStatusUpdateComponentLibraryModule,
            NotificationComponentLibraryModule,
            SendBackComponentLibraryModule,
            DeleteDialogLibraryModule,
            FileUploadLibraryModule,
            LastUpdateLibraryModule,
            AssigningTaskLibraryModule,
            MaximizeDialogLibraryModule,
            MatRadioModule,
            FileUploadDeafultLibraryModule,
            FileDownloadLibraryModule,
            MatSidenavModule,
            MatListModule,
            MatExpansionModule,
            MatFormFieldModule,
            MatInputModule,
            MatDividerModule,
            MatCardModule,
            MatCheckboxModule,
            MatDatepickerModule,
            MatMomentDateModule,
            MatNativeDateModule,
            MatStepperModule,
            MatSlideToggleModule,
            MatSelectModule,
            CommonModule,
            ReactiveFormsModule,
            MatIconModule,
            MatTabsModule,
            MatSlideToggleModule,
            MatPaginatorModule,
            MatTableModule,
            FormsModule,
            NgbModule,
            MatTooltipModule,
            MatChipsModule,
            SaveAsDraftModule,
            CustomQuestionnaireModule,
            RouterModule.forChild(routes)
        ], RouterModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(GenericBeneficiaryImmigrationDetailsLibraryModule, { declarations: [GenericBeneficiaryImmigrationDetailsLibraryComponent,
        ImgDateFormatPipe], imports: [PrimengLibraryModule,
        StepStatusUpdateComponentLibraryModule,
        NotificationComponentLibraryModule,
        SendBackComponentLibraryModule,
        DeleteDialogLibraryModule,
        FileUploadLibraryModule,
        LastUpdateLibraryModule,
        AssigningTaskLibraryModule,
        MaximizeDialogLibraryModule,
        MatRadioModule,
        FileUploadDeafultLibraryModule,
        FileDownloadLibraryModule,
        MatSidenavModule,
        MatListModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatInputModule,
        MatDividerModule,
        MatCardModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatMomentDateModule,
        MatNativeDateModule,
        MatStepperModule,
        MatSlideToggleModule,
        MatSelectModule,
        CommonModule,
        ReactiveFormsModule,
        MatIconModule,
        MatTabsModule,
        MatSlideToggleModule,
        MatPaginatorModule,
        MatTableModule,
        FormsModule,
        NgbModule,
        MatTooltipModule,
        MatChipsModule,
        SaveAsDraftModule,
        CustomQuestionnaireModule, i6.RouterModule], exports: [GenericBeneficiaryImmigrationDetailsLibraryComponent,
        RouterModule] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GenericBeneficiaryImmigrationDetailsLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    GenericBeneficiaryImmigrationDetailsLibraryComponent,
                    ImgDateFormatPipe
                ],
                imports: [
                    PrimengLibraryModule,
                    StepStatusUpdateComponentLibraryModule,
                    NotificationComponentLibraryModule,
                    SendBackComponentLibraryModule,
                    DeleteDialogLibraryModule,
                    FileUploadLibraryModule,
                    LastUpdateLibraryModule,
                    AssigningTaskLibraryModule,
                    MaximizeDialogLibraryModule,
                    MatRadioModule,
                    FileUploadDeafultLibraryModule,
                    FileDownloadLibraryModule,
                    MatSidenavModule,
                    MatListModule,
                    MatExpansionModule,
                    MatFormFieldModule,
                    MatInputModule,
                    MatDividerModule,
                    MatCardModule,
                    MatCheckboxModule,
                    MatDatepickerModule,
                    MatMomentDateModule,
                    MatNativeDateModule,
                    MatStepperModule,
                    MatSlideToggleModule,
                    MatSelectModule,
                    CommonModule,
                    ReactiveFormsModule,
                    MatIconModule,
                    MatTabsModule,
                    MatSlideToggleModule,
                    MatPaginatorModule,
                    MatTableModule,
                    FormsModule,
                    NgbModule,
                    MatTooltipModule,
                    MatChipsModule,
                    SaveAsDraftModule,
                    CustomQuestionnaireModule,
                    RouterModule.forChild(routes)
                ],
                exports: [
                    GenericBeneficiaryImmigrationDetailsLibraryComponent,
                    RouterModule
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of generic-beneficiary-immigration-details-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GenericBeneficiaryImmigrationDetailsLibraryComponent, GenericBeneficiaryImmigrationDetailsLibraryModule, GenericBeneficiaryImmigrationDetailsLibraryService };
//# sourceMappingURL=generic-beneficiary-immigration-details-library.js.map
